// Generated by scripts/generate-questions.ts. Do not edit by hand.
// Edit the questions table in Postgres, then run `npm run generate:questions`.
import type { Question } from "./types";

export const generatedQuestions: readonly Question[] = [
  {
    id: "daily-northern-ireland-census-population-2021",
    category: "population",
    measure: "population",
    subtype: "country",
    prompt: "What was Northern Ireland's population in the 2021 census?",
    answer: 1903175,
    min: 40000,
    max: 3000000,
    scale: "log",
    unit: "people",
    referenceYear: "2021",
    source: {
      title: "Northern Ireland Statistics and Research Agency - Census 2021",
      url: "https://www.nisra.gov.uk/statistics/census/census-2021",
    },
    explanation: "Northern Ireland's 2021 census recorded a population of 1,903,175 people.",
  },
  {
    id: "daily-scotland-census-population-2022",
    category: "population",
    measure: "population",
    subtype: "country",
    prompt: "What was Scotland's population in the 2022 census?",
    answer: 5439842,
    min: 150000,
    max: 12000000,
    scale: "log",
    unit: "people",
    referenceYear: "2022",
    source: {
      title: "Scotland's Census - Unrounded Population Estimates",
      url: "https://www.scotlandscensus.gov.uk/2022-reports/scotlands-census-2022-quality-assurance-reports/quality-assurance-report-unrounded-population-estimates-and-ethnic-group-national-identity-language-and-religion-topic-data/",
    },
    explanation: "Scotland's 2022 census recorded a population of 5,439,842 people, its largest census total on record.",
  },
  {
    id: "pop-bangladesh-2026",
    category: "population",
    measure: "population",
    subtype: "country",
    prompt: "What is the estimated population of Bangladesh in 2026?",
    answer: 177818044,
    min: 40000000,
    max: 400000000,
    scale: "linear",
    unit: "people",
    referenceYear: "2026",
    source: {
      title: "Worldometer — Countries in the world by population (2026), from UN World Population Prospects 2024 revision",
      url: "https://www.worldometers.info/world-population/population-by-country/",
    },
    explanation: "Bangladesh fits more people than Russia into an area smaller than England and Scotland combined, and only 43% of them live in cities.",
  },
  {
    id: "pop-canada-2026",
    category: "population",
    measure: "population",
    subtype: "country",
    prompt: "What is the estimated population of Canada in 2026?",
    answer: 40467728,
    min: 12000000,
    max: 90000000,
    scale: "linear",
    unit: "people",
    referenceYear: "2026",
    source: {
      title: "Worldometer — Countries in the world by population (2026), from UN World Population Prospects 2024 revision",
      url: "https://www.worldometers.info/world-population/population-by-country/",
    },
    explanation: "With fertility at 1.33, essentially all of Canada's growth comes from net migration of around 291,000 a year — one of the highest per-capita intakes in the world.",
  },
  {
    id: "pop-chile-2026",
    category: "population",
    measure: "population",
    subtype: "country",
    prompt: "What is the estimated population of Chile in 2026?",
    answer: 19945850,
    min: 5000000,
    max: 45000000,
    scale: "linear",
    unit: "people",
    referenceYear: "2026",
    source: {
      title: "Worldometer — Countries in the world by population (2026), from UN World Population Prospects 2024 revision",
      url: "https://www.worldometers.info/world-population/population-by-country/",
    },
    explanation: "Chile stretches 4,300 km down the continent but averages 27 people per square kilometre, with almost everyone concentrated in the central valley around Santiago.",
  },
  {
    id: "pop-colombia-2026",
    category: "population",
    measure: "population",
    subtype: "country",
    prompt: "What is the estimated population of Colombia in 2026?",
    answer: 53936226,
    min: 15000000,
    max: 120000000,
    scale: "linear",
    unit: "people",
    referenceYear: "2026",
    source: {
      title: "Worldometer — Countries in the world by population (2026), from UN World Population Prospects 2024 revision",
      url: "https://www.worldometers.info/world-population/population-by-country/",
    },
    explanation: "Colombia is over 80% urban with fertility down to 1.6, so its 0.96% growth leans heavily on net migration of about 116,000 a year.",
  },
  {
    id: "pop-dr-congo-2026",
    category: "population",
    measure: "population",
    subtype: "country",
    prompt: "What is the estimated population of DR Congo in 2026?",
    answer: 116452162,
    min: 25000000,
    max: 260000000,
    scale: "linear",
    unit: "people",
    referenceYear: "2026",
    source: {
      title: "Worldometer — Countries in the world by population (2026), from UN World Population Prospects 2024 revision",
      url: "https://www.worldometers.info/world-population/population-by-country/",
    },
    explanation: "At 5.8 children per woman, DR Congo is adding 3.6 million people a year — roughly a Croatia every year — and is projected to become one of the world's largest countries this century.",
  },
  {
    id: "pop-egypt-2026",
    category: "population",
    measure: "population",
    subtype: "country",
    prompt: "What is the estimated population of Egypt in 2026?",
    answer: 120101175,
    min: 30000000,
    max: 220000000,
    scale: "linear",
    unit: "people",
    referenceYear: "2026",
    source: {
      title: "Worldometer — Countries in the world by population (2026), from UN World Population Prospects 2024 revision",
      url: "https://www.worldometers.info/world-population/population-by-country/",
    },
    explanation: "Egypt's nominal density looks modest at 121 per square kilometre, but that averages across the Sahara — the habitable strip along the river is among the most crowded land on Earth.",
  },
  {
    id: "pop-germany-2026",
    category: "population",
    measure: "population",
    subtype: "country",
    prompt: "What is the estimated population of Germany in 2026?",
    answer: 83644258,
    min: 45000000,
    max: 110000000,
    scale: "linear",
    unit: "people",
    referenceYear: "2026",
    source: {
      title: "Worldometer — Countries in the world by population (2026), from UN World Population Prospects 2024 revision",
      url: "https://www.worldometers.info/world-population/population-by-country/",
    },
    explanation: "Germany's median age of 45.7 means deaths now outpace births by a wide margin. It remains the EU's largest country by a considerable distance despite the decline.",
  },
  {
    id: "pop-india-2026",
    category: "population",
    measure: "population",
    subtype: "country",
    prompt: "What is the estimated population of India in 2026?",
    answer: 1476625576,
    min: 300000000,
    max: 3000000000,
    scale: "linear",
    unit: "people",
    referenceYear: "2026",
    source: {
      title: "Worldometer — Countries in the world by population (2026), from UN World Population Prospects 2024 revision",
      url: "https://www.worldometers.info/world-population/population-by-country/",
    },
    explanation: "India's fertility rate is now around 1.93, under the 2.1 needed to hold steady. It keeps growing only because its median age is 29 — decades of past births still working through the system.",
  },
  {
    id: "pop-japan-2026",
    category: "population",
    measure: "population",
    subtype: "country",
    prompt: "What is the estimated population of Japan in 2026?",
    answer: 122427731,
    min: 60000000,
    max: 260000000,
    scale: "linear",
    unit: "people",
    referenceYear: "2026",
    source: {
      title: "Worldometer — Countries in the world by population (2026), from UN World Population Prospects 2024 revision",
      url: "https://www.worldometers.info/world-population/population-by-country/",
    },
    explanation: "Japan is losing around 675,000 people a year even while gaining 128,000 through migration — deaths outnumber births by a margin no realistic immigration policy could close.",
  },
  {
    id: "pop-new-zealand-2026",
    category: "population",
    measure: "population",
    subtype: "country",
    prompt: "What is the estimated population of New Zealand in 2026?",
    answer: 5287479,
    min: 1500000,
    max: 12000000,
    scale: "linear",
    unit: "people",
    referenceYear: "2026",
    source: {
      title: "Worldometer — Countries in the world by population (2026), from UN World Population Prospects 2024 revision",
      url: "https://www.worldometers.info/world-population/population-by-country/",
    },
    explanation: "New Zealand crossed five million only recently, and with fertility at 1.64 its 0.68% growth depends on net migration of around 16,000 a year.",
  },
  {
    id: "pop-pakistan-2026",
    category: "population",
    measure: "population",
    subtype: "country",
    prompt: "What is the estimated population of Pakistan in 2026?",
    answer: 259299791,
    min: 60000000,
    max: 600000000,
    scale: "linear",
    unit: "people",
    referenceYear: "2026",
    source: {
      title: "Worldometer — Countries in the world by population (2026), from UN World Population Prospects 2024 revision",
      url: "https://www.worldometers.info/world-population/population-by-country/",
    },
    explanation: "At 3.44 children per woman and a median age under 21, Pakistan adds around four million people annually even after net emigration of over a million.",
  },
  {
    id: "pop-poland-2026",
    category: "population",
    measure: "population",
    subtype: "country",
    prompt: "What is the estimated population of Poland in 2026?",
    answer: 37843188,
    min: 15000000,
    max: 90000000,
    scale: "linear",
    unit: "people",
    referenceYear: "2026",
    source: {
      title: "Worldometer — Countries in the world by population (2026), from UN World Population Prospects 2024 revision",
      url: "https://www.worldometers.info/world-population/population-by-country/",
    },
    explanation: "Poland combines a fertility rate of 1.31 with net emigration, giving a decline of 0.78% a year — steeper than Japan's. Only 60% of the country lives in cities.",
  },
  {
    id: "pop-singapore-2026",
    category: "population",
    measure: "population",
    subtype: "country",
    prompt: "What is the estimated population of Singapore in 2026?",
    answer: 5905748,
    min: 2000000,
    max: 9000000,
    scale: "linear",
    unit: "people",
    referenceYear: "2026",
    source: {
      title: "Worldometer — Countries in the world by population (2026), from UN World Population Prospects 2024 revision",
      url: "https://www.worldometers.info/world-population/population-by-country/",
    },
    explanation: "Singapore's fertility rate of 0.97 is among the world's lowest, so its continued growth of 0.6% a year comes entirely from immigration.",
  },
  {
    id: "pop-tanzania-2026",
    category: "population",
    measure: "population",
    subtype: "country",
    prompt: "What is the estimated population of Tanzania in 2026?",
    answer: 72563780,
    min: 15000000,
    max: 160000000,
    scale: "linear",
    unit: "people",
    referenceYear: "2026",
    source: {
      title: "Worldometer — Countries in the world by population (2026), from UN World Population Prospects 2024 revision",
      url: "https://www.worldometers.info/world-population/population-by-country/",
    },
    explanation: "At 4.41 children per woman and only 41% urban, Tanzania adds around two million people a year — more than Thailand, Italy and Japan lose between them.",
  },
  {
    id: "pop-vietnam-2026",
    category: "population",
    measure: "population",
    subtype: "country",
    prompt: "What is the estimated population of Vietnam in 2026?",
    answer: 102177431,
    min: 40000000,
    max: 130000000,
    scale: "linear",
    unit: "people",
    referenceYear: "2026",
    source: {
      title: "Worldometer — Countries in the world by population (2026), from UN World Population Prospects 2024 revision",
      url: "https://www.worldometers.info/world-population/population-by-country/",
    },
    explanation: "Vietnam crossed 100 million recently, but its fertility rate of 1.86 is already below replacement and growth has slowed to 0.57% a year.",
  },
  {
    id: "population-country-bangladesh-2024",
    category: "population",
    measure: "population",
    subtype: "country",
    prompt: "What was the estimated population of Bangladesh in 2024?",
    answer: 173562364,
    min: 1000000,
    max: 1600000000,
    scale: "log",
    unit: "people",
    referenceYear: "2024 midyear estimate",
    source: {
      title: "UN DESA — World Population Prospects 2024",
      url: "https://population.un.org/wpp/",
    },
    explanation: "The 2024 midyear estimate was about 173.6 million people across Bangladesh as a whole.",
  },
  {
    id: "population-country-brazil-2024",
    category: "population",
    measure: "population",
    subtype: "country",
    prompt: "What was the estimated population of Brazil in 2024?",
    answer: 211998573,
    min: 1000000,
    max: 1600000000,
    scale: "log",
    unit: "people",
    referenceYear: "2024 midyear estimate",
    source: {
      title: "UN DESA — World Population Prospects 2024",
      url: "https://population.un.org/wpp/",
    },
    explanation: "The 2024 midyear estimate was about 212.0 million people across Brazil as a whole.",
  },
  {
    id: "population-country-china-2024",
    category: "population",
    measure: "population",
    subtype: "country",
    prompt: "What was the estimated population of China in 2024?",
    answer: 1419321278,
    min: 1000000,
    max: 1600000000,
    scale: "log",
    unit: "people",
    referenceYear: "2024 midyear estimate",
    source: {
      title: "UN DESA — World Population Prospects 2024",
      url: "https://population.un.org/wpp/",
    },
    explanation: "The 2024 midyear estimate was about 1.419 billion people in China's national population series.",
  },
  {
    id: "population-country-dr-congo-2024",
    category: "population",
    measure: "population",
    subtype: "country",
    prompt: "What was the estimated population of the Democratic Republic of the Congo in 2024?",
    answer: 109276265,
    min: 1000000,
    max: 1600000000,
    scale: "log",
    unit: "people",
    referenceYear: "2024 midyear estimate",
    source: {
      title: "UN DESA — World Population Prospects 2024",
      url: "https://population.un.org/wpp/",
    },
    explanation: "The 2024 midyear estimate was about 109.3 million people across the DRC as a whole.",
  },
  {
    id: "population-country-egypt-2024",
    category: "population",
    measure: "population",
    subtype: "country",
    prompt: "What was the estimated population of Egypt in 2024?",
    answer: 116538258,
    min: 1000000,
    max: 1600000000,
    scale: "log",
    unit: "people",
    referenceYear: "2024 midyear estimate",
    source: {
      title: "UN DESA — World Population Prospects 2024",
      url: "https://population.un.org/wpp/",
    },
    explanation: "The 2024 midyear estimate was about 116.5 million people across Egypt as a whole.",
  },
  {
    id: "population-country-ethiopia-2024",
    category: "population",
    measure: "population",
    subtype: "country",
    prompt: "What was the estimated population of Ethiopia in 2024?",
    answer: 132059768,
    min: 1000000,
    max: 1600000000,
    scale: "log",
    unit: "people",
    referenceYear: "2024 midyear estimate",
    source: {
      title: "UN DESA — World Population Prospects 2024",
      url: "https://population.un.org/wpp/",
    },
    explanation: "The 2024 midyear estimate was about 132.1 million people across Ethiopia as a whole.",
  },
  {
    id: "population-country-india-2024",
    category: "population",
    measure: "population",
    subtype: "country",
    prompt: "What was the estimated population of India in 2024?",
    answer: 1450935791,
    min: 1000000,
    max: 1600000000,
    scale: "log",
    unit: "people",
    referenceYear: "2024 midyear estimate",
    source: {
      title: "UN DESA — World Population Prospects 2024",
      url: "https://population.un.org/wpp/",
    },
    explanation: "The 2024 midyear estimate was about 1.451 billion people across India as a whole.",
  },
  {
    id: "population-country-indonesia-2024",
    category: "population",
    measure: "population",
    subtype: "country",
    prompt: "What was the estimated population of Indonesia in 2024?",
    answer: 283487931,
    min: 1000000,
    max: 1600000000,
    scale: "log",
    unit: "people",
    referenceYear: "2024 midyear estimate",
    source: {
      title: "UN DESA — World Population Prospects 2024",
      url: "https://population.un.org/wpp/",
    },
    explanation: "The 2024 midyear estimate was about 283.5 million people across the Indonesian archipelago.",
  },
  {
    id: "population-country-japan-2024",
    category: "population",
    measure: "population",
    subtype: "country",
    prompt: "What was the estimated population of Japan in 2024?",
    answer: 123753041,
    min: 1000000,
    max: 1600000000,
    scale: "log",
    unit: "people",
    referenceYear: "2024 midyear estimate",
    source: {
      title: "UN DESA — World Population Prospects 2024",
      url: "https://population.un.org/wpp/",
    },
    explanation: "The 2024 midyear estimate was about 123.8 million people across Japan as a whole.",
  },
  {
    id: "population-country-mexico-2024",
    category: "population",
    measure: "population",
    subtype: "country",
    prompt: "What was the estimated population of Mexico in 2024?",
    answer: 130861007,
    min: 1000000,
    max: 1600000000,
    scale: "log",
    unit: "people",
    referenceYear: "2024 midyear estimate",
    source: {
      title: "UN DESA — World Population Prospects 2024",
      url: "https://population.un.org/wpp/",
    },
    explanation: "The 2024 midyear estimate was about 130.9 million people across Mexico as a whole.",
  },
  {
    id: "population-country-nigeria-2024",
    category: "population",
    measure: "population",
    subtype: "country",
    prompt: "What was the estimated population of Nigeria in 2024?",
    answer: 232679478,
    min: 1000000,
    max: 1600000000,
    scale: "log",
    unit: "people",
    referenceYear: "2024 midyear estimate",
    source: {
      title: "UN DESA — World Population Prospects 2024",
      url: "https://population.un.org/wpp/",
    },
    explanation: "The 2024 midyear estimate was about 232.7 million people across Nigeria as a whole.",
  },
  {
    id: "population-country-pakistan-2024",
    category: "population",
    measure: "population",
    subtype: "country",
    prompt: "What was the estimated population of Pakistan in 2024?",
    answer: 251269164,
    min: 1000000,
    max: 1600000000,
    scale: "log",
    unit: "people",
    referenceYear: "2024 midyear estimate",
    source: {
      title: "UN DESA — World Population Prospects 2024",
      url: "https://population.un.org/wpp/",
    },
    explanation: "The 2024 midyear estimate was about 251.3 million people across Pakistan as a whole.",
  },
  {
    id: "population-country-philippines-2024",
    category: "population",
    measure: "population",
    subtype: "country",
    prompt: "What was the estimated population of the Philippines in 2024?",
    answer: 115843670,
    min: 1000000,
    max: 1600000000,
    scale: "log",
    unit: "people",
    referenceYear: "2024 midyear estimate",
    source: {
      title: "UN DESA — World Population Prospects 2024",
      url: "https://population.un.org/wpp/",
    },
    explanation: "The 2024 midyear estimate was about 115.8 million people across the Philippines as a whole.",
  },
  {
    id: "population-country-russia-2024",
    category: "population",
    measure: "population",
    subtype: "country",
    prompt: "What was the estimated population of Russia in 2024?",
    answer: 144820423,
    min: 1000000,
    max: 1600000000,
    scale: "log",
    unit: "people",
    referenceYear: "2024 midyear estimate",
    source: {
      title: "UN DESA — World Population Prospects 2024",
      url: "https://population.un.org/wpp/",
    },
    explanation: "The 2024 midyear estimate was about 144.8 million people across the Russian Federation.",
  },
  {
    id: "population-country-united-states-2024",
    category: "population",
    measure: "population",
    subtype: "country",
    prompt: "What was the estimated population of the United States in 2024?",
    answer: 345426571,
    min: 1000000,
    max: 1600000000,
    scale: "log",
    unit: "people",
    referenceYear: "2024 midyear estimate",
    source: {
      title: "UN DESA — World Population Prospects 2024",
      url: "https://population.un.org/wpp/",
    },
    explanation: "The 2024 midyear estimate was about 345.4 million people for the United States as a whole.",
  },
  {
    id: "agg-bangkok-2025",
    category: "population",
    measure: "population",
    subtype: "city",
    prompt: "How many people lived in the Bangkok urban area in 2025?",
    answer: 18180280,
    min: 3000000,
    max: 45000000,
    scale: "linear",
    unit: "people",
    referenceYear: "2025",
    source: {
      title: "Worldometer — Largest Cities in the World (2025), from UN World Urbanization Prospects 2025 Revision",
      url: "https://www.worldometers.info/population/largest-cities-in-the-world/",
    },
    explanation: "Bangkok is still growing at 1% a year even though Thailand's national population is falling — one of the starkest urban-rural divergences anywhere.",
  },
  {
    id: "agg-buenos-aires-2025",
    category: "population",
    measure: "population",
    subtype: "city",
    prompt: "How many people lived in the Buenos Aires urban area in 2025?",
    answer: 14017736,
    min: 3000000,
    max: 40000000,
    scale: "linear",
    unit: "people",
    referenceYear: "2025",
    source: {
      title: "Worldometer — Largest Cities in the World (2025), from UN World Urbanization Prospects 2025 Revision",
      url: "https://www.worldometers.info/population/largest-cities-in-the-world/",
    },
    explanation: "Growing at just 0.11% a year, Buenos Aires is projected to add barely 200,000 people over the next 25 years. Argentina is 96.5% urban, among the highest anywhere.",
  },
  {
    id: "agg-cairo-2025",
    category: "population",
    measure: "population",
    subtype: "city",
    prompt: "How many people lived in the Cairo urban area in 2025?",
    answer: 25566102,
    min: 8000000,
    max: 35000000,
    scale: "linear",
    unit: "people",
    referenceYear: "2025",
    source: {
      title: "Worldometer — Largest Cities in the World (2025), from UN World Urbanization Prospects 2025 Revision",
      url: "https://www.worldometers.info/population/largest-cities-in-the-world/",
    },
    explanation: "Cairo squeezes its population into just 1,645 km², hemmed in by desert on both sides. Egypt has been building an entirely new administrative capital 45 km east partly to relieve it.",
  },
  {
    id: "agg-delhi-2025",
    category: "population",
    measure: "population",
    subtype: "city",
    prompt: "How many people lived in the Delhi urban area in 2025?",
    answer: 30222405,
    min: 12000000,
    max: 45000000,
    scale: "linear",
    unit: "people",
    referenceYear: "2025",
    source: {
      title: "Worldometer — Largest Cities in the World (2025), from UN World Urbanization Prospects 2025 Revision",
      url: "https://www.worldometers.info/population/largest-cities-in-the-world/",
    },
    explanation: "Delhi fits its population into 2,101 km², less than half Tokyo's footprint. The UN projects it will approach 34 million by 2050.",
  },
  {
    id: "agg-istanbul-2025",
    category: "population",
    measure: "population",
    subtype: "city",
    prompt: "How many people lived in the Istanbul urban area in 2025?",
    answer: 15014763,
    min: 3000000,
    max: 35000000,
    scale: "linear",
    unit: "people",
    referenceYear: "2025",
    source: {
      title: "Worldometer — Largest Cities in the World (2025), from UN World Urbanization Prospects 2025 Revision",
      url: "https://www.worldometers.info/population/largest-cities-in-the-world/",
    },
    explanation: "At nearly 12,000 people per square kilometre, Istanbul is roughly twice as dense as London and sits directly on the North Anatolian Fault.",
  },
  {
    id: "agg-jakarta-2025",
    category: "population",
    measure: "population",
    subtype: "city",
    prompt: "How many people lived in the Jakarta urban area in 2025?",
    answer: 41913860,
    min: 8000000,
    max: 70000000,
    scale: "linear",
    unit: "people",
    referenceYear: "2025",
    source: {
      title: "Worldometer — Largest Cities in the World (2025), from UN World Urbanization Prospects 2025 Revision",
      url: "https://www.worldometers.info/population/largest-cities-in-the-world/",
    },
    explanation: "Jakarta sprawls across 4,883 km² at over 8,500 people per square kilometre and is projected to reach nearly 52 million by 2050, despite parts of North Jakarta subsiding several centimetres a year.",
  },
  {
    id: "agg-karachi-2025",
    category: "population",
    measure: "population",
    subtype: "city",
    prompt: "How many people lived in the Karachi urban area in 2025?",
    answer: 21422590,
    min: 4000000,
    max: 50000000,
    scale: "linear",
    unit: "people",
    referenceYear: "2025",
    source: {
      title: "Worldometer — Largest Cities in the World (2025), from UN World Urbanization Prospects 2025 Revision",
      url: "https://www.worldometers.info/population/largest-cities-in-the-world/",
    },
    explanation: "Karachi's footprint is roughly a third of Delhi's but holds two-thirds as many people. Growing at nearly 2% a year, it's projected to pass 32 million by 2050.",
  },
  {
    id: "agg-lagos-2025",
    category: "population",
    measure: "population",
    subtype: "city",
    prompt: "How many people lived in the Lagos urban area in 2025?",
    answer: 12791699,
    min: 2000000,
    max: 35000000,
    scale: "linear",
    unit: "people",
    referenceYear: "2025",
    source: {
      title: "Worldometer — Largest Cities in the World (2025), from UN World Urbanization Prospects 2025 Revision",
      url: "https://www.worldometers.info/population/largest-cities-in-the-world/",
    },
    explanation: "Lagos is often quoted at 20 million or more; the UN's urban-area definition puts it lower. Either way it's growing at 1.23% a year on 1,231 km² of lagoon and reclaimed land.",
  },
  {
    id: "agg-luanda-2025",
    category: "population",
    measure: "population",
    subtype: "city",
    prompt: "How many people lived in the Luanda urban area in 2025?",
    answer: 11370127,
    min: 3000000,
    max: 16000000,
    scale: "linear",
    unit: "people",
    referenceYear: "2025",
    source: {
      title: "Worldometer — Largest Cities in the World (2025), from UN World Urbanization Prospects 2025 Revision",
      url: "https://www.worldometers.info/population/largest-cities-in-the-world/",
    },
    explanation: "Luanda is projected to reach over 20 million by 2050, which would make it larger than São Paulo is today. Angola's fertility rate of 4.89 is doing most of the work.",
  },
  {
    id: "agg-manila-2025",
    category: "population",
    measure: "population",
    subtype: "city",
    prompt: "How many people lived in the Manila urban area in 2025?",
    answer: 24735305,
    min: 6000000,
    max: 60000000,
    scale: "linear",
    unit: "people",
    referenceYear: "2025",
    source: {
      title: "Worldometer — Largest Cities in the World (2025), from UN World Urbanization Prospects 2025 Revision",
      url: "https://www.worldometers.info/population/largest-cities-in-the-world/",
    },
    explanation: "Metro Manila is a patchwork of 16 separate cities plus a municipality under one authority, at over 10,000 people per square kilometre.",
  },
  {
    id: "agg-mexico-city-2025",
    category: "population",
    measure: "population",
    subtype: "city",
    prompt: "How many people lived in the Mexico City urban area in 2025?",
    answer: 17734212,
    min: 6000000,
    max: 24000000,
    scale: "linear",
    unit: "people",
    referenceYear: "2025",
    source: {
      title: "Worldometer — Largest Cities in the World (2025), from UN World Urbanization Prospects 2025 Revision",
      url: "https://www.worldometers.info/population/largest-cities-in-the-world/",
    },
    explanation: "The UN projects Mexico City will be almost exactly the same size in 2050 as today — a rare case of a megacity flatlining rather than growing or shrinking.",
  },
  {
    id: "agg-new-york-2025",
    category: "population",
    measure: "population",
    subtype: "city",
    prompt: "How many people lived in the New York urban area in 2025?",
    answer: 13920148,
    min: 4000000,
    max: 32000000,
    scale: "linear",
    unit: "people",
    referenceYear: "2025",
    source: {
      title: "Worldometer — Largest Cities in the World (2025), from UN World Urbanization Prospects 2025 Revision",
      url: "https://www.worldometers.info/population/largest-cities-in-the-world/",
    },
    explanation: "New York's urban area covers 2,691 km², more than Delhi's, for less than half the people. It contracted 0.18% in the year to 2025.",
  },
  {
    id: "agg-paris-2025",
    category: "population",
    measure: "population",
    subtype: "city",
    prompt: "How many people lived in the Paris urban area in 2025?",
    answer: 9381921,
    min: 2000000,
    max: 28000000,
    scale: "linear",
    unit: "people",
    referenceYear: "2025",
    source: {
      title: "Worldometer — Largest Cities in the World (2025), from UN World Urbanization Prospects 2025 Revision",
      url: "https://www.worldometers.info/population/largest-cities-in-the-world/",
    },
    explanation: "The gap between the Paris urban area and the City of Paris is one of the widest in the world — the administrative commune holds barely a fifth of the people counted here.",
  },
  {
    id: "agg-sao-paulo-2025",
    category: "population",
    measure: "population",
    subtype: "city",
    prompt: "How many people lived in the São Paulo urban area in 2025?",
    answer: 18949790,
    min: 4000000,
    max: 40000000,
    scale: "linear",
    unit: "people",
    referenceYear: "2025",
    source: {
      title: "Worldometer — Largest Cities in the World (2025), from UN World Urbanization Prospects 2025 Revision",
      url: "https://www.worldometers.info/population/largest-cities-in-the-world/",
    },
    explanation: "Growth has slowed to 0.16% a year and Brazil's fertility rate is now 1.59, so the UN projects São Paulo will peak and then edge down to around 18.2 million by 2050.",
  },
  {
    id: "agg-seoul-2025",
    category: "population",
    measure: "population",
    subtype: "city",
    prompt: "How many people lived in the Seoul urban area in 2025?",
    answer: 22490482,
    min: 5000000,
    max: 45000000,
    scale: "linear",
    unit: "people",
    referenceYear: "2025",
    source: {
      title: "Worldometer — Largest Cities in the World (2025), from UN World Urbanization Prospects 2025 Revision",
      url: "https://www.worldometers.info/population/largest-cities-in-the-world/",
    },
    explanation: "Seoul grew 0.23% in the year to 2025 and is projected to shrink to 21.2 million by 2050, dragged down by the world's lowest fertility rate.",
  },
  {
    id: "agg-shanghai-2025",
    category: "population",
    measure: "population",
    subtype: "city",
    prompt: "How many people lived in the Shanghai urban area in 2025?",
    answer: 29558908,
    min: 6000000,
    max: 60000000,
    scale: "linear",
    unit: "people",
    referenceYear: "2025",
    source: {
      title: "Worldometer — Largest Cities in the World (2025), from UN World Urbanization Prospects 2025 Revision",
      url: "https://www.worldometers.info/population/largest-cities-in-the-world/",
    },
    explanation: "Shanghai is growing at 1.31% even as China's national population falls — internal migration is concentrating people into a handful of coastal cities.",
  },
  {
    id: "population-city-austin-2020",
    category: "population",
    measure: "population",
    subtype: "city",
    prompt: "What was Austin's population in the 2020 U.S. Census?",
    answer: 961855,
    min: 300000,
    max: 8000000,
    scale: "log",
    unit: "people",
    referenceYear: "2020 decennial census (city proper)",
    source: {
      title: "U.S. Census Bureau QuickFacts — Austin city, Texas",
      url: "https://www.census.gov/quickfacts/fact/table/austincitytexas/PST045225",
    },
    explanation: "The 2020 decennial census counted 961,855 residents inside Austin's legal city limits.",
  },
  {
    id: "population-city-charlotte-2020",
    category: "population",
    measure: "population",
    subtype: "city",
    prompt: "What was Charlotte's population in the 2020 U.S. Census?",
    answer: 874579,
    min: 300000,
    max: 8000000,
    scale: "log",
    unit: "people",
    referenceYear: "2020 decennial census (city proper)",
    source: {
      title: "U.S. Census Bureau QuickFacts — Charlotte city, North Carolina",
      url: "https://www.census.gov/quickfacts/fact/table/charlottecitynorthcarolina/PST045225",
    },
    explanation: "The 2020 decennial census counted 874,579 residents inside Charlotte's legal city limits.",
  },
  {
    id: "population-city-chicago-2020",
    category: "population",
    measure: "population",
    subtype: "city",
    prompt: "What was Chicago's population in the 2020 U.S. Census?",
    answer: 2746388,
    min: 100000,
    max: 10000000,
    scale: "log",
    unit: "people",
    referenceYear: "2020 decennial census (city proper)",
    source: {
      title: "U.S. Census Bureau QuickFacts — Chicago city, Illinois",
      url: "https://www.census.gov/quickfacts/fact/table/chicagocityillinois/PST045225",
    },
    explanation: "The 2020 decennial census counted 2,746,388 residents inside Chicago's legal city limits.",
  },
  {
    id: "population-city-columbus-2020",
    category: "population",
    measure: "population",
    subtype: "city",
    prompt: "What was Columbus, Ohio's population in the 2020 U.S. Census?",
    answer: 905748,
    min: 300000,
    max: 8000000,
    scale: "log",
    unit: "people",
    referenceYear: "2020 decennial census (city proper)",
    source: {
      title: "U.S. Census Bureau QuickFacts — Columbus city, Ohio",
      url: "https://www.census.gov/quickfacts/fact/table/columbuscityohio/PST045225",
    },
    explanation: "The 2020 decennial census counted 905,748 residents inside Columbus' legal city limits.",
  },
  {
    id: "population-city-dallas-2020",
    category: "population",
    measure: "population",
    subtype: "city",
    prompt: "What was Dallas' population in the 2020 U.S. Census?",
    answer: 1304379,
    min: 700000,
    max: 10000000,
    scale: "log",
    unit: "people",
    referenceYear: "2020 decennial census (city proper)",
    source: {
      title: "U.S. Census Bureau QuickFacts — Dallas city, Texas",
      url: "https://www.census.gov/quickfacts/fact/table/dallascitytexas/PST045225",
    },
    explanation: "The 2020 decennial census counted 1,304,379 residents inside Dallas' legal city limits.",
  },
  {
    id: "population-city-fort-worth-2020",
    category: "population",
    measure: "population",
    subtype: "city",
    prompt: "What was Fort Worth's population in the 2020 U.S. Census?",
    answer: 918915,
    min: 300000,
    max: 8000000,
    scale: "log",
    unit: "people",
    referenceYear: "2020 decennial census (city proper)",
    source: {
      title: "U.S. Census Bureau QuickFacts — Fort Worth city, Texas",
      url: "https://www.census.gov/quickfacts/fact/table/fortworthcitytexas/PST045225",
    },
    explanation: "The 2020 decennial census counted 918,915 residents inside Fort Worth's legal city limits.",
  },
  {
    id: "population-city-houston-2020",
    category: "population",
    measure: "population",
    subtype: "city",
    prompt: "What was Houston's population in the 2020 U.S. Census?",
    answer: 2304580,
    min: 100000,
    max: 10000000,
    scale: "log",
    unit: "people",
    referenceYear: "2020 decennial census (city proper)",
    source: {
      title: "U.S. Census Bureau QuickFacts — Houston city, Texas",
      url: "https://www.census.gov/quickfacts/fact/table/houstoncitytexas/PST045225",
    },
    explanation: "The 2020 decennial census counted 2,304,580 residents inside Houston's legal city limits.",
  },
  {
    id: "population-city-jacksonville-2020",
    category: "population",
    measure: "population",
    subtype: "city",
    prompt: "What was Jacksonville's population in the 2020 U.S. Census?",
    answer: 949611,
    min: 300000,
    max: 8000000,
    scale: "log",
    unit: "people",
    referenceYear: "2020 decennial census (consolidated city proper)",
    source: {
      title: "U.S. Census Bureau QuickFacts — Jacksonville city, Florida",
      url: "https://www.census.gov/quickfacts/fact/table/jacksonvillecityflorida/PST045225",
    },
    explanation: "The 2020 decennial census counted 949,611 residents inside Jacksonville's consolidated city boundaries.",
  },
  {
    id: "population-city-los-angeles-2020",
    category: "population",
    measure: "population",
    subtype: "city",
    prompt: "What was Los Angeles' population in the 2020 U.S. Census?",
    answer: 3898747,
    min: 100000,
    max: 10000000,
    scale: "log",
    unit: "people",
    referenceYear: "2020 decennial census (city proper)",
    source: {
      title: "U.S. Census Bureau QuickFacts — Los Angeles city, California",
      url: "https://www.census.gov/quickfacts/fact/table/losangelescitycalifornia/PST045225",
    },
    explanation: "The 2020 decennial census counted 3,898,747 residents inside Los Angeles' legal city limits.",
  },
  {
    id: "population-city-new-york-2020",
    category: "population",
    measure: "population",
    subtype: "city",
    prompt: "What was New York City's population in the 2020 U.S. Census?",
    answer: 8804190,
    min: 100000,
    max: 10000000,
    scale: "log",
    unit: "people",
    referenceYear: "2020 decennial census (city proper)",
    source: {
      title: "U.S. Census Bureau QuickFacts — New York city, New York",
      url: "https://www.census.gov/quickfacts/fact/table/newyorkcitynewyork/PST045225",
    },
    explanation: "The 2020 decennial census counted 8,804,190 residents inside New York City's legal city limits.",
  },
  {
    id: "population-city-philadelphia-2020",
    category: "population",
    measure: "population",
    subtype: "city",
    prompt: "What was Philadelphia's population in the 2020 U.S. Census?",
    answer: 1603797,
    min: 700000,
    max: 10000000,
    scale: "log",
    unit: "people",
    referenceYear: "2020 decennial census (city proper)",
    source: {
      title: "U.S. Census Bureau QuickFacts — Philadelphia city, Pennsylvania",
      url: "https://www.census.gov/quickfacts/fact/table/philadelphiacitypennsylvania/PST045225",
    },
    explanation: "The 2020 decennial census counted 1,603,797 residents inside Philadelphia's legal city limits.",
  },
  {
    id: "population-city-phoenix-2020",
    category: "population",
    measure: "population",
    subtype: "city",
    prompt: "What was Phoenix's population in the 2020 U.S. Census?",
    answer: 1608139,
    min: 700000,
    max: 10000000,
    scale: "log",
    unit: "people",
    referenceYear: "2020 decennial census (city proper)",
    source: {
      title: "U.S. Census Bureau QuickFacts — Phoenix city, Arizona",
      url: "https://www.census.gov/quickfacts/fact/table/phoenixcityarizona/PST045225",
    },
    explanation: "The 2020 decennial census counted 1,608,139 residents inside Phoenix's legal city limits.",
  },
  {
    id: "population-city-san-antonio-2020",
    category: "population",
    measure: "population",
    subtype: "city",
    prompt: "What was San Antonio's population in the 2020 U.S. Census?",
    answer: 1434625,
    min: 700000,
    max: 10000000,
    scale: "log",
    unit: "people",
    referenceYear: "2020 decennial census (city proper)",
    source: {
      title: "U.S. Census Bureau QuickFacts — San Antonio city, Texas",
      url: "https://www.census.gov/quickfacts/fact/table/sanantoniocitytexas/PST045225",
    },
    explanation: "The 2020 decennial census counted 1,434,625 residents inside San Antonio's legal city limits.",
  },
  {
    id: "population-city-san-diego-2020",
    category: "population",
    measure: "population",
    subtype: "city",
    prompt: "What was San Diego's population in the 2020 U.S. Census?",
    answer: 1386932,
    min: 700000,
    max: 10000000,
    scale: "log",
    unit: "people",
    referenceYear: "2020 decennial census (city proper)",
    source: {
      title: "U.S. Census Bureau QuickFacts — San Diego city, California",
      url: "https://www.census.gov/quickfacts/fact/table/sandiegocitycalifornia/PST045225",
    },
    explanation: "The 2020 decennial census counted 1,386,932 residents inside San Diego's legal city limits.",
  },
  {
    id: "population-city-san-jose-2020",
    category: "population",
    measure: "population",
    subtype: "city",
    prompt: "What was San Jose's population in the 2020 U.S. Census?",
    answer: 1013240,
    min: 300000,
    max: 8000000,
    scale: "log",
    unit: "people",
    referenceYear: "2020 decennial census (city proper)",
    source: {
      title: "U.S. Census Bureau QuickFacts — San Jose city, California",
      url: "https://www.census.gov/quickfacts/fact/table/sanjosecitycalifornia/PST045225",
    },
    explanation: "The 2020 decennial census counted 1,013,240 residents inside San Jose's legal city limits.",
  },
  {
    id: "quantity-count-living-languages",
    category: "population",
    measure: "quantity",
    subtype: "count",
    prompt: "Roughly how many languages are still spoken in the world today?",
    answer: 7100,
    min: 50,
    max: 50000,
    scale: "log",
    unit: "count",
    source: {
      title: "Ethnologue — Languages of the World",
      url: "https://www.ethnologue.com/",
    },
    explanation: "About 7,100, though roughly half have fewer than 10,000 speakers and a large share are expected to fall out of use this century.",
  },
  {
    id: "quantity-percentage-adult-literacy",
    category: "population",
    measure: "quantity",
    subtype: "percentage",
    prompt: "What share of the world's adults could read and write, in the most recent UNESCO estimate?",
    answer: 87,
    min: 0,
    max: 100,
    scale: "linear",
    unit: "percent",
    source: {
      title: "UNESCO Institute for Statistics — Literacy",
      url: "https://uis.unesco.org/",
    },
    explanation: "About 87 percent of adults worldwide, compared with roughly 68 percent in 1979. Nearly two-thirds of adults who cannot read are women.",
  },
  {
    id: "quantity-percentage-electricity-access",
    category: "population",
    measure: "quantity",
    subtype: "percentage",
    prompt: "What share of the world's population had access to electricity in 2022?",
    answer: 91,
    min: 0,
    max: 100,
    scale: "linear",
    unit: "percent",
    referenceYear: "2022",
    source: {
      title: "World Bank — Access to electricity (% of population)",
      url: "https://data.worldbank.org/indicator/EG.ELC.ACCS.ZS",
    },
    explanation: "About 91 percent, up from roughly 71 percent in 1990. Most of the remaining gap is in sub-Saharan Africa.",
  },
  {
    id: "quantity-percentage-internet-users",
    category: "population",
    measure: "quantity",
    subtype: "percentage",
    prompt: "What share of the world's population was using the internet in 2023?",
    answer: 67,
    min: 0,
    max: 100,
    scale: "linear",
    unit: "percent",
    referenceYear: "2023",
    source: {
      title: "International Telecommunication Union — Statistics",
      url: "https://www.itu.int/en/ITU-D/Statistics/Pages/stat/default.aspx",
    },
    explanation: "About 67 percent, leaving roughly 2.6 billion people offline. The gap is widest in low-income countries and among women.",
  },
  {
    id: "quantity-percentage-urban-population",
    category: "population",
    measure: "quantity",
    subtype: "percentage",
    prompt: "What share of the world's population lived in urban areas in 2023?",
    answer: 57,
    min: 0,
    max: 100,
    scale: "linear",
    unit: "percent",
    referenceYear: "2023",
    source: {
      title: "World Bank — Urban population (% of total population)",
      url: "https://data.worldbank.org/indicator/SP.URB.TOTL.IN.ZS",
    },
    explanation: "About 57 percent. The world passed the halfway mark around 2007; in 1960 it was roughly a third.",
  },
  {
    id: "daily-bell-telephone-patent-year",
    category: "history",
    measure: "history",
    subtype: "event",
    prompt: "In what year was Alexander Graham Bell granted his first US telephone patent?",
    answer: 1876,
    min: 1000,
    max: 2026,
    scale: "linear",
    unit: "year",
    source: {
      title: "United States Patent and Trademark Office - Bringing Light for All",
      url: "https://www.uspto.gov/learning-and-resources/journeys-innovation/historical-stories/bringing-light-all",
    },
    explanation: "Alexander Graham Bell received his foundational US telephone patent in 1876.",
  },
  {
    id: "daily-berlin-wall-opening-year",
    category: "history",
    measure: "history",
    subtype: "event",
    prompt: "In what year was the Berlin Wall opened after nearly three decades of division?",
    answer: 1989,
    min: 1800,
    max: 2026,
    scale: "linear",
    unit: "year",
    source: {
      title: "Berlin.de - Opening and Fall of the Berlin Wall",
      url: "https://www.berlin.de/en/history/8482274-8619314-opening-and-fall-of-the-berlin-wall.en.html",
    },
    explanation: "The Berlin Wall was opened on 9 November 1989 after mounting public pressure and political upheaval.",
  },
  {
    id: "daily-chernobyl-disaster-year",
    category: "history",
    measure: "history",
    subtype: "event",
    prompt: "In what year did the Chernobyl nuclear disaster occur?",
    answer: 1986,
    min: 1800,
    max: 2026,
    scale: "linear",
    unit: "year",
    source: {
      title: "International Atomic Energy Agency - Twenty Years After the Chernobyl Accident",
      url: "https://www.iaea.org/newscenter/news/twenty-years-after-the-chernobyl-accident",
    },
    explanation: "Reactor 4 at the Chernobyl nuclear power plant exploded on 26 April 1986.",
  },
  {
    id: "daily-first-modern-olympics-year",
    category: "history",
    measure: "history",
    subtype: "event",
    prompt: "In what year did the first modern Olympic Games begin in Athens?",
    answer: 1896,
    min: 1850,
    max: 2026,
    scale: "linear",
    unit: "year",
    source: {
      title: "Australian Olympic Committee - Athens 1896",
      url: "https://www.olympics.com.au/games/athens-1896/",
    },
    explanation: "The first modern Olympic Games began in Athens on 6 April 1896.",
  },
  {
    id: "daily-great-pyramid-completed-year",
    category: "history",
    measure: "history",
    subtype: "event",
    prompt: "In roughly what year was the Great Pyramid of Giza completed?",
    answer: -2560,
    min: -3000,
    max: 500,
    scale: "linear",
    unit: "year",
    source: {
      title: "Encyclopaedia Britannica — Pyramids of Giza",
      url: "https://www.britannica.com/topic/Pyramids-of-Giza",
    },
    explanation: "The Great Pyramid was built for the pharaoh Khufu in about 2560 BCE.",
  },
  {
    id: "daily-great-wall-first-unified-year",
    category: "history",
    measure: "history",
    subtype: "event",
    prompt: "In roughly what year did Qin Shi Huang first link the walls that became the Great Wall of China?",
    answer: -221,
    min: -1000,
    max: 2026,
    scale: "linear",
    unit: "year",
    source: {
      title: "Encyclopaedia Britannica — Great Wall of China",
      url: "https://www.britannica.com/topic/Great-Wall-of-China",
    },
    explanation: "China's first emperor joined existing frontier walls from about 221 BCE.",
  },
  {
    id: "daily-library-of-alexandria-founded-year",
    category: "history",
    measure: "history",
    subtype: "event",
    prompt: "In roughly what year was the Library of Alexandria founded?",
    answer: -285,
    min: -1000,
    max: 2026,
    scale: "linear",
    unit: "year",
    source: {
      title: "Encyclopaedia Britannica — Library of Alexandria",
      url: "https://www.britannica.com/topic/Library-of-Alexandria",
    },
    explanation: "The library was established under the early Ptolemies in about 285 BCE.",
  },
  {
    id: "daily-tutankhamun-death-year",
    category: "history",
    measure: "history",
    subtype: "event",
    prompt: "In roughly what year did the pharaoh Tutankhamun die?",
    answer: -1323,
    min: -2500,
    max: 500,
    scale: "linear",
    unit: "year",
    source: {
      title: "Encyclopaedia Britannica — Tutankhamun",
      url: "https://www.britannica.com/biography/Tutankhamen",
    },
    explanation: "Tutankhamun died around 1323 BCE, still a teenager, and his tomb went undisturbed until 1922.",
  },
  {
    id: "daily-western-roman-empire-fell-year",
    category: "history",
    measure: "history",
    subtype: "event",
    prompt: "In what year is the Western Roman Empire conventionally said to have fallen?",
    answer: 476,
    min: -500,
    max: 2026,
    scale: "linear",
    unit: "year",
    source: {
      title: "Encyclopaedia Britannica — Fall of Rome",
      url: "https://www.britannica.com/place/ancient-Rome",
    },
    explanation: "The deposition of Romulus Augustulus in 476 CE is the traditional marker for the end of the Western empire.",
  },
  {
    id: "history-event-apollo-eleven",
    category: "history",
    measure: "history",
    subtype: "event",
    prompt: "In what year did Apollo 11 achieve the first crewed Moon landing?",
    answer: 1969,
    min: 1000,
    max: 2025,
    scale: "linear",
    unit: "year",
    source: {
      title: "NASA — Apollo 11",
      url: "https://www.nasa.gov/mission/apollo-11/",
    },
    explanation: "Apollo 11 landed on the Moon on 20 July 1969, and Neil Armstrong stepped onto the surface soon after.",
  },
  {
    id: "history-event-battle-of-hastings",
    category: "history",
    measure: "history",
    subtype: "event",
    prompt: "In what year was the Battle of Hastings fought?",
    answer: 1066,
    min: 1000,
    max: 2025,
    scale: "linear",
    unit: "year",
    source: {
      title: "English Heritage — History of the Battle of Hastings",
      url: "https://www.english-heritage.org.uk/visit/places/1066-battle-of-hastings-abbey-and-battlefield/history-and-stories/history/",
    },
    explanation: "The battle was fought in 1066, when William of Normandy defeated King Harold II.",
  },
  {
    id: "history-event-columbus-caribbean",
    category: "history",
    measure: "history",
    subtype: "event",
    prompt: "In what year did Christopher Columbus' first voyage reach the Caribbean?",
    answer: 1492,
    min: 800,
    max: 1800,
    scale: "linear",
    unit: "year",
    source: {
      title: "Library of Congress — 1492: An Ongoing Voyage, Columbus",
      url: "https://www.loc.gov/exhibits/1492/columbus.html",
    },
    explanation: "Columbus' first Atlantic voyage reached the Caribbean in 1492.",
  },
  {
    id: "history-event-euro-launched",
    category: "history",
    measure: "history",
    subtype: "event",
    prompt: "In what year was the euro launched as an accounting and electronic currency?",
    answer: 1999,
    min: 1000,
    max: 2025,
    scale: "linear",
    unit: "year",
    source: {
      title: "European Central Bank — Our Money",
      url: "https://www.ecb.europa.eu/euro/intro/html/index.en.html",
    },
    explanation: "The euro launched on 1 January 1999; euro banknotes and coins entered circulation in 2002.",
  },
  {
    id: "history-event-fall-of-constantinople",
    category: "history",
    measure: "history",
    subtype: "event",
    prompt: "In what year did Constantinople fall to the Ottoman Empire?",
    answer: 1453,
    min: 800,
    max: 1800,
    scale: "linear",
    unit: "year",
    source: {
      title: "Encyclopaedia Britannica — Fall of Constantinople",
      url: "https://www.britannica.com/event/Fall-of-Constantinople-1453",
    },
    explanation: "Ottoman forces captured Constantinople in 1453, ending the Byzantine Empire.",
  },
  {
    id: "history-event-first-world-war-begins",
    category: "history",
    measure: "history",
    subtype: "event",
    prompt: "In what year did the First World War begin?",
    answer: 1914,
    min: 1000,
    max: 2025,
    scale: "linear",
    unit: "year",
    source: {
      title: "Imperial War Museums — How the World Went to War in 1914",
      url: "https://www.iwm.org.uk/history/how-the-world-went-to-war-in-1914",
    },
    explanation: "A chain of declarations of war turned the July Crisis into a global conflict in 1914.",
  },
  {
    id: "history-event-french-revolution-begins",
    category: "history",
    measure: "history",
    subtype: "event",
    prompt: "In what year did the French Revolution begin?",
    answer: 1789,
    min: 1000,
    max: 2025,
    scale: "linear",
    unit: "year",
    source: {
      title: "Encyclopaedia Britannica — French Revolution",
      url: "https://www.britannica.com/event/French-Revolution",
    },
    explanation: "The French Revolution began in 1789 amid political, social, and financial crisis.",
  },
  {
    id: "history-event-great-fire-london",
    category: "history",
    measure: "history",
    subtype: "event",
    prompt: "In what year did the Great Fire of London begin?",
    answer: 1666,
    min: 1000,
    max: 2025,
    scale: "linear",
    unit: "year",
    source: {
      title: "London Museum — The Great Fire of London",
      url: "https://www.londonmuseum.org.uk/collections/london-stories/great-fire-of-london/",
    },
    explanation: "The Great Fire began in September 1666 and burned for four days.",
  },
  {
    id: "history-event-gunpowder-plot",
    category: "history",
    measure: "history",
    subtype: "event",
    prompt: "In what year was the Gunpowder Plot uncovered?",
    answer: 1605,
    min: 950,
    max: 1950,
    scale: "linear",
    unit: "year",
    source: {
      title: "UK Parliament — The Gunpowder Plot of 1605",
      url: "https://www.parliament.uk/about/living-heritage/evolutionofparliament/parliamentaryauthority/the-gunpowder-plot-of-1605/",
    },
    explanation: "The plot to destroy the House of Lords was uncovered on 5 November 1605.",
  },
  {
    id: "history-event-haitian-independence",
    category: "history",
    measure: "history",
    subtype: "event",
    prompt: "In what year did Haiti declare independence from France?",
    answer: 1804,
    min: 1000,
    max: 2025,
    scale: "linear",
    unit: "year",
    source: {
      title: "Encyclopaedia Britannica — Haitian Revolution",
      url: "https://www.britannica.com/topic/Haitian-Revolution",
    },
    explanation: "Haiti declared independence in 1804 after the successful Haitian Revolution.",
  },
  {
    id: "history-event-jamestown-founded",
    category: "history",
    measure: "history",
    subtype: "event",
    prompt: "In what year was Jamestown, the first permanent English settlement in North America, founded?",
    answer: 1607,
    min: 950,
    max: 1950,
    scale: "linear",
    unit: "year",
    source: {
      title: "U.S. National Park Service — Jamestown and Plymouth",
      url: "https://www.nps.gov/jame/learn/historyculture/jamestown-and-plymouth-compare-and-contrast.htm",
    },
    explanation: "English settlers founded Jamestown in Virginia in 1607.",
  },
  {
    id: "history-event-magna-carta",
    category: "history",
    measure: "history",
    subtype: "event",
    prompt: "In what year was Magna Carta first sealed at Runnymede?",
    answer: 1215,
    min: 1000,
    max: 2025,
    scale: "linear",
    unit: "year",
    source: {
      title: "UK Parliament — Magna Carta",
      url: "https://www.parliament.uk/magnacarta/",
    },
    explanation: "King John first sealed Magna Carta at Runnymede in 1215.",
  },
  {
    id: "history-event-meiji-restoration",
    category: "history",
    measure: "history",
    subtype: "event",
    prompt: "In what year did the Meiji Restoration begin in Japan?",
    answer: 1868,
    min: 1000,
    max: 2025,
    scale: "linear",
    unit: "year",
    source: {
      title: "Encyclopaedia Britannica — Meiji Restoration",
      url: "https://www.britannica.com/event/Meiji-Restoration",
    },
    explanation: "The Meiji Restoration began in 1868, restoring imperial rule and accelerating Japan's transformation.",
  },
  {
    id: "history-event-ninety-five-theses",
    category: "history",
    measure: "history",
    subtype: "event",
    prompt: "In what year did Martin Luther circulate the Ninety-five Theses?",
    answer: 1517,
    min: 850,
    max: 1850,
    scale: "linear",
    unit: "year",
    source: {
      title: "Encyclopaedia Britannica — Ninety-five Theses",
      url: "https://www.britannica.com/event/Ninety-five-Theses",
    },
    explanation: "Luther circulated the Ninety-five Theses in 1517, a landmark of the Protestant Reformation.",
  },
  {
    id: "history-event-penicillin-discovery",
    category: "history",
    measure: "history",
    subtype: "event",
    prompt: "In what year did Alexander Fleming discover penicillin?",
    answer: 1928,
    min: 1000,
    max: 2025,
    scale: "linear",
    unit: "year",
    source: {
      title: "Nobel Prize — Alexander Fleming, Facts",
      url: "https://www.nobelprize.org/prizes/medicine/1945/fleming/facts/",
    },
    explanation: "Fleming observed penicillin's antibacterial effect in 1928; later work made it a usable medicine.",
  },
  {
    id: "history-event-plymouth-founded",
    category: "history",
    measure: "history",
    subtype: "event",
    prompt: "In what year did the Mayflower settlers establish Plymouth Colony?",
    answer: 1620,
    min: 950,
    max: 1950,
    scale: "linear",
    unit: "year",
    source: {
      title: "U.S. National Park Service — Jamestown and Plymouth",
      url: "https://www.nps.gov/jame/learn/historyculture/jamestown-and-plymouth-compare-and-contrast.htm",
    },
    explanation: "The Mayflower settlers landed and established Plymouth Colony in 1620.",
  },
  {
    id: "history-event-representation-people-act",
    category: "history",
    measure: "history",
    subtype: "event",
    prompt: "In what year did the UK Representation of the People Act give the parliamentary vote to qualifying women over 30?",
    answer: 1918,
    min: 1000,
    max: 2025,
    scale: "linear",
    unit: "year",
    source: {
      title: "UK Parliament — The 1918 Representation of the People Act",
      url: "https://www.parliament.uk/about/living-heritage/transformingsociety/electionsvoting/womenvote/overview/thevote/",
    },
    explanation: "The 1918 Act enfranchised many women over 30; equal voting terms with men followed in 1928.",
  },
  {
    id: "history-event-russian-revolution",
    category: "history",
    measure: "history",
    subtype: "event",
    prompt: "In what year did the two revolutions that ended imperial rule and brought the Bolsheviks to power occur in Russia?",
    answer: 1917,
    min: 1000,
    max: 2025,
    scale: "linear",
    unit: "year",
    source: {
      title: "Encyclopaedia Britannica — Russian Revolution",
      url: "https://www.britannica.com/event/Russian-Revolution",
    },
    explanation: "Russia's February and October Revolutions both took place in 1917.",
  },
  {
    id: "history-event-second-world-war-europe",
    category: "history",
    measure: "history",
    subtype: "event",
    prompt: "In what year did the Second World War begin in Europe with Germany's invasion of Poland?",
    answer: 1939,
    min: 1000,
    max: 2025,
    scale: "linear",
    unit: "year",
    source: {
      title: "Imperial War Museums — How Europe Went to War in 1939",
      url: "https://www.iwm.org.uk/history/how-europe-went-to-war-in-1939",
    },
    explanation: "Germany invaded Poland on 1 September 1939; Britain and France declared war two days later.",
  },
  {
    id: "history-event-spanish-armada",
    category: "history",
    measure: "history",
    subtype: "event",
    prompt: "In what year did the Spanish Armada campaign take place?",
    answer: 1588,
    min: 900,
    max: 1900,
    scale: "linear",
    unit: "year",
    source: {
      title: "Royal Museums Greenwich — The Spanish Armada",
      url: "https://www.rmg.co.uk/stories/topics/spanish-armada-history-causes-timeline",
    },
    explanation: "Philip II's Spanish Armada sailed against England in 1588 and failed to achieve its invasion aims.",
  },
  {
    id: "history-event-sputnik-one",
    category: "history",
    measure: "history",
    subtype: "event",
    prompt: "In what year did the Soviet Union launch Sputnik 1, the first artificial satellite?",
    answer: 1957,
    min: 1000,
    max: 2025,
    scale: "linear",
    unit: "year",
    source: {
      title: "NASA History — From Sputnik I to Vanguard TV-3",
      url: "https://www.nasa.gov/history/sputnik/chap11.html",
    },
    explanation: "The Soviet Union launched Sputnik 1 into orbit on 4 October 1957.",
  },
  {
    id: "history-event-stockton-darlington-railway",
    category: "history",
    measure: "history",
    subtype: "event",
    prompt: "In what year did the Stockton and Darlington Railway open, marking the birth of the modern public railway?",
    answer: 1825,
    min: 1000,
    max: 2025,
    scale: "linear",
    unit: "year",
    source: {
      title: "National Railway Museum — Leonard Raisbeck and the Stockton & Darlington Railway",
      url: "https://www.railwaymuseum.org.uk/objects-and-stories/leonard-raisbeck",
    },
    explanation: "The Stockton and Darlington Railway opened on 27 September 1825.",
  },
  {
    id: "history-event-titanic-sinks",
    category: "history",
    measure: "history",
    subtype: "event",
    prompt: "In what year did RMS Titanic sink on its maiden voyage?",
    answer: 1912,
    min: 1000,
    max: 2025,
    scale: "linear",
    unit: "year",
    source: {
      title: "NOAA — RMS Titanic: History and Significance",
      url: "https://www.noaa.gov/office-of-general-counsel/gc-international-section/rms-titanic-history-and-significance",
    },
    explanation: "Titanic struck an iceberg and sank in the North Atlantic in April 1912.",
  },
  {
    id: "history-event-united-nations-founded",
    category: "history",
    measure: "history",
    subtype: "event",
    prompt: "In what year did the United Nations officially come into existence?",
    answer: 1945,
    min: 1000,
    max: 2025,
    scale: "linear",
    unit: "year",
    source: {
      title: "United Nations — History of the United Nations",
      url: "https://www.un.org/en/about-us/history-of-the-un",
    },
    explanation: "The UN Charter came into force on 24 October 1945, officially creating the organization.",
  },
  {
    id: "history-event-us-civil-war-begins",
    category: "history",
    measure: "history",
    subtype: "event",
    prompt: "In what year did the U.S. Civil War begin?",
    answer: 1861,
    min: 1000,
    max: 2025,
    scale: "linear",
    unit: "year",
    source: {
      title: "U.S. National Park Service — Civil War Facts",
      url: "https://www.nps.gov/civilwar/facts.htm",
    },
    explanation: "The U.S. Civil War began in 1861 with the Confederate attack on Fort Sumter.",
  },
  {
    id: "history-event-us-declaration-independence",
    category: "history",
    measure: "history",
    subtype: "event",
    prompt: "In what year did the Continental Congress adopt the U.S. Declaration of Independence?",
    answer: 1776,
    min: 1000,
    max: 2025,
    scale: "linear",
    unit: "year",
    source: {
      title: "U.S. National Archives — Declaration of Independence",
      url: "https://www.archives.gov/milestone-documents/declaration-of-independence",
    },
    explanation: "The Continental Congress adopted the Declaration on 4 July 1776.",
  },
  {
    id: "history-event-wall-street-crash",
    category: "history",
    measure: "history",
    subtype: "event",
    prompt: "In what year did the Wall Street stock market crash associated with Black Tuesday occur?",
    answer: 1929,
    min: 1000,
    max: 2025,
    scale: "linear",
    unit: "year",
    source: {
      title: "Federal Reserve History — Stock Market Crash of 1929",
      url: "https://www.federalreservehistory.org/essays/stock-market-crash-of-1929",
    },
    explanation: "The market collapsed across several days in October 1929, including Black Tuesday on 29 October.",
  },
  {
    id: "history-event-waterloo",
    category: "history",
    measure: "history",
    subtype: "event",
    prompt: "In what year was the Battle of Waterloo fought?",
    answer: 1815,
    min: 1000,
    max: 2025,
    scale: "linear",
    unit: "year",
    source: {
      title: "National Army Museum — Battle of Waterloo",
      url: "https://www.nam.ac.uk/explore/battle-waterloo",
    },
    explanation: "The Battle of Waterloo was fought on 18 June 1815 and ended Napoleon's return to power.",
  },
  {
    id: "history-event-world-wide-web",
    category: "history",
    measure: "history",
    subtype: "event",
    prompt: "In what year did Tim Berners-Lee invent the World Wide Web while working at CERN?",
    answer: 1989,
    min: 1000,
    max: 2025,
    scale: "linear",
    unit: "year",
    source: {
      title: "CERN — Where the Web Was Born",
      url: "https://home.cern/science/computing/the-birth-of-the-web/where-web-was-born/",
    },
    explanation: "Tim Berners-Lee proposed and invented the World Wide Web at CERN in 1989.",
  },
  {
    id: "history-event-wright-first-flight",
    category: "history",
    measure: "history",
    subtype: "event",
    prompt: "In what year did the Wright brothers make the first successful powered, controlled airplane flight?",
    answer: 1903,
    min: 1000,
    max: 2025,
    scale: "linear",
    unit: "year",
    source: {
      title: "Smithsonian National Air and Space Museum — The Wright Brothers",
      url: "https://airandspace.si.edu/exhibitions/wright-brothers/online/fly/1903/",
    },
    explanation: "Orville and Wilbur Wright achieved powered, controlled flight at Kitty Hawk in 1903.",
  },
  {
    id: "history-lindisfarne-raid-year",
    category: "history",
    measure: "history",
    subtype: "event",
    prompt: "In what year did Norse raiders sack the monastery on Lindisfarne, an attack that shocked all of Christian Europe?",
    answer: 793,
    min: 600,
    max: 1100,
    scale: "linear",
    unit: "year",
    source: {
      title: "English Heritage — The Viking Raid on Lindisfarne",
      url: "https://www.english-heritage.org.uk/visit/places/lindisfarne-priory/History/viking-raid/",
    },
    explanation: "The raid on Lindisfarne's monastery in 793 is traditionally seen as marking the start of the Viking Age.",
  },
  {
    id: "history-gokstad-ship-length",
    category: "history",
    measure: "size",
    subtype: "length",
    prompt: "The Gokstad ship, the finest Viking longship ever excavated, measures how many metres from bow to stern?",
    answer: 23.22,
    min: 8,
    max: 45,
    scale: "linear",
    unit: "metre",
    source: {
      title: "Museum of the Viking Age — The Gokstad Ship",
      url: "https://www.vikingtidsmuseet.no/english/the-collection/the-gokstad-ship/the-gokstad-ship.html",
    },
    explanation: "The Gokstad ship measures 23.22 metres long and 5.18 metres wide, built from oak around AD 890.",
  },
  {
    id: "history-great-pyramid-original-height",
    category: "history",
    measure: "size",
    subtype: "length",
    prompt: "Before its gleaming limestone casing was stripped away over the centuries, how tall did the Great Pyramid of Giza originally stand?",
    answer: 146.5,
    min: 50,
    max: 300,
    scale: "linear",
    unit: "metre",
    source: {
      title: "Egypt Ministry of Tourism and Antiquities — The Great Pyramid",
      url: "https://egymonuments.gov.eg/en/monuments/the-great-pyramid",
    },
    explanation: "The pyramid originally reached 146.5 metres, making it the tallest structure on Earth for roughly 3,800 years.",
  },
  {
    id: "history-ishtar-gate-height",
    category: "history",
    measure: "size",
    subtype: "length",
    prompt: "Nebuchadnezzar II's dazzling blue Ishtar Gate, covered in glazed dragons and bulls, originally stood how tall?",
    answer: 12,
    min: 3,
    max: 40,
    scale: "log",
    unit: "metre",
    source: {
      title: "Britannica — Ishtar Gate",
      url: "https://britannica.com/topic/Ishtar-Gate",
    },
    explanation: "The gate stood more than 12 metres high and formed the eighth fortified entrance into the city of Babylon.",
  },
  {
    id: "history-statue-of-zeus-olympia-height",
    category: "history",
    measure: "size",
    subtype: "length",
    prompt: "Phidias's gold-and-ivory Statue of Zeus was so vast that ancient writers joked the god would smash through the roof if he stood up — how tall was it seated?",
    answer: 12,
    min: 3,
    max: 30,
    scale: "linear",
    unit: "metre",
    source: {
      title: "Britannica — Statue of Zeus",
      url: "https://www.britannica.com/topic/Statue-of-Zeus",
    },
    explanation: "The seated statue stood almost 12 metres tall inside its temple, one of the Seven Wonders of the Ancient World.",
  },
  {
    id: "history-suenos-stone-height",
    category: "history",
    measure: "size",
    subtype: "length",
    prompt: "Sueno's Stone near Forres is Scotland's tallest surviving carved standing stone — how many metres does it reach?",
    answer: 7,
    min: 1,
    max: 20,
    scale: "linear",
    unit: "metre",
    source: {
      title: "Historic Environment Scotland — Sueno's Stone",
      url: "https://www.historicenvironment.scot/visit-a-place/places/suenos-stone/",
    },
    explanation: "Sueno's Stone stands about 7 metres tall, covered in an intricate Pictish cross and a battle scene.",
  },
  {
    id: "history-roman-empire-peak-area",
    category: "history",
    measure: "size",
    subtype: "area",
    prompt: "At its absolute widest, under Emperor Trajan in AD 117, how many square kilometres did the Roman Empire cover?",
    answer: 5000000,
    min: 500000,
    max: 20000000,
    scale: "log",
    unit: "square-kilometre",
    source: {
      title: "Wikipedia — Roman Empire (infobox area figures)",
      url: "https://en.wikipedia.org/wiki/Roman_Empire",
    },
    explanation: "The empire covered about 5 million square kilometres at its peak, stretching from Britain to the Persian Gulf.",
  },
  {
    id: "history-cuerdale-hoard-silver-weight",
    category: "history",
    measure: "size",
    subtype: "mass",
    prompt: "The Cuerdale Hoard, the largest Viking silver hoard known from north-western Europe, weighed roughly how many kilograms?",
    answer: 40,
    min: 1,
    max: 200,
    scale: "log",
    unit: "kilogram",
    source: {
      title: "British Museum Images — The Cuerdale Hoard",
      url: "https://www.bmimages.com/preview.asp?image=00035906001",
    },
    explanation: "The hoard weighed almost 40 kilograms of silver coins, ingots and hacksilver, buried around AD 905.",
  },
  {
    id: "history-great-pyramid-average-block-weight",
    category: "history",
    measure: "size",
    subtype: "mass",
    prompt: "Egyptologists estimate that an average limestone block inside the Great Pyramid weighs about how many tonnes?",
    answer: 2.5,
    min: 0.5,
    max: 20,
    scale: "log",
    unit: "tonne",
    source: {
      title: "npj Heritage Science — Sustainability problems of the Giza pyramids",
      url: "https://www.nature.com/articles/s40494-020-0356-9",
    },
    explanation: "Most Egyptologists use 2.5 tonnes as the average block weight, though some granite blocks weigh far more.",
  },
  {
    id: "history-augustus-standing-legions-count",
    category: "history",
    measure: "quantity",
    subtype: "count",
    prompt: "After Augustus disbanded Rome's bloated civil-war armies, how many legions were left in his new professional standing force?",
    answer: 28,
    min: 5,
    max: 80,
    scale: "linear",
    unit: "count",
    source: {
      title: "UNRV Roman History — Augustus and the Legions",
      url: "https://www.unrv.com/early-empire/augustus-legions.php",
    },
    explanation: "Augustus reduced over 50 legions down to 28 professional units, most of which lasted for centuries.",
  },
  {
    id: "history-gokstad-ship-oarholes-count",
    category: "history",
    measure: "quantity",
    subtype: "count",
    prompt: "The Gokstad ship could be rowed by two men sharing each hole along its side — how many oar holes did it have in total?",
    answer: 32,
    min: 4,
    max: 80,
    scale: "linear",
    unit: "count",
    source: {
      title: "Museum of the Viking Age — The Gokstad Ship",
      url: "https://www.vikingtidsmuseet.no/english/the-collection/the-gokstad-ship/the-gokstad-ship.html",
    },
    explanation: "There are 16 oar holes along each side, 32 in total, giving space for a crew of up to 67 people.",
  },
  {
    id: "history-hammurabi-code-law-count",
    category: "history",
    measure: "quantity",
    subtype: "count",
    prompt: "How many individual laws are carved into the towering black stele known as the Code of Hammurabi?",
    answer: 282,
    min: 50,
    max: 500,
    scale: "linear",
    unit: "count",
    source: {
      title: "Louvre Museum — The Code of Hammurabi",
      url: "https://www.louvre.fr/en/the-code-of-hammurabi",
    },
    explanation: "The stele records 282 legal judgements covering family, property, trade and labour in ancient Babylon.",
  },
  {
    id: "history-iliad-book-count",
    category: "history",
    measure: "quantity",
    subtype: "count",
    prompt: "Ancient scholars split Homer's entire Iliad into how many separate books?",
    answer: 24,
    min: 4,
    max: 60,
    scale: "linear",
    unit: "count",
    source: {
      title: "Harvard Center for Hellenic Studies — An Outline of the Homeric Iliad",
      url: "https://continuum.fas.harvard.edu/an-outline-of-the-homeric-iliad-designed-especially-for-first-time-readers/",
    },
    explanation: "The Iliad was divided into 24 books, traditionally said to echo the 24 letters of the Greek alphabet.",
  },
  {
    id: "history-pictish-symbol-stones-count",
    category: "history",
    measure: "quantity",
    subtype: "count",
    prompt: "Roughly how many Class I Pictish symbol stones, carved with mysterious animal and geometric designs, survive across Scotland today?",
    answer: 200,
    min: 20,
    max: 500,
    scale: "linear",
    unit: "count",
    source: {
      title: "Historic Environment Scotland — What's Left of the Picts?",
      url: "https://blog.historicenvironment.scot/2025/08/whats-left-of-the-picts-scotlands-pictish-stones/",
    },
    explanation: "Around 200 Class I symbol stones survive, carved between the 4th and 7th centuries with designs unique to the Picts.",
  },
  {
    id: "quantity-money-alaska-purchase",
    category: "history",
    measure: "quantity",
    subtype: "money",
    prompt: "What did the United States pay Russia for Alaska in 1867, in the dollars of the day?",
    answer: 7200000,
    min: 50000,
    max: 50000000,
    scale: "log",
    unit: "usd",
    referenceYear: "1867",
    source: {
      title: "Encyclopaedia Britannica — Alaska Purchase",
      url: "https://www.britannica.com/topic/Alaska-Purchase",
    },
    explanation: "7.2 million dollars, about two cents an acre. Critics called it Seward's Folly until gold was found three decades later.",
  },
  {
    id: "quantity-money-apollo-program",
    category: "history",
    measure: "quantity",
    subtype: "money",
    prompt: "What did the Apollo programme cost in total through 1973, in the dollars of the day?",
    answer: 25400000000,
    min: 100000000,
    max: 500000000000,
    scale: "log",
    unit: "usd",
    referenceYear: "1973",
    source: {
      title: "Encyclopaedia Britannica — Apollo program",
      url: "https://www.britannica.com/science/Apollo-space-program",
    },
    explanation: "About 25.4 billion dollars at the time. At its peak the programme took close to four percent of the entire federal budget.",
  },
  {
    id: "quantity-money-empire-state-building",
    category: "history",
    measure: "quantity",
    subtype: "money",
    prompt: "What did the Empire State Building cost to build, completed in 1931, in the dollars of the day?",
    answer: 40948900,
    min: 500000,
    max: 500000000,
    scale: "log",
    unit: "usd",
    referenceYear: "1931",
    source: {
      title: "Encyclopaedia Britannica — Empire State Building",
      url: "https://www.britannica.com/topic/Empire-State-Building",
    },
    explanation: "About 41 million dollars, well under its budget because the Depression had driven down the cost of labour and materials.",
  },
  {
    id: "quantity-money-golden-gate-bridge",
    category: "history",
    measure: "quantity",
    subtype: "money",
    prompt: "What did the Golden Gate Bridge cost to build, completed in 1937, in the dollars of the day?",
    answer: 35000000,
    min: 500000,
    max: 200000000,
    scale: "log",
    unit: "usd",
    referenceYear: "1937",
    source: {
      title: "Encyclopaedia Britannica — Golden Gate Bridge",
      url: "https://www.britannica.com/topic/Golden-Gate-Bridge",
    },
    explanation: "About 35 million dollars, and it came in under budget. A safety net strung beneath the deck saved nineteen workers who fell into it.",
  },
  {
    id: "quantity-money-hubble-launch",
    category: "history",
    measure: "quantity",
    subtype: "money",
    prompt: "What had the Hubble Space Telescope cost by the time it launched in 1990, in the dollars of the day?",
    answer: 1500000000,
    min: 20000000,
    max: 20000000000,
    scale: "log",
    unit: "usd",
    referenceYear: "1990",
    source: {
      title: "NASA Science — Hubble Space Telescope",
      url: "https://science.nasa.gov/mission/hubble/",
    },
    explanation: "About 1.5 billion dollars. Its main mirror turned out to be misground, and a shuttle crew had to fly up in 1993 to correct it.",
  },
  {
    id: "quantity-money-louisiana-purchase",
    category: "history",
    measure: "quantity",
    subtype: "money",
    prompt: "What did the United States pay France for the Louisiana Purchase in 1803, in the dollars of the day?",
    answer: 15000000,
    min: 100000,
    max: 100000000,
    scale: "log",
    unit: "usd",
    referenceYear: "1803",
    source: {
      title: "Encyclopaedia Britannica — Louisiana Purchase",
      url: "https://www.britannica.com/event/Louisiana-Purchase",
    },
    explanation: "15 million dollars for about 2.1 million square kilometres, which roughly doubled the size of the country at around three cents an acre.",
  },
  {
    id: "quantity-money-manhattan-project",
    category: "history",
    measure: "quantity",
    subtype: "money",
    prompt: "What did the Manhattan Project cost through 1945, in the dollars of the day?",
    answer: 1900000000,
    min: 5000000,
    max: 20000000000,
    scale: "log",
    unit: "usd",
    referenceYear: "1945",
    source: {
      title: "Encyclopaedia Britannica — Manhattan Project",
      url: "https://www.britannica.com/event/Manhattan-Project",
    },
    explanation: "About 1.9 billion dollars. The great majority went on producing fissile material rather than on designing the weapons themselves.",
  },
  {
    id: "quantity-money-marshall-plan",
    category: "history",
    measure: "quantity",
    subtype: "money",
    prompt: "How much aid did the Marshall Plan send to western Europe between 1948 and 1952, in the dollars of the day?",
    answer: 13300000000,
    min: 100000000,
    max: 200000000000,
    scale: "log",
    unit: "usd",
    referenceYear: "1952",
    source: {
      title: "Encyclopaedia Britannica — Marshall Plan",
      url: "https://www.britannica.com/event/Marshall-Plan",
    },
    explanation: "About 13.3 billion dollars over four years, split across sixteen countries, with Britain and France receiving the largest shares.",
  },
  {
    id: "quantity-money-panama-canal",
    category: "history",
    measure: "quantity",
    subtype: "money",
    prompt: "What did the Panama Canal cost the United States to build between 1904 and 1914, in the dollars of the day?",
    answer: 375000000,
    min: 5000000,
    max: 2000000000,
    scale: "log",
    unit: "usd",
    referenceYear: "1914",
    source: {
      title: "Encyclopaedia Britannica — Panama Canal",
      url: "https://www.britannica.com/topic/Panama-Canal",
    },
    explanation: "About 375 million dollars, the most expensive construction project the United States had undertaken to that point.",
  },
  {
    id: "quantity-money-titanic-build",
    category: "history",
    measure: "quantity",
    subtype: "money",
    prompt: "What did it cost to build the RMS Titanic in 1912, in the dollars of the day?",
    answer: 7500000,
    min: 100000,
    max: 100000000,
    scale: "log",
    unit: "usd",
    referenceYear: "1912",
    source: {
      title: "Encyclopaedia Britannica — Titanic",
      url: "https://www.britannica.com/topic/Titanic",
    },
    explanation: "About 7.5 million dollars. She was insured for rather less than she cost to build, and sank on her maiden voyage.",
  },
  {
    id: "history-neo-babylonian-empire-duration",
    category: "history",
    measure: "physics",
    subtype: "duration",
    prompt: "From Nabopolassar's revolt against Assyria to Cyrus's conquest, for how many years did the Neo-Babylonian Empire actually last?",
    answer: 87,
    min: 10,
    max: 400,
    scale: "log",
    unit: "duration-year",
    source: {
      title: "Britannica — Neo-Babylonian Empire",
      url: "https://www.britannica.com/place/Neo-Babylonian-Empire",
    },
    explanation: "The empire lasted 87 years, from Nabopolassar's coronation in 626 BCE to the Persian conquest in 539 BCE.",
  },
  {
    id: "history-rome-founding-to-fall-duration",
    category: "history",
    measure: "physics",
    subtype: "duration",
    prompt: "Rome's founding is traditionally dated to 753 BCE, and its western empire fell in 476 CE — how many years separate the two?",
    answer: 1229,
    min: 200,
    max: 2500,
    scale: "log",
    unit: "duration-year",
    source: {
      title: "Britannica — Ancient Rome",
      url: "https://www.britannica.com/place/ancient-Rome",
    },
    explanation: "The traditional founding of Rome in 753 BCE and the fall of the Western Roman Empire in 476 CE are 1,229 years apart.",
  },
  {
    id: "physics-duration-anglo-zanzibar-war",
    category: "history",
    measure: "physics",
    subtype: "duration",
    prompt: "How long did the Anglo-Zanzibar War of 1896, the shortest recorded war in history, last?",
    answer: 38,
    min: 5,
    max: 2000,
    scale: "log",
    unit: "minute",
    source: {
      title: "Encyclopaedia Britannica — Anglo-Zanzibar War",
      url: "https://www.britannica.com/event/Anglo-Zanzibar-War",
    },
    explanation: "Roughly 38 minutes on 27 August 1896. The bombardment began at about nine in the morning and the palace surrendered before ten.",
  },
  {
    id: "physics-duration-hundred-years-war",
    category: "history",
    measure: "physics",
    subtype: "duration",
    prompt: "How many years did the Hundred Years' War between England and France actually last?",
    answer: 116,
    min: 2,
    max: 500,
    scale: "log",
    unit: "duration-year",
    source: {
      title: "Encyclopaedia Britannica — Hundred Years' War",
      url: "https://www.britannica.com/event/Hundred-Years-War",
    },
    explanation: "116 years, from 1337 to 1453, and punctuated by long truces. The name was applied by historians long after it ended.",
  },
  {
    id: "geography-event-mount-st-helens-eruption",
    category: "geography",
    measure: "history",
    subtype: "event",
    prompt: "In what year did Mount St. Helens have its catastrophic modern eruption?",
    answer: 1980,
    min: 1900,
    max: 2025,
    scale: "linear",
    unit: "year",
    source: {
      title: "U.S. Geological Survey - 1980 Cataclysmic Eruption",
      url: "https://www.usgs.gov/volcanoes/mount-st.-helens/science/1980-cataclysmic-eruption",
    },
    explanation: "Mount St. Helens erupted catastrophically on 18 May 1980, triggering the largest landslide in recorded history.",
  },
  {
    id: "geography-event-surtsey-formation",
    category: "geography",
    measure: "history",
    subtype: "event",
    prompt: "In what year did the volcanic island of Surtsey first emerge above the sea?",
    answer: 1963,
    min: 1900,
    max: 2025,
    scale: "linear",
    unit: "year",
    source: {
      title: "UNESCO World Heritage Centre - Surtsey",
      url: "https://whc.unesco.org/en/list/1267/",
    },
    explanation: "Surtsey first emerged off Iceland in 1963, and eruptions continued building the new island until 1967.",
  },
  {
    id: "daily-english-channel-narrowest-width",
    category: "geography",
    measure: "size",
    subtype: "length",
    prompt: "How wide is the English Channel at its narrowest point?",
    answer: 34,
    min: 1,
    max: 60,
    scale: "log",
    unit: "kilometre",
    source: {
      title: "National Geographic - Channel",
      url: "https://education.nationalgeographic.org/resource/channel/",
    },
    explanation: "The English Channel narrows to about 34 kilometres between Dover and Cap Gris-Nez.",
  },
  {
    id: "daily-horseshoe-falls-width",
    category: "geography",
    measure: "size",
    subtype: "length",
    prompt: "How wide is the crest of Horseshoe Falls at Niagara Falls?",
    answer: 670,
    min: 15,
    max: 1200,
    scale: "log",
    unit: "metre",
    source: {
      title: "Niagara Parks - Niagara Falls Facts",
      url: "https://www.niagaraparks.com/visit-niagara-parks/plan-your-visit/niagara-falls-geology-facts-figures/",
    },
    explanation: "The curved crest of Horseshoe Falls is about 670 metres wide on the Canadian side of Niagara Falls.",
  },
  {
    id: "daily-mount-fuji-height",
    category: "geography",
    measure: "size",
    subtype: "length",
    prompt: "How high is the summit of Mount Fuji above sea level?",
    answer: 3776,
    min: 80,
    max: 6000,
    scale: "log",
    unit: "metre",
    source: {
      title: "Japan National Tourism Organization - Mt. Fuji",
      url: "https://www.japan.travel/en/fuji-guide/mt-fuji-more-than-a-mountain/",
    },
    explanation: "Mount Fuji reaches 3,776 metres above sea level, making it the highest mountain in Japan.",
  },
  {
    id: "daily-victoria-falls-width",
    category: "geography",
    measure: "size",
    subtype: "length",
    prompt: "How wide is Victoria Falls from one side of its curtain of water to the other?",
    answer: 1708,
    min: 30,
    max: 4000,
    scale: "log",
    unit: "metre",
    source: {
      title: "UNESCO World Heritage Centre - Mosi-oa-Tunya / Victoria Falls",
      url: "https://whc.unesco.org/en/list/509/",
    },
    explanation: "Victoria Falls forms a curtain of water about 1,708 metres wide on the border of Zambia and Zimbabwe.",
  },
  {
    id: "geography-length-andes",
    category: "geography",
    measure: "size",
    subtype: "length",
    prompt: "Approximately how long is the Andes mountain range?",
    answer: 7000,
    min: 1000,
    max: 20000,
    scale: "log",
    unit: "kilometre",
    source: {
      title: "NASA - Chilean Andes",
      url: "https://www.nasa.gov/image-article/chilean-andes/",
    },
    explanation: "The Andes stretch about 7,000 kilometres along western South America, making them the longest continental mountain range.",
  },
  {
    id: "geography-length-arctic-ocean-depth",
    category: "geography",
    measure: "size",
    subtype: "length",
    prompt: "What is the maximum depth of the Arctic Ocean?",
    answer: 5567,
    min: 500,
    max: 12000,
    scale: "log",
    unit: "metre",
    source: {
      title: "NOAA Ocean Service - The World's Smallest Ocean",
      url: "https://oceanservice.noaa.gov/facts/smallestocean.html",
    },
    explanation: "The Arctic Ocean reaches 5,567 metres at its deepest point, despite being the smallest and shallowest of the five ocean basins overall.",
  },
  {
    id: "geography-length-australia-coastline",
    category: "geography",
    measure: "size",
    subtype: "length",
    prompt: "Roughly how long is mainland Australia's coastline, excluding small offshore islands?",
    answer: 34000,
    min: 1000,
    max: 100000,
    scale: "log",
    unit: "kilometre",
    source: {
      title: "Geoscience Australia - Coasts and Estuaries",
      url: "https://www.ga.gov.au/scientific-topics/marine/coasts-estuaries",
    },
    explanation: "Mainland Australia has roughly 34,000 kilometres of coastline when small offshore islands are excluded.",
  },
  {
    id: "geography-length-badwater-basin-elevation",
    category: "geography",
    measure: "size",
    subtype: "length",
    prompt: "What is Badwater Basin's elevation relative to sea level?",
    answer: -86,
    min: -150,
    max: 50,
    scale: "linear",
    unit: "metre",
    source: {
      title: "U.S. National Park Service - Badwater Basin",
      url: "https://www.nps.gov/places/badwater-basin.htm",
    },
    explanation: "Badwater Basin lies 86 metres below sea level, making it the lowest point in North America; the negative answer marks that below-sea-level elevation.",
  },
  {
    id: "geography-length-bering-strait-width",
    category: "geography",
    measure: "size",
    subtype: "length",
    prompt: "About how wide is the Bering Strait between Alaska and Russia at its narrowest?",
    answer: 85,
    min: 20,
    max: 200,
    scale: "linear",
    unit: "kilometre",
    source: {
      title: "NOAA Fisheries - The Strait Connecting the Pacific and Arctic Oceans",
      url: "https://www.fisheries.noaa.gov/feature-story/strait-connecting-pacific-and-arctic-oceans-larger-previously-measured",
    },
    explanation: "Only about 85 kilometres separate mainland Alaska and Russia across the Bering Strait at their closest point.",
  },
  {
    id: "geography-length-crater-lake-depth",
    category: "geography",
    measure: "size",
    subtype: "length",
    prompt: "What is the maximum depth of Crater Lake in Oregon?",
    answer: 592,
    min: 100,
    max: 2000,
    scale: "log",
    unit: "metre",
    source: {
      title: "U.S. National Park Service - The World's Deepest Lakes",
      url: "https://www.nps.gov/crla/planyourvisit/upload/World-s-Deepest-Lakes-2017-508.pdf",
    },
    explanation: "Crater Lake reaches 592 metres at its deepest point, making it the deepest lake in the United States and one of the deepest on Earth.",
  },
  {
    id: "geography-length-denali-elevation",
    category: "geography",
    measure: "size",
    subtype: "length",
    prompt: "What is the elevation of Denali above sea level?",
    answer: 6190,
    min: 1000,
    max: 10000,
    scale: "linear",
    unit: "metre",
    source: {
      title: "U.S. National Park Service - Measuring Earth Movements from the Denali Fault",
      url: "https://home.nps.gov/articles/denali-fault-movement.htm",
    },
    explanation: "Denali reaches 6,190 metres above sea level, making it the highest mountain in North America.",
  },
  {
    id: "geography-length-great-salt-lake-depth",
    category: "geography",
    measure: "size",
    subtype: "length",
    prompt: "Roughly how deep is the Great Salt Lake at its deepest?",
    answer: 11,
    min: 1,
    max: 60,
    scale: "linear",
    unit: "metre",
    source: {
      title: "U.S. Geological Survey - Great Salt Lake Facts",
      url: "https://www.usgs.gov/centers/utah-water-science-center/science/general-information-facts-news-publications-and-partners",
    },
    explanation: "The Great Salt Lake is surprisingly shallow: its maximum depth is about 35 feet, or roughly 11 metres.",
  },
  {
    id: "geography-length-lake-tahoe-depth",
    category: "geography",
    measure: "size",
    subtype: "length",
    prompt: "What is the maximum depth of Lake Tahoe?",
    answer: 502,
    min: 50,
    max: 2000,
    scale: "log",
    unit: "metre",
    source: {
      title: "U.S. Geological Survey - Lake Tahoe Hydro Mapper",
      url: "https://www.usgs.gov/media/images/lake-tahoe-hydro-mapper",
    },
    explanation: "Lake Tahoe descends to about 502 metres, or 1,645 feet, which makes it the second-deepest lake in the United States.",
  },
  {
    id: "geography-length-mauna-kea-base-to-peak",
    category: "geography",
    measure: "size",
    subtype: "length",
    prompt: "How tall is Mauna Kea from its underwater base to its summit?",
    answer: 10210,
    min: 1000,
    max: 20000,
    scale: "log",
    unit: "metre",
    source: {
      title: "NOAA Ocean Service - Highest Point on Earth",
      url: "https://oceanservice.noaa.gov/facts/highestpoint.html",
    },
    explanation: "Measured from its base on the Pacific seafloor, Mauna Kea rises about 10,210 metres, taller base-to-peak than Mount Everest.",
  },
  {
    id: "geography-length-mid-ocean-ridge",
    category: "geography",
    measure: "size",
    subtype: "length",
    prompt: "Approximately how long is Earth's global mid-ocean ridge system?",
    answer: 65000,
    min: 5000,
    max: 150000,
    scale: "log",
    unit: "kilometre",
    source: {
      title: "NOAA Ocean Exploration - Mid-Ocean Ridge",
      url: "https://oceanexplorer.noaa.gov/ocean-fact/mid-ocean-ridge/",
    },
    explanation: "The connected mid-ocean ridge system runs for nearly 65,000 kilometres, with more than 90 percent of it hidden underwater.",
  },
  {
    id: "geography-length-uluru-rise",
    category: "geography",
    measure: "size",
    subtype: "length",
    prompt: "How high does Uluru rise above the surrounding plain?",
    answer: 340,
    min: 50,
    max: 1000,
    scale: "linear",
    unit: "metre",
    source: {
      title: "Parks Australia - Uluru-Kata Tjuta Media Handbook",
      url: "https://parksaustralia.gov.au/uluru/pub/uluru-kata-tjuta-media-handbook.pdf",
    },
    explanation: "Uluru rises about 340 metres above the plain, while much of the same sandstone formation continues unseen beneath the ground.",
  },
  {
    id: "size-length-angel-falls",
    category: "geography",
    measure: "size",
    subtype: "length",
    prompt: "What is the total drop of Angel Falls in Venezuela, the world's highest uninterrupted waterfall?",
    answer: 979,
    min: 50,
    max: 2000,
    scale: "log",
    unit: "metre",
    source: {
      title: "Encyclopaedia Britannica — Angel Falls",
      url: "https://www.britannica.com/place/Angel-Falls",
    },
    explanation: "Angel Falls drops about 979 metres, so far that much of the water disperses into mist before it reaches the bottom.",
  },
  {
    id: "size-length-challenger-deep",
    category: "geography",
    measure: "size",
    subtype: "length",
    prompt: "How deep is Challenger Deep, the deepest known point of the ocean floor?",
    answer: 10935,
    min: 500,
    max: 20000,
    scale: "log",
    unit: "metre",
    source: {
      title: "NOAA Ocean Exploration — How deep is the ocean?",
      url: "https://oceanexplorer.noaa.gov/facts/ocean-depth.html",
    },
    explanation: "Challenger Deep, in the Mariana Trench, reaches about 10,935 metres. Mount Everest would sit beneath the surface with two kilometres to spare.",
  },
  {
    id: "size-length-everest",
    category: "geography",
    measure: "size",
    subtype: "length",
    prompt: "What is the elevation of the summit of Mount Everest above sea level?",
    answer: 8849,
    min: 1000,
    max: 20000,
    scale: "log",
    unit: "metre",
    source: {
      title: "Encyclopaedia Britannica — Mount Everest",
      url: "https://www.britannica.com/place/Mount-Everest",
    },
    explanation: "China and Nepal jointly announced 8,848.86 metres in 2020, settling a long disagreement over whether to measure the rock or the snow cap.",
  },
  {
    id: "size-length-lake-baikal-depth",
    category: "geography",
    measure: "size",
    subtype: "length",
    prompt: "What is the maximum depth of Lake Baikal, the deepest lake in the world?",
    answer: 1642,
    min: 50,
    max: 5000,
    scale: "log",
    unit: "metre",
    source: {
      title: "Encyclopaedia Britannica — Lake Baikal",
      url: "https://www.britannica.com/place/Lake-Baikal",
    },
    explanation: "Baikal reaches about 1,642 metres deep and holds roughly a fifth of the world's unfrozen fresh surface water.",
  },
  {
    id: "size-length-nile",
    category: "geography",
    measure: "size",
    subtype: "length",
    prompt: "How long is the Nile, measured from its remotest headstream to the Mediterranean?",
    answer: 6650,
    min: 500,
    max: 20000,
    scale: "log",
    unit: "kilometre",
    source: {
      title: "Encyclopaedia Britannica — Nile River",
      url: "https://www.britannica.com/place/Nile-River",
    },
    explanation: "The Nile runs about 6,650 kilometres. Whether it or the Amazon is the longer river depends on where each is judged to begin.",
  },
  {
    id: "daily-vatican-city-area",
    category: "geography",
    measure: "size",
    subtype: "area",
    prompt: "How large is Vatican City, the world's smallest sovereign state?",
    answer: 0.49,
    min: 0.1,
    max: 1000000,
    scale: "log",
    unit: "square-kilometre",
    source: {
      title: "Encyclopaedia Britannica — Vatican City",
      url: "https://www.britannica.com/place/Vatican-City",
    },
    explanation: "Vatican City covers about 0.49 square kilometres, smaller than many city parks.",
  },
  {
    id: "geography-area-arctic-ocean",
    category: "geography",
    measure: "size",
    subtype: "area",
    prompt: "Approximately what area does the Arctic Ocean cover?",
    answer: 15600000,
    min: 1000000,
    max: 50000000,
    scale: "log",
    unit: "square-kilometre",
    source: {
      title: "NOAA Ocean Service - The World's Smallest Ocean",
      url: "https://oceanservice.noaa.gov/facts/smallestocean.html",
    },
    explanation: "The Arctic Ocean covers about 15.6 million square kilometres, an area roughly one and a half times the size of Europe.",
  },
  {
    id: "geography-area-australia",
    category: "geography",
    measure: "size",
    subtype: "area",
    prompt: "What is the total area of Australia?",
    answer: 7688287,
    min: 500000,
    max: 30000000,
    scale: "log",
    unit: "square-kilometre",
    source: {
      title: "Geoscience Australia - Australia's Size Compared",
      url: "https://www.ga.gov.au/scientific-topics/national-location-information/dimensions/australias-size-compared",
    },
    explanation: "Australia covers 7,688,287 square kilometres, accounting for about 5 percent of the world's land area.",
  },
  {
    id: "geography-area-everglades",
    category: "geography",
    measure: "size",
    subtype: "area",
    prompt: "Approximately what area does Everglades National Park cover?",
    answer: 6242,
    min: 500,
    max: 30000,
    scale: "log",
    unit: "square-kilometre",
    source: {
      title: "U.S. National Park Service - Everglades Park Statistics",
      url: "https://home.nps.gov/ever/learn/news/parkstatistics.htm",
    },
    explanation: "Everglades National Park spans about 6,242 square kilometres, converted from its official area of 2,410 square miles.",
  },
  {
    id: "geography-area-great-lakes",
    category: "geography",
    measure: "size",
    subtype: "area",
    prompt: "What is the combined water surface area of the five Great Lakes?",
    answer: 244160,
    min: 10000,
    max: 2000000,
    scale: "log",
    unit: "square-kilometre",
    source: {
      title: "U.S. Environmental Protection Agency - Physical Features of the Great Lakes",
      url: "https://www.epa.gov/greatlakes/physical-features-great-lakes",
    },
    explanation: "Together, Lakes Superior, Michigan, Huron, Erie and Ontario cover 244,160 square kilometres of water.",
  },
  {
    id: "geography-area-surtsey",
    category: "geography",
    measure: "size",
    subtype: "area",
    prompt: "Approximately what area does Iceland's volcanic island of Surtsey cover?",
    answer: 1.41,
    min: 0.1,
    max: 20,
    scale: "log",
    unit: "square-kilometre",
    source: {
      title: "UNESCO World Heritage Centre - Surtsey",
      url: "https://whc.unesco.org/en/list/1267/",
    },
    explanation: "Surtsey covers about 1.41 square kilometres, or 141 hectares, after emerging from the sea during volcanic eruptions.",
  },
  {
    id: "geography-area-yosemite",
    category: "geography",
    measure: "size",
    subtype: "area",
    prompt: "Approximately what area does Yosemite National Park cover?",
    answer: 3074,
    min: 500,
    max: 20000,
    scale: "log",
    unit: "square-kilometre",
    source: {
      title: "U.S. National Park Service - Yosemite Park Statistics",
      url: "https://www.nps.gov/yose/learn/management/statistics.htm",
    },
    explanation: "Yosemite covers about 3,074 square kilometres, converted from the National Park Service figure of 1,187 square miles.",
  },
  {
    id: "size-area-amazon-rainforest",
    category: "geography",
    measure: "size",
    subtype: "area",
    prompt: "How large is the Amazon rainforest?",
    answer: 5500000,
    min: 50000,
    max: 50000000,
    scale: "log",
    unit: "square-kilometre",
    source: {
      title: "Encyclopaedia Britannica — Amazon Rainforest",
      url: "https://www.britannica.com/place/Amazon-Rainforest",
    },
    explanation: "About 5.5 million square kilometres across nine countries, roughly 60 percent of it inside Brazil.",
  },
  {
    id: "size-area-antarctica",
    category: "geography",
    measure: "size",
    subtype: "area",
    prompt: "What is the area of Antarctica?",
    answer: 14200000,
    min: 100000,
    max: 100000000,
    scale: "log",
    unit: "square-kilometre",
    source: {
      title: "Encyclopaedia Britannica — Antarctica",
      url: "https://www.britannica.com/place/Antarctica",
    },
    explanation: "About 14.2 million square kilometres, making it larger than Europe and nearly twice the size of Australia.",
  },
  {
    id: "size-area-caspian-sea",
    category: "geography",
    measure: "size",
    subtype: "area",
    prompt: "What is the surface area of the Caspian Sea, the largest inland body of water on Earth?",
    answer: 371000,
    min: 1000,
    max: 2000000,
    scale: "log",
    unit: "square-kilometre",
    source: {
      title: "Encyclopaedia Britannica — Caspian Sea",
      url: "https://www.britannica.com/place/Caspian-Sea",
    },
    explanation: "About 371,000 square kilometres. Whether it counts as a lake or a sea has real consequences for how its oil is divided.",
  },
  {
    id: "size-area-great-barrier-reef",
    category: "geography",
    measure: "size",
    subtype: "area",
    prompt: "How large an area does the Great Barrier Reef cover?",
    answer: 344400,
    min: 1000,
    max: 5000000,
    scale: "log",
    unit: "square-kilometre",
    source: {
      title: "Encyclopaedia Britannica — Great Barrier Reef",
      url: "https://www.britannica.com/place/Great-Barrier-Reef",
    },
    explanation: "The reef system stretches over about 344,400 square kilometres off Queensland, large enough to be visible from orbit.",
  },
  {
    id: "size-area-greenland",
    category: "geography",
    measure: "size",
    subtype: "area",
    prompt: "What is the total area of Greenland, the world's largest island?",
    answer: 2166086,
    min: 10000,
    max: 20000000,
    scale: "log",
    unit: "square-kilometre",
    source: {
      title: "Encyclopaedia Britannica — Greenland",
      url: "https://www.britannica.com/place/Greenland",
    },
    explanation: "Greenland covers about 2.17 million square kilometres, roughly 80 percent of it under ice. Mercator maps exaggerate it enormously.",
  },
  {
    id: "size-area-lake-superior",
    category: "geography",
    measure: "size",
    subtype: "area",
    prompt: "What is the surface area of Lake Superior, the largest of the Great Lakes?",
    answer: 82100,
    min: 1000,
    max: 1000000,
    scale: "log",
    unit: "square-kilometre",
    source: {
      title: "Encyclopaedia Britannica — Lake Superior",
      url: "https://www.britannica.com/place/Lake-Superior-lake-North-America",
    },
    explanation: "About 82,100 square kilometres, the largest freshwater lake in the world by surface area.",
  },
  {
    id: "size-area-mediterranean-sea",
    category: "geography",
    measure: "size",
    subtype: "area",
    prompt: "What is the surface area of the Mediterranean Sea?",
    answer: 2510000,
    min: 10000,
    max: 20000000,
    scale: "log",
    unit: "square-kilometre",
    source: {
      title: "Encyclopaedia Britannica — Mediterranean Sea",
      url: "https://www.britannica.com/place/Mediterranean-Sea",
    },
    explanation: "About 2.51 million square kilometres, connected to the Atlantic by the Strait of Gibraltar, which is only 13 kilometres wide.",
  },
  {
    id: "size-area-pacific-ocean",
    category: "geography",
    measure: "size",
    subtype: "area",
    prompt: "What is the surface area of the Pacific Ocean?",
    answer: 165250000,
    min: 1000000,
    max: 500000000,
    scale: "log",
    unit: "square-kilometre",
    source: {
      title: "Encyclopaedia Britannica — Pacific Ocean",
      url: "https://www.britannica.com/place/Pacific-Ocean",
    },
    explanation: "At about 165 million square kilometres the Pacific covers more of the planet than every landmass put together.",
  },
  {
    id: "size-area-russia",
    category: "geography",
    measure: "size",
    subtype: "area",
    prompt: "What is the total area of Russia, the largest country in the world?",
    answer: 17098246,
    min: 100000,
    max: 100000000,
    scale: "log",
    unit: "square-kilometre",
    source: {
      title: "Encyclopaedia Britannica — Russia",
      url: "https://www.britannica.com/place/Russia",
    },
    explanation: "About 17.1 million square kilometres, close to an eighth of all the inhabited land on Earth.",
  },
  {
    id: "size-area-sahara",
    category: "geography",
    measure: "size",
    subtype: "area",
    prompt: "How large is the Sahara, the largest hot desert in the world?",
    answer: 9200000,
    min: 100000,
    max: 50000000,
    scale: "log",
    unit: "square-kilometre",
    source: {
      title: "Encyclopaedia Britannica — Sahara",
      url: "https://www.britannica.com/place/Sahara-desert-Africa",
    },
    explanation: "About 9.2 million square kilometres, close to the area of the United States, and it spans eleven countries.",
  },
  {
    id: "geography-count-african-un-members",
    category: "geography",
    measure: "quantity",
    subtype: "count",
    prompt: "According to the UN's 2025 count, how many African countries are United Nations members?",
    answer: 54,
    min: 10,
    max: 100,
    scale: "linear",
    unit: "count",
    referenceYear: "2025",
    source: {
      title: "United Nations Dag Hammarskjold Library - African Countries",
      url: "https://ask.un.org/faq/22882",
    },
    explanation: "The United Nations has 54 African member states, all of which belong to its African Group.",
  },
  {
    id: "geography-count-danube-countries",
    category: "geography",
    measure: "quantity",
    subtype: "count",
    prompt: "Through how many countries does the main Danube River flow?",
    answer: 10,
    min: 1,
    max: 30,
    scale: "linear",
    unit: "count",
    source: {
      title: "International Commission for the Protection of the Danube River - Basin Overview",
      url: "https://www.icpdr.org/danube-basin/danube-river-basin/danube-river-basin-overview-map",
    },
    explanation: "The main Danube flows through 10 countries; its wider drainage basin reaches nine more, making it the world's most international river basin.",
  },
  {
    id: "geography-count-eight-thousanders",
    category: "geography",
    measure: "quantity",
    subtype: "count",
    prompt: "How many mountain peaks on Earth rise above 8,000 metres?",
    answer: 14,
    min: 1,
    max: 40,
    scale: "linear",
    unit: "count",
    source: {
      title: "NASA Earth Observatory - 8,000-meter Peaks of the Himalaya and Karakoram",
      url: "https://science.nasa.gov/earth/earth-observatory/8000-meter-peaks-of-the-himalaya-and-karakoram-82581/",
    },
    explanation: "There are 14 peaks above 8,000 metres, and every one lies in the Himalayan or Karakoram mountain ranges of Asia.",
  },
  {
    id: "geography-count-japan-islands",
    category: "geography",
    measure: "quantity",
    subtype: "count",
    prompt: "According to Japan's 2022 digital-map survey, how many islands does Japan have?",
    answer: 14125,
    min: 500,
    max: 50000,
    scale: "log",
    unit: "count",
    referenceYear: "2022",
    source: {
      title: "Geospatial Information Authority of Japan - Number of Islands in Japan",
      url: "https://web1.gsi.go.jp/kihonjohochousa/islands_index.html",
    },
    explanation: "The 2022 survey counted 14,125 islands using digital mapping, more than double the total from the earlier paper-map count.",
  },
  {
    id: "geography-count-nile-countries",
    category: "geography",
    measure: "quantity",
    subtype: "count",
    prompt: "Through how many countries does the Nile River flow?",
    answer: 11,
    min: 1,
    max: 30,
    scale: "linear",
    unit: "count",
    source: {
      title: "Nile Basin Initiative - Major Subbasins",
      url: "https://nilebasin.org/en/media-center/maps/major-subbasins",
    },
    explanation: "The Nile flows through 11 countries across eastern and north-eastern Africa before reaching the Mediterranean Sea.",
  },
  {
    id: "geography-count-philippines-islands",
    category: "geography",
    measure: "quantity",
    subtype: "count",
    prompt: "According to the Philippine Department of Tourism's 2026 listing, how many islands make up the Philippines?",
    answer: 7641,
    min: 500,
    max: 30000,
    scale: "log",
    unit: "count",
    referenceYear: "2026",
    source: {
      title: "Philippine Department of Tourism - Island Hopping",
      url: "https://www.tourism.gov.ph/article/island-hopping-0-21/",
    },
    explanation: "The Philippines consists of 7,641 islands, grouped into the three broad regions of Luzon, Visayas and Mindanao.",
  },
  {
    id: "quantity-count-indonesia-islands",
    category: "geography",
    measure: "quantity",
    subtype: "count",
    prompt: "Roughly how many islands make up Indonesia?",
    answer: 17000,
    min: 100,
    max: 100000,
    scale: "log",
    unit: "count",
    source: {
      title: "Encyclopaedia Britannica — Indonesia",
      url: "https://www.britannica.com/place/Indonesia",
    },
    explanation: "About 17,000, of which only around 6,000 are inhabited. The archipelago stretches more than 5,000 kilometres from end to end.",
  },
  {
    id: "quantity-count-russia-time-zones",
    category: "geography",
    measure: "quantity",
    subtype: "count",
    prompt: "How many time zones does Russia span?",
    answer: 11,
    min: 2,
    max: 500,
    scale: "log",
    unit: "count",
    source: {
      title: "Encyclopaedia Britannica — Russia",
      url: "https://www.britannica.com/place/Russia",
    },
    explanation: "Eleven. When the working day begins in Kaliningrad on the Baltic, it is already evening in Kamchatka on the Pacific.",
  },
  {
    id: "quantity-count-un-member-states",
    category: "geography",
    measure: "quantity",
    subtype: "count",
    prompt: "How many member states does the United Nations have?",
    answer: 193,
    min: 5,
    max: 1000,
    scale: "log",
    unit: "count",
    source: {
      title: "United Nations — Member States",
      url: "https://www.un.org/en/about-us/member-states",
    },
    explanation: "193, the most recent being South Sudan in 2011. The UN began with 51 members in 1945.",
  },
  {
    id: "daily-share-of-earths-water-that-is-groundwater",
    category: "geography",
    measure: "quantity",
    subtype: "percentage",
    prompt: "What share of the world's fresh water is held underground as groundwater?",
    answer: 30,
    min: 0,
    max: 100,
    scale: "linear",
    unit: "percent",
    source: {
      title: "USGS Water Science School",
      url: "https://www.usgs.gov/special-topics/water-science-school",
    },
    explanation: "Roughly 30 per cent of fresh water is groundwater; most of the rest is locked in ice.",
  },
  {
    id: "daily-share-of-ocean-floor-mapped",
    category: "geography",
    measure: "quantity",
    subtype: "percentage",
    prompt: "What share of the ocean floor had been mapped to modern standards by 2023?",
    answer: 25,
    min: 0,
    max: 100,
    scale: "linear",
    unit: "percent",
    source: {
      title: "Nippon Foundation–GEBCO Seabed 2030",
      url: "https://seabed2030.org/",
    },
    explanation: "About a quarter of the seabed had been mapped at modern resolution, up from six per cent in 2017.",
  },
  {
    id: "daily-share-of-world-land-that-is-russia",
    category: "geography",
    measure: "quantity",
    subtype: "percentage",
    prompt: "What share of the world's land area does Russia cover?",
    answer: 11,
    min: 0,
    max: 100,
    scale: "linear",
    unit: "percent",
    source: {
      title: "Encyclopaedia Britannica — Russia",
      url: "https://www.britannica.com/place/Russia",
    },
    explanation: "At about 17 million square kilometres Russia covers roughly a ninth of the world's land.",
  },
  {
    id: "geography-percentage-antarctica-freshwater",
    category: "geography",
    measure: "quantity",
    subtype: "percentage",
    prompt: "Approximately what percentage of Earth's freshwater is held in Antarctica?",
    answer: 70,
    min: 0,
    max: 100,
    scale: "linear",
    unit: "percent",
    source: {
      title: "NASA Jet Propulsion Laboratory - RADARSAT Maps Antarctica",
      url: "https://www.jpl.nasa.gov/news/radarsat-begins-first-complete-detailed-map-of-antarctica/",
    },
    explanation: "Antarctica contains nearly 70 percent of Earth's freshwater, locked in an ice sheet that covers almost the entire continent.",
  },
  {
    id: "geography-percentage-great-lakes-surface-freshwater",
    category: "geography",
    measure: "quantity",
    subtype: "percentage",
    prompt: "About what percentage of the world's surface freshwater is held by the Great Lakes?",
    answer: 21,
    min: 0,
    max: 100,
    scale: "linear",
    unit: "percent",
    source: {
      title: "U.S. Environmental Protection Agency - Great Lakes Facts and Figures",
      url: "https://www.epa.gov/greatlakes/great-lakes-facts-and-figures",
    },
    explanation: "The five Great Lakes hold about 21 percent of the world's supply of surface freshwater by volume.",
  },
  {
    id: "geography-percentage-world-forest-cover-2025",
    category: "geography",
    measure: "quantity",
    subtype: "percentage",
    prompt: "What percentage of the world's land area was covered by forest in 2025?",
    answer: 31.81,
    min: 0,
    max: 100,
    scale: "linear",
    unit: "percent",
    referenceYear: "2025",
    source: {
      title: "UN Food and Agriculture Organization - Forest Area Indicator",
      url: "https://www.fao.org/sustainable-development-goals-data-portal/data/indicators/indicator-1511---forest-area-as-a-percentage-of-total-land-area/en",
    },
    explanation: "Forests covered 31.81 percent of global land area in 2025, according to the UN Food and Agriculture Organization.",
  },
  {
    id: "geography-percentage-world-mountain-cover",
    category: "geography",
    measure: "quantity",
    subtype: "percentage",
    prompt: "Approximately what percentage of Earth's land surface is covered by mountains?",
    answer: 27,
    min: 0,
    max: 100,
    scale: "linear",
    unit: "percent",
    source: {
      title: "UN Food and Agriculture Organization Mountain Partnership - Forests",
      url: "https://www.fao.org/mountain-partnership/our-work/thematic-areas/forests/en",
    },
    explanation: "Mountains cover around 27 percent of Earth's land surface and supply freshwater to more than half of humanity.",
  },
  {
    id: "quantity-percentage-agricultural-land",
    category: "geography",
    measure: "quantity",
    subtype: "percentage",
    prompt: "What share of the world's land area is used for agriculture, counting both cropland and pasture?",
    answer: 38,
    min: 0,
    max: 100,
    scale: "linear",
    unit: "percent",
    source: {
      title: "World Bank — Agricultural land (% of land area)",
      url: "https://data.worldbank.org/indicator/AG.LND.AGRI.ZS",
    },
    explanation: "About 38 percent. Grazing land accounts for roughly two-thirds of that, far more than the land used to grow crops.",
  },
  {
    id: "quantity-percentage-earth-land",
    category: "geography",
    measure: "quantity",
    subtype: "percentage",
    prompt: "What share of the Earth's land surface is covered by desert?",
    answer: 33,
    min: 0,
    max: 100,
    scale: "linear",
    unit: "percent",
    source: {
      title: "Encyclopaedia Britannica — Desert",
      url: "https://www.britannica.com/science/desert",
    },
    explanation: "About a third, counting both hot and cold deserts. Antarctica is the largest of them, since a desert is defined by rainfall rather than heat.",
  },
  {
    id: "quantity-percentage-fresh-water",
    category: "geography",
    measure: "quantity",
    subtype: "percentage",
    prompt: "What share of all the water on Earth is fresh water rather than salt water?",
    answer: 2.5,
    min: 0,
    max: 100,
    scale: "linear",
    unit: "percent",
    source: {
      title: "USGS Water Science School — How much water is there on Earth?",
      url: "https://www.usgs.gov/special-topics/water-science-school/science/how-much-water-there-earth",
    },
    explanation: "About 2.5 percent, and most of that is locked in ice caps and glaciers. Well under one percent of Earth's water is accessible fresh water.",
  },
  {
    id: "quantity-percentage-ocean-surface",
    category: "geography",
    measure: "quantity",
    subtype: "percentage",
    prompt: "What share of the Earth's surface is covered by ocean?",
    answer: 71,
    min: 0,
    max: 100,
    scale: "linear",
    unit: "percent",
    source: {
      title: "NOAA Ocean Service — How much water is in the ocean?",
      url: "https://oceanservice.noaa.gov/facts/oceanwater.html",
    },
    explanation: "About 71 percent. The ocean holds roughly 97 percent of the planet's water, and most of it has never been directly observed.",
  },
  {
    id: "physics-temperature-highest-recorded",
    category: "geography",
    measure: "physics",
    subtype: "temperature",
    prompt: "What is the highest air temperature reliably recorded at the Earth's surface?",
    answer: 56.7,
    min: -100,
    max: 100,
    scale: "linear",
    unit: "celsius",
    source: {
      title: "WMO Weather and Climate Extremes Archive",
      url: "https://wmo.asu.edu/",
    },
    explanation: "56.7°C at Furnace Creek in Death Valley on 10 July 1913. A higher 1922 reading from Libya was struck from the record in 2012.",
  },
  {
    id: "physics-temperature-lowest-recorded",
    category: "geography",
    measure: "physics",
    subtype: "temperature",
    prompt: "What is the lowest natural air temperature ever recorded at a weather station?",
    answer: -89.2,
    min: -150,
    max: 60,
    scale: "linear",
    unit: "celsius",
    source: {
      title: "WMO Weather and Climate Extremes Archive",
      url: "https://wmo.asu.edu/",
    },
    explanation: "−89.2°C at Vostok Station in Antarctica on 21 July 1983. Satellites have since measured colder patches of ice from orbit.",
  },
  {
    id: "daily-human-blood-vessel-length",
    category: "science",
    measure: "size",
    subtype: "length",
    prompt: "Roughly how long would all the blood vessels in a human body be if laid end to end?",
    answer: 96560,
    min: 60000,
    max: 4000000,
    scale: "log",
    unit: "kilometre",
    source: {
      title: "PubMed Central - Building Blood Vessel Chips with Enhanced Physiological Relevance",
      url: "https://pmc.ncbi.nlm.nih.gov/articles/PMC10489284/",
    },
    explanation: "The body's blood vessels total more than 96,000 kilometres, enough to circle Earth more than twice.",
  },
  {
    id: "science-length-human-cell-dna",
    category: "science",
    measure: "size",
    subtype: "length",
    prompt: "How long is the DNA in one human cell when completely unwound?",
    answer: 2,
    min: 0.1,
    max: 20,
    scale: "log",
    unit: "metre",
    source: {
      title: "NCBI Bookshelf — Physiology, DNA",
      url: "https://www.ncbi.nlm.nih.gov/books/NBK534207/",
    },
    explanation: "Roughly 2 metres. It fits inside a microscopic nucleus by wrapping tightly around proteins and folding into chromosomes.",
  },
  {
    id: "science-length-hunga-tonga-plume-2022",
    category: "science",
    measure: "size",
    subtype: "length",
    prompt: "How high did the 2022 Hunga Tonga eruption plume reach?",
    answer: 58,
    min: 5,
    max: 500,
    scale: "log",
    unit: "kilometre",
    source: {
      title: "NOAA Chemical Sciences Laboratory - Hunga Tonga Assessment",
      url: "https://csl.noaa.gov/assessments/hthh/outline.html",
    },
    explanation: "About 58 kilometres, reached within roughly 20 minutes. The plume punched beyond the stratosphere and into the mesosphere.",
  },
  {
    id: "science-length-icecube-depth",
    category: "science",
    measure: "size",
    subtype: "length",
    prompt: "How deep beneath Antarctic ice do IceCube’s sensors reach?",
    answer: 2450,
    min: 100,
    max: 10000,
    scale: "log",
    unit: "metre",
    source: {
      title: "IceCube — Detector",
      url: "https://icecube.wisc.edu/science/icecube/",
    },
    explanation: "2,450 metres. Thousands of light sensors are frozen into clear Antarctic ice to detect traces left by elusive neutrinos.",
  },
  {
    id: "science-length-kola-superdeep-borehole",
    category: "science",
    measure: "size",
    subtype: "length",
    prompt: "How deep did the Soviet Kola Superdeep Borehole reach?",
    answer: 12260,
    min: 1000,
    max: 100000,
    scale: "log",
    unit: "metre",
    source: {
      title: "USGS Volcano Watch - The Layered Earth Turns 100 Years Old",
      url: "https://www.usgs.gov/observatories/hvo/news/volcano-watch-layered-earth-turns-100-years-old",
    },
    explanation: "12,260 metres. Drilling stopped after mechanical problems and unexpectedly high temperatures made going deeper impractical.",
  },
  {
    id: "science-length-ligo-arm",
    category: "science",
    measure: "size",
    subtype: "length",
    prompt: "How long is each arm of the LIGO gravitational-wave observatory?",
    answer: 4,
    min: 0.5,
    max: 50,
    scale: "log",
    unit: "kilometre",
    source: {
      title: "LIGO Lab — A Gravitational-Wave Observatory",
      url: "https://www.ligo.caltech.edu/page/ligo-gw-interferometer",
    },
    explanation: "Four kilometres. Each LIGO detector has two perpendicular vacuum arms that let lasers measure distortions far smaller than an atomic nucleus.",
  },
  {
    id: "science-length-longest-human-axon",
    category: "science",
    measure: "size",
    subtype: "length",
    prompt: "How long can the human body’s longest axon be?",
    answer: 1,
    min: 0.1,
    max: 10,
    scale: "log",
    unit: "metre",
    source: {
      title: "NCBI Bookshelf — Molecular Biology of the Cell",
      url: "https://www.ncbi.nlm.nih.gov/books/NBK26930/",
    },
    explanation: "Up to 1 metre, running from the base of the spinal cord to the tip of the big toe.",
  },
  {
    id: "science-length-megaflash-southern-us-2020",
    category: "science",
    measure: "size",
    subtype: "length",
    prompt: "How far did the 29 April 2020 southern US megaflash extend?",
    answer: 768,
    min: 50,
    max: 5000,
    scale: "log",
    unit: "kilometre",
    source: {
      title: "WMO — Megaflash Lightning Records",
      url: "https://wmo.int/news/media-centre/wmo-certifies-two-megaflash-lightning-records",
    },
    explanation: "768 kilometres. Satellite data showed the single lightning flash stretching across parts of the southern United States.",
  },
  {
    id: "science-area-antarctic-ozone-hole-2015",
    category: "science",
    measure: "size",
    subtype: "area",
    prompt: "What area did Antarctica’s ozone hole reach on 2 October 2015?",
    answer: 28200000,
    min: 1000000,
    max: 100000000,
    scale: "log",
    unit: "square-kilometre",
    source: {
      title: "NASA Earth Observatory — Ozone Hole 2015",
      url: "https://science.nasa.gov/earth/earth-observatory/ozone-hole-2015-86869/",
    },
    explanation: "28.2 million square kilometres. That was its largest single-day area in 2015.",
  },
  {
    id: "science-area-great-pacific-garbage-patch-2018",
    category: "science",
    measure: "size",
    subtype: "area",
    prompt: "What area did a 2018 study assign to the Great Pacific Garbage Patch?",
    answer: 1600000,
    min: 100000,
    max: 10000000,
    scale: "log",
    unit: "square-kilometre",
    source: {
      title: "Scientific Reports - Evidence the Garbage Patch Is Accumulating Plastic",
      url: "https://www.nature.com/articles/s41598-018-22939-w",
    },
    explanation: "About 1.6 million square kilometres. It is a broad accumulation zone of scattered debris, not a solid island of rubbish.",
  },
  {
    id: "science-area-malheur-armillaria",
    category: "science",
    measure: "size",
    subtype: "area",
    prompt: "What area does Oregon’s Malheur Forest Armillaria fungus cover?",
    answer: 8.9,
    min: 0.5,
    max: 100,
    scale: "log",
    unit: "square-kilometre",
    source: {
      title: "Oregon State University — Our Strategic Advantage",
      url: "https://agsci.oregonstate.edu/home/about/our-strategic-advantage",
    },
    explanation: "About 8.9 square kilometres. Most of this vast fungus is a hidden network growing through soil and tree roots.",
  },
  {
    id: "science-area-tunguska-forest-1908",
    category: "science",
    measure: "size",
    subtype: "area",
    prompt: "What area of forest did the 1908 Tunguska explosion flatten?",
    answer: 2000,
    min: 100,
    max: 50000,
    scale: "log",
    unit: "square-kilometre",
    source: {
      title: "European Space Agency — Tunguska Event",
      url: "https://www.esa.int/Newsroom/Press_Releases/ESA_Studies_Missions_to_Safeguard_the_Earth",
    },
    explanation: "About 2,000 square kilometres. The incoming object exploded roughly 8 kilometres above Siberia instead of striking the ground.",
  },
  {
    id: "science-mass-antarctic-ice-loss-2002-2023",
    category: "science",
    measure: "size",
    subtype: "mass",
    prompt: "How much ice did Antarctica lose per year on average from 2002 to 2023?",
    answer: 150000000000,
    min: 1000000000,
    max: 10000000000000,
    scale: "log",
    unit: "tonne",
    source: {
      title: "NASA Science — Antarctic Ice Mass Loss 2002–2023",
      url: "https://science.nasa.gov/earth/antarctic-ice-mass-loss-2002-2023/",
    },
    explanation: "An average of 150 billion metric tonnes per year, based on measurements from the GRACE and GRACE-FO satellites.",
  },
  {
    id: "science-mass-cern-cms-detector",
    category: "science",
    measure: "size",
    subtype: "mass",
    prompt: "How much does CERN’s CMS particle detector weigh?",
    answer: 14000,
    min: 1000,
    max: 100000,
    scale: "log",
    unit: "tonne",
    source: {
      title: "CERN — CMS Experiment",
      url: "https://home.cern/science/experiments/cms/",
    },
    explanation: "14,000 tonnes. Much of that mass is the steel yoke surrounding CMS’s enormous superconducting magnet.",
  },
  {
    id: "science-mass-cumulus-cloud-water",
    category: "science",
    measure: "size",
    subtype: "mass",
    prompt: "How much water is in a one-cubic-kilometre cumulus cloud?",
    answer: 500000,
    min: 10000,
    max: 10000000,
    scale: "log",
    unit: "kilogram",
    source: {
      title: "USGS Water Science School — How Much Does a Cloud Weigh?",
      url: "https://www.usgs.gov/water-science-school/science/how-much-does-a-cloud-weigh",
    },
    explanation: "About 500,000 kilograms of water droplets. The cloud stays aloft because that water is spread through an enormous volume of air.",
  },
  {
    id: "science-mass-earth-dry-atmosphere",
    category: "science",
    measure: "size",
    subtype: "mass",
    prompt: "About how much mass is in Earth’s dry atmosphere?",
    answer: 5130000000000000000,
    min: 100000000000000000,
    max: 100000000000000000000,
    scale: "log",
    unit: "kilogram",
    source: {
      title: "NOAA Global Monitoring Laboratory — Greenhouse Gas FAQ",
      url: "https://gml.noaa.gov/infodata/faq_cat-3.html",
    },
    explanation: "About 5.13 quintillion kilograms, excluding water vapour. Gravity keeps this immense mass of gas wrapped around Earth.",
  },
  {
    id: "science-mass-human-bacteria-reference",
    category: "science",
    measure: "size",
    subtype: "mass",
    prompt: "About how much bacterial mass is in a reference 70 kg adult man?",
    answer: 0.2,
    min: 0.01,
    max: 10,
    scale: "log",
    unit: "kilogram",
    source: {
      title: "PLOS Biology - Revised Human and Bacteria Cell Estimates",
      url: "https://journals.plos.org/plosbiology/article?id=10.1371/journal.pbio.1002533",
    },
    explanation: "About 0.2 kilograms in wet weight, mostly in the colon - far below the older claim that people carry several kilograms of bacteria.",
  },
  {
    id: "science-mass-neutron-star-sugar-cube",
    category: "science",
    measure: "size",
    subtype: "mass",
    prompt: "How much would a sugar cube of neutron-star material weigh on Earth?",
    answer: 1000000000000,
    min: 1000000,
    max: 1000000000000000,
    scale: "log",
    unit: "kilogram",
    source: {
      title: "NASA Imagine the Universe - Neutron Stars",
      url: "https://imagine.gsfc.nasa.gov/science/objects/neutron_stars1.html",
    },
    explanation: "About 1 trillion kilograms - roughly the mass of a mountain squeezed into the volume of a sugar cube.",
  },
  {
    id: "daily-bones-a-baby-is-born-with",
    category: "science",
    measure: "quantity",
    subtype: "count",
    prompt: "How many bones is a human baby born with?",
    answer: 270,
    min: 20,
    max: 20000,
    scale: "log",
    unit: "count",
    source: {
      title: "Encyclopaedia Britannica — Human skeletal system",
      url: "https://www.britannica.com/science/human-skeleton",
    },
    explanation: "Babies start with about 270 bones; many fuse together, leaving 206 in an adult.",
  },
  {
    id: "daily-human-body-cell-count",
    category: "science",
    measure: "quantity",
    subtype: "count",
    prompt: "About how many human cells are in an adult body?",
    answer: 30000000000000,
    min: 15000000000000,
    max: 1000000000000000,
    scale: "log",
    unit: "count",
    source: {
      title: "National Institute of General Medical Sciences - Cells by the Numbers",
      url: "https://nigms.nih.gov/biobeat/2024/09/cells-by-the-numbers-2",
    },
    explanation: "NIGMS says adults have about 30 trillion human cells, with typical estimates varying by body size.",
  },
  {
    id: "daily-human-genome-base-pairs",
    category: "science",
    measure: "quantity",
    subtype: "count",
    prompt: "About how many DNA base pairs are in one copy of the human genome?",
    answer: 3000000000,
    min: 1500000000,
    max: 100000000000,
    scale: "log",
    unit: "count",
    source: {
      title: "National Human Genome Research Institute - Base Pair",
      url: "https://www.genome.gov/genetics-glossary/Base-Pair",
    },
    explanation: "One copy of the human genome contains about 3 billion DNA base pairs spread across 23 chromosomes.",
  },
  {
    id: "quantity-count-chemical-elements",
    category: "science",
    measure: "quantity",
    subtype: "count",
    prompt: "How many chemical elements are named on the periodic table?",
    answer: 118,
    min: 5,
    max: 500,
    scale: "log",
    unit: "count",
    source: {
      title: "IUPAC — Periodic Table of Elements",
      url: "https://iupac.org/what-we-do/periodic-table-of-elements/",
    },
    explanation: "118, up to oganesson. Everything beyond uranium is made in a laboratory, and the heaviest survive for only fractions of a second.",
  },
  {
    id: "quantity-count-human-bones",
    category: "science",
    measure: "quantity",
    subtype: "count",
    prompt: "How many bones are there in an adult human skeleton?",
    answer: 206,
    min: 10,
    max: 1000,
    scale: "log",
    unit: "count",
    source: {
      title: "Encyclopaedia Britannica — Human skeleton",
      url: "https://www.britannica.com/science/human-skeleton",
    },
    explanation: "206 in a typical adult. A newborn has roughly 270; many fuse together during childhood, particularly in the skull and spine.",
  },
  {
    id: "quantity-count-human-chromosomes",
    category: "science",
    measure: "quantity",
    subtype: "count",
    prompt: "How many chromosomes are there in a typical human body cell?",
    answer: 46,
    min: 2,
    max: 200,
    scale: "log",
    unit: "count",
    source: {
      title: "Encyclopaedia Britannica — Chromosome",
      url: "https://www.britannica.com/science/chromosome",
    },
    explanation: "46, arranged in 23 pairs. The correct count was only settled in 1956; textbooks had said 48 for more than thirty years.",
  },
  {
    id: "science-count-detectable-earthquakes-year",
    category: "science",
    measure: "quantity",
    subtype: "count",
    prompt: "About how many detectable earthquakes occur worldwide each year?",
    answer: 500000,
    min: 10000,
    max: 10000000,
    scale: "log",
    unit: "count",
    source: {
      title: "USGS — Cool Earthquake Facts",
      url: "https://www.usgs.gov/programs/earthquake-hazards/cool-earthquake-facts?qt-science_center_objects=0",
    },
    explanation: "About 500,000. Roughly 100,000 can be felt, while only a much smaller number cause damage.",
  },
  {
    id: "science-count-global-lightning-flashes",
    category: "science",
    measure: "quantity",
    subtype: "count",
    prompt: "About how many lightning flashes occur across Earth every second?",
    answer: 50,
    min: 1,
    max: 1000,
    scale: "log",
    unit: "count",
    source: {
      title: "NASA Earth Observatory - Sensing Lightning from the Space Station",
      url: "https://science.nasa.gov/earth/earth-observatory/sensing-lightning-from-the-space-station-83387/",
    },
    explanation: "About 50 every second - roughly 4.3 million flashes per day and 1.5 billion per year across Earth's atmosphere.",
  },
  {
    id: "science-count-neutrinos-through-body",
    category: "science",
    measure: "quantity",
    subtype: "count",
    prompt: "About how many neutrinos pass through your body every second?",
    answer: 100000000000000,
    min: 1000000000,
    max: 1000000000000000000,
    scale: "log",
    unit: "count",
    source: {
      title: "Fermilab MINERvA — Why Study Neutrinos?",
      url: "https://minerva.fnal.gov/why-study-neutrinos/",
    },
    explanation: "About 100 trillion. Neutrinos interact so weakly with matter that almost all of them pass straight through you unnoticed.",
  },
  {
    id: "daily-share-of-body-weight-that-is-brain",
    category: "science",
    measure: "quantity",
    subtype: "percentage",
    prompt: "What share of an adult's body weight is their brain?",
    answer: 2,
    min: 0,
    max: 100,
    scale: "linear",
    unit: "percent",
    source: {
      title: "Encyclopaedia Britannica — Human brain",
      url: "https://www.britannica.com/science/human-brain",
    },
    explanation: "The brain is about 2 per cent of body weight but uses roughly a fifth of the body's energy.",
  },
  {
    id: "daily-share-of-dry-air-that-is-oxygen",
    category: "science",
    measure: "quantity",
    subtype: "percentage",
    prompt: "What share of dry air at sea level is oxygen, by volume?",
    answer: 20.9,
    min: 0,
    max: 100,
    scale: "linear",
    unit: "percent",
    source: {
      title: "Encyclopaedia Britannica — Atmosphere",
      url: "https://www.britannica.com/science/atmosphere",
    },
    explanation: "Oxygen makes up about 20.9 per cent of dry air, with nitrogen taking most of the rest.",
  },
  {
    id: "quantity-percentage-atmosphere-nitrogen",
    category: "science",
    measure: "quantity",
    subtype: "percentage",
    prompt: "What share of dry air in the Earth's atmosphere is nitrogen, by volume?",
    answer: 78,
    min: 0,
    max: 100,
    scale: "linear",
    unit: "percent",
    source: {
      title: "NOAA JetStream — The atmosphere",
      url: "https://www.noaa.gov/jetstream/atmosphere",
    },
    explanation: "About 78 percent nitrogen and 21 percent oxygen. Everything else, carbon dioxide included, shares the remaining one percent.",
  },
  {
    id: "quantity-percentage-body-water",
    category: "science",
    measure: "quantity",
    subtype: "percentage",
    prompt: "What share of an adult human body is water, by weight?",
    answer: 60,
    min: 0,
    max: 100,
    scale: "linear",
    unit: "percent",
    source: {
      title: "USGS Water Science School — The water in you",
      url: "https://www.usgs.gov/special-topics/water-science-school/science/water-you-water-and-human-body",
    },
    explanation: "Around 60 percent in an average adult, varying with age and body composition. The brain and lungs are closer to 80 percent.",
  },
  {
    id: "science-percentage-brain-energy",
    category: "science",
    measure: "quantity",
    subtype: "percentage",
    prompt: "What percentage of body energy does the resting brain consume?",
    answer: 20,
    min: 0,
    max: 100,
    scale: "linear",
    unit: "percent",
    source: {
      title: "NCBI Bookshelf - Physiology, Brain",
      url: "https://www.ncbi.nlm.nih.gov/books/NBK551718/",
    },
    explanation: "About 20 percent, despite the brain representing only about 2 percent of total body weight.",
  },
  {
    id: "science-percentage-global-lactose-malabsorption",
    category: "science",
    measure: "quantity",
    subtype: "percentage",
    prompt: "About what percentage of people worldwide have lactose malabsorption?",
    answer: 68,
    min: 0,
    max: 100,
    scale: "linear",
    unit: "percent",
    source: {
      title: "NIDDK — Definition and Facts for Lactose Intolerance",
      url: "https://www.niddk.nih.gov/health-information/digestive-diseases/lactose-intolerance/definition-facts.",
    },
    explanation: "About 68 percent. Reduced lactose digestion after infancy is common worldwide, though not everyone develops symptoms.",
  },
  {
    id: "science-percentage-ocean-oxygen",
    category: "science",
    measure: "quantity",
    subtype: "percentage",
    prompt: "About what percentage of Earth’s oxygen is produced by the ocean?",
    answer: 50,
    min: 0,
    max: 100,
    scale: "linear",
    unit: "percent",
    source: {
      title: "NOAA Ocean Service — How Much Oxygen Comes from the Ocean?",
      url: "https://oceanservice.noaa.gov/facts/ocean-oxygen.html",
    },
    explanation: "About 50 percent. Most ocean oxygen production comes from microscopic photosynthetic plankton.",
  },
  {
    id: "science-percentage-undescribed-species-2011",
    category: "science",
    measure: "quantity",
    subtype: "percentage",
    prompt: "In a 2011 study, what percentage of Earth’s species awaited description?",
    answer: 86,
    min: 0,
    max: 100,
    scale: "linear",
    unit: "percent",
    source: {
      title: "PLOS Biology — How Many Species Are There on Earth?",
      url: "https://journals.plos.org/plosbiology/article?id=10.1371%2Fjournal.pbio.1001127",
    },
    explanation: "About 86 percent. The study estimated roughly 8.7 million eukaryotic species globally, with most still undescribed.",
  },
  {
    id: "physics-duration-carbon-14-half-life",
    category: "science",
    measure: "physics",
    subtype: "duration",
    prompt: "What is the half-life of carbon-14, the isotope used in radiocarbon dating?",
    answer: 5730,
    min: 50,
    max: 50000,
    scale: "log",
    unit: "duration-year",
    source: {
      title: "Encyclopaedia Britannica — Carbon-14",
      url: "https://www.britannica.com/science/carbon-14",
    },
    explanation: "About 5,730 years. That decay rate is why radiocarbon dating becomes unreliable much beyond 50,000 years, when too little is left to measure.",
  },
  {
    id: "physics-duration-neutron-half-life",
    category: "science",
    measure: "physics",
    subtype: "duration",
    prompt: "What is the half-life of a free neutron outside an atomic nucleus?",
    answer: 611,
    min: 1,
    max: 10000,
    scale: "log",
    unit: "second",
    source: {
      title: "Encyclopaedia Britannica — Neutron",
      url: "https://www.britannica.com/science/neutron",
    },
    explanation: "About 611 seconds, a little over ten minutes, after which it decays into a proton, an electron and an antineutrino. Bound inside a nucleus it is stable.",
  },
  {
    id: "science-duration-adult-skeleton-renewal",
    category: "science",
    measure: "physics",
    subtype: "duration",
    prompt: "About how many years does it take to replace most of an adult skeleton?",
    answer: 10,
    min: 1,
    max: 100,
    scale: "log",
    unit: "duration-year",
    source: {
      title: "NCBI Bookshelf - The Basics of Bone in Health and Disease",
      url: "https://www.ncbi.nlm.nih.gov/books/NBK45504/",
    },
    explanation: "About 10 years. Bone is living tissue and continually remodels.",
  },
  {
    id: "science-duration-drive-to-moon-60mph",
    category: "science",
    measure: "physics",
    subtype: "duration",
    prompt: "At 60 mph, roughly how many days would driving to the Moon take?",
    answer: 174,
    min: 20,
    max: 1000,
    scale: "log",
    unit: "day",
    source: {
      title: "NASA — Launch Into Math",
      url: "https://www.nasa.gov/wp-content/uploads/2023/12/launch-into-math1-solutions-508.pdf",
    },
    explanation: "About 174 days of nonstop driving. NASA’s calculation uses a 250,000-mile trip at a steady 60 miles per hour.",
  },
  {
    id: "science-duration-megaflash-south-america-2020",
    category: "science",
    measure: "physics",
    subtype: "duration",
    prompt: "How long did the 18 June 2020 South American megaflash last?",
    answer: 17.102,
    min: 1,
    max: 100,
    scale: "log",
    unit: "second",
    source: {
      title: "WMO — Megaflash Lightning Records",
      url: "https://wmo.int/news/media-centre/wmo-certifies-two-megaflash-lightning-records",
    },
    explanation: "17.102 seconds. The lightning flash developed continuously through a storm over Uruguay and northern Argentina.",
  },
  {
    id: "science-duration-red-blood-cell-lifespan",
    category: "science",
    measure: "physics",
    subtype: "duration",
    prompt: "What is the average lifespan of a human red blood cell?",
    answer: 120,
    min: 10,
    max: 1000,
    scale: "log",
    unit: "day",
    source: {
      title: "NCBI MeSH — Erythrocyte Aging",
      url: "https://www.ncbi.nlm.nih.gov/mesh/68004905",
    },
    explanation: "About 120 days. Old red blood cells are removed from circulation while bone marrow continually produces replacements.",
  },
  {
    id: "science-duration-uq-pitch-drop-first",
    category: "science",
    measure: "physics",
    subtype: "duration",
    prompt: "How many years did UQ’s first Pitch Drop take to fall?",
    answer: 8,
    min: 1,
    max: 100,
    scale: "log",
    unit: "duration-year",
    source: {
      title: "University of Queensland — Pitch Drop Experiment",
      url: "https://smp.uq.edu.au/pitch-drop-experiment",
    },
    explanation: "Eight years. The pitch looks solid at room temperature but flows so slowly that the experiment has produced only a handful of drops.",
  },
  {
    id: "daily-sound-speed-seawater",
    category: "science",
    measure: "physics",
    subtype: "speed",
    prompt: "Approximately how fast does sound travel through seawater?",
    answer: 5400,
    min: 120,
    max: 10000,
    scale: "log",
    unit: "kph",
    source: {
      title: "NOAA Ocean Service - How Far Does Sound Travel in the Ocean?",
      url: "https://oceanservice.noaa.gov/facts/sound.html",
    },
    explanation: "Sound travels through seawater at about 5,400 kilometres per hour, more than four times its speed in air.",
  },
  {
    id: "physics-speed-light",
    category: "science",
    measure: "physics",
    subtype: "speed",
    prompt: "How fast does light travel in a vacuum, expressed in kilometres per hour?",
    answer: 1079252849,
    min: 100000,
    max: 100000000000,
    scale: "log",
    unit: "kph",
    source: {
      title: "Encyclopaedia Britannica — Speed of light",
      url: "https://www.britannica.com/science/speed-of-light",
    },
    explanation: "Exactly 1,079,252,848.8 kilometres per hour. The figure is exact because the metre is now defined in terms of it.",
  },
  {
    id: "physics-speed-sound",
    category: "science",
    measure: "physics",
    subtype: "speed",
    prompt: "How fast does sound travel through dry air at sea level and 20°C?",
    answer: 1235,
    min: 20,
    max: 5000,
    scale: "log",
    unit: "kph",
    source: {
      title: "Encyclopaedia Britannica — Speed of sound",
      url: "https://www.britannica.com/science/speed-of-sound-physics",
    },
    explanation: "About 1,235 kilometres per hour, or 343 metres per second. Sound moves faster in warmer air, and much faster again through water and steel.",
  },
  {
    id: "physics-speed-usain-bolt",
    category: "science",
    measure: "physics",
    subtype: "speed",
    prompt: "What top speed did Usain Bolt reach during his 100 metres world record in 2009?",
    answer: 44,
    min: 2,
    max: 200,
    scale: "log",
    unit: "kph",
    referenceYear: "2009",
    source: {
      title: "Encyclopaedia Britannica — Usain Bolt",
      url: "https://www.britannica.com/biography/Usain-Bolt",
    },
    explanation: "About 44 kilometres per hour at his fastest, over a run averaging roughly 37. The record of 9.58 seconds still stands.",
  },
  {
    id: "science-speed-open-ocean-tsunami",
    category: "science",
    measure: "physics",
    subtype: "speed",
    prompt: "How fast can a tsunami travel across the open ocean?",
    answer: 800,
    min: 50,
    max: 3000,
    scale: "log",
    unit: "kph",
    source: {
      title: "NOAA Science On a Sphere — Sumatra Tsunami 2004",
      url: "https://sos.noaa.gov/catalog/datasets/tsunami-historical-series-sumatra-2004/",
    },
    explanation: "Up to about 800 kilometres per hour, comparable to a jet aircraft. The wave slows and grows taller as it reaches shallow water.",
  },
  {
    id: "science-speed-slab-avalanche",
    category: "science",
    measure: "physics",
    subtype: "speed",
    prompt: "How fast can a slab avalanche travel?",
    answer: 130,
    min: 10,
    max: 1000,
    scale: "log",
    unit: "kph",
    source: {
      title: "Avalanche Canada — Types of Avalanches",
      url: "https://avysavvy.avalanche.ca/en-ca/types-of-avalanches",
    },
    explanation: "Up to 130 kilometres per hour. A slab starts as one cohesive sheet before breaking apart as it descends.",
  },
  {
    id: "science-speed-thunder-sound",
    category: "science",
    measure: "physics",
    subtype: "speed",
    prompt: "About how fast does the sound of thunder travel through air?",
    answer: 1200,
    min: 100,
    max: 10000,
    scale: "log",
    unit: "kph",
    source: {
      title: "NOAA JetStream — Sound of Thunder",
      url: "https://prod-01-alb-www-noaa.woc.noaa.gov/jetstream/lightning/sound-of-thunder/learning-lesson-determining-distance-to-thunderstorm",
    },
    explanation: "About 1,200 kilometres per hour. Temperature changes the exact speed, but sound takes roughly three seconds to travel one kilometre.",
  },
  {
    id: "daily-dry-ice-sublimation-point",
    category: "science",
    measure: "physics",
    subtype: "temperature",
    prompt: "At what temperature does dry ice turn straight from solid to gas?",
    answer: -78.5,
    min: -273,
    max: 500,
    scale: "linear",
    unit: "celsius",
    source: {
      title: "Encyclopaedia Britannica — Dry ice",
      url: "https://www.britannica.com/science/dry-ice",
    },
    explanation: "Solid carbon dioxide sublimes at about -78.5 degrees Celsius without ever becoming liquid.",
  },
  {
    id: "daily-liquid-helium-boiling-point",
    category: "science",
    measure: "physics",
    subtype: "temperature",
    prompt: "At what temperature does liquid helium boil at atmospheric pressure?",
    answer: -269,
    min: -273,
    max: 100,
    scale: "linear",
    unit: "celsius",
    source: {
      title: "Encyclopaedia Britannica — Helium",
      url: "https://www.britannica.com/science/helium-chemical-element",
    },
    explanation: "Helium boils at about -269 degrees Celsius, only four degrees above absolute zero.",
  },
  {
    id: "physics-temperature-earth-core",
    category: "science",
    measure: "physics",
    subtype: "temperature",
    prompt: "Roughly how hot is the Earth's inner core?",
    answer: 5200,
    min: 0,
    max: 20000,
    scale: "linear",
    unit: "celsius",
    source: {
      title: "Encyclopaedia Britannica — Earth: the interior",
      url: "https://www.britannica.com/place/Earth/The-interior",
    },
    explanation: "Around 5,200°C, comparable to the surface of the Sun. It stays solid despite the heat because the pressure there is immense.",
  },
  {
    id: "physics-temperature-iron-melting",
    category: "science",
    measure: "physics",
    subtype: "temperature",
    prompt: "At what temperature does pure iron melt?",
    answer: 1538,
    min: 0,
    max: 5000,
    scale: "linear",
    unit: "celsius",
    source: {
      title: "Encyclopaedia Britannica — Iron",
      url: "https://www.britannica.com/science/iron-chemical-element",
    },
    explanation: "1,538°C. Early smiths could never reach it, so wrought iron was worked hot and soft rather than cast as a liquid.",
  },
  {
    id: "physics-temperature-lightning",
    category: "science",
    measure: "physics",
    subtype: "temperature",
    prompt: "How hot does the air in a lightning channel get?",
    answer: 30000,
    min: 1000,
    max: 100000,
    scale: "linear",
    unit: "celsius",
    source: {
      title: "NOAA National Weather Service — Lightning safety",
      url: "https://www.weather.gov/safety/lightning",
    },
    explanation: "Around 30,000°C, roughly five times hotter than the surface of the Sun. The air expands so violently that the shock wave is heard as thunder.",
  },
  {
    id: "physics-temperature-nitrogen-boiling",
    category: "science",
    measure: "physics",
    subtype: "temperature",
    prompt: "At what temperature does liquid nitrogen boil at normal atmospheric pressure?",
    answer: -196,
    min: -273,
    max: 100,
    scale: "linear",
    unit: "celsius",
    source: {
      title: "Encyclopaedia Britannica — Nitrogen",
      url: "https://www.britannica.com/science/nitrogen",
    },
    explanation: "−196°C. Because it boils away steadily at room temperature, liquid nitrogen has to be stored in vented containers rather than sealed ones.",
  },
  {
    id: "science-temperature-absolute-zero",
    category: "science",
    measure: "physics",
    subtype: "temperature",
    prompt: "What temperature is absolute zero on the Celsius scale?",
    answer: -273.15,
    min: -400,
    max: 100,
    scale: "linear",
    unit: "celsius",
    source: {
      title: "NIST — About Cryogenics",
      url: "https://www.nist.gov/mml/acmd/cryogenic-technologies-project/about-cryogenics",
    },
    explanation: "Exactly −273.15°C. It is the theoretical point at which a system has the least thermal energy allowed by quantum mechanics.",
  },
  {
    id: "science-temperature-everest-boiling-water",
    category: "science",
    measure: "physics",
    subtype: "temperature",
    prompt: "About what temperature does water boil at Mount Everest’s summit?",
    answer: 70,
    min: -50,
    max: 150,
    scale: "linear",
    unit: "celsius",
    source: {
      title: "Royal Meteorological Society MetLink — Air Pressure",
      url: "https://www.metlink.org/experiment_topic/air-pressure/",
    },
    explanation: "About 70 degrees Celsius. Lower air pressure at the summit reduces water’s boiling point far below the sea-level value.",
  },
  {
    id: "science-temperature-gallium-melting",
    category: "science",
    measure: "physics",
    subtype: "temperature",
    prompt: "At what temperature does high-purity gallium melt?",
    answer: 29.7646,
    min: -50,
    max: 100,
    scale: "linear",
    unit: "celsius",
    source: {
      title: "NIST - Gallium Melting-Point Standard",
      url: "https://www.nist.gov/publications/standard-reference-material-1751-gallium-melting-point-standard",
    },
    explanation: "29.7646 degrees Celsius. Gallium has a precisely known melting point used as a fixed reference in modern thermometry.",
  },
  {
    id: "science-temperature-rhic-quark-gluon-2010",
    category: "science",
    measure: "physics",
    subtype: "temperature",
    prompt: "What temperature did RHIC’s quark-gluon plasma reach in 2010?",
    answer: 4000000000000,
    min: 0,
    max: 10000000000000,
    scale: "linear",
    unit: "celsius",
    source: {
      title: "Brookhaven National Laboratory — RHIC Physics",
      url: "https://www.bnl.gov/newsroom/news.php?a=111074",
    },
    explanation: "About 4 trillion degrees Celsius. The collision recreated a state of matter thought to have filled the very early universe.",
  },
  {
    id: "animals-length-arctic-tern-annual-migration",
    category: "animals",
    measure: "size",
    subtype: "length",
    prompt: "How far can an Arctic tern fly on its annual migration, in kilometres?",
    answer: 70000,
    min: 1000,
    max: 250000,
    scale: "log",
    unit: "kilometre",
    referenceYear: "2026",
    source: {
      title: "British Antarctic Survey - Arctic Terns",
      url: "https://www.bas.ac.uk/news/arctic-terns-confirmed-to-have-the-longest-animal-migration-in-the-world/",
    },
    explanation: "British Antarctic Survey research found Arctic terns travel more than 70,000 km on their annual pole-to-pole migration.",
  },
  {
    id: "animals-length-black-rhino-front-horn",
    category: "animals",
    measure: "size",
    subtype: "length",
    prompt: "How long can a black rhino's front horn grow?",
    answer: 1.3,
    min: 0.2,
    max: 2.5,
    scale: "linear",
    unit: "metre",
    source: {
      title: "San Diego Zoo Wildlife Alliance — Rhinoceros",
      url: "https://animals.sandiegozoo.org/animals/rhinoceros",
    },
    explanation: "Black rhinos grow the longest horns of any rhino, with the front horn reaching 1.3 metres (4 feet) of compacted keratin — the same material as your fingernails.",
  },
  {
    id: "animals-length-blue-whale-maximum",
    category: "animals",
    measure: "size",
    subtype: "length",
    prompt: "How long can the largest blue whales grow?",
    answer: 33.5,
    min: 10,
    max: 60,
    scale: "linear",
    unit: "metre",
    source: {
      title: "NOAA Fisheries — Blue Whale",
      url: "https://www.fisheries.noaa.gov/species/blue-whale",
    },
    explanation: "Antarctic blue whales reach about 110 feet, or 33.5 metres — longer than a basketball court and the largest animal that has ever lived.",
  },
  {
    id: "animals-length-giant-manta-ray-disc-width",
    category: "animals",
    measure: "size",
    subtype: "length",
    prompt: "How wide can a giant manta ray measure from wingtip to wingtip?",
    answer: 7.9,
    min: 1,
    max: 15,
    scale: "linear",
    unit: "metre",
    source: {
      title: "NOAA Fisheries — Giant Manta Ray",
      url: "https://www.fisheries.noaa.gov/species/giant-manta-ray",
    },
    explanation: "The world's largest ray spans up to 26 feet — about 7.9 metres — while weighing as much as 5,300 pounds.",
  },
  {
    id: "animals-length-giant-squid",
    category: "animals",
    measure: "size",
    subtype: "length",
    prompt: "How long was the largest giant squid recorded by scientists, in metres?",
    answer: 13,
    min: 1,
    max: 50,
    scale: "log",
    unit: "metre",
    referenceYear: "2026",
    source: {
      title: "Smithsonian National Museum of Natural History - Giant Squid",
      url: "https://naturalhistory.si.edu/explore/giant-squid",
    },
    explanation: "The Smithsonian says the largest giant squid recorded by scientists was almost 43 feet, or about 13 metres, long.",
  },
  {
    id: "animals-length-giraffe-male-height",
    category: "animals",
    measure: "size",
    subtype: "length",
    prompt: "How tall can an adult male giraffe stand?",
    answer: 5.5,
    min: 2,
    max: 10,
    scale: "linear",
    unit: "metre",
    source: {
      title: "San Diego Zoo Wildlife Alliance — Giraffe",
      url: "https://animals.sandiegozoo.org/animals/giraffe",
    },
    explanation: "Males reach 5.5 metres (18 feet), tall enough to peer into a second-storey window, with a neck alone weighing about 272 kilograms.",
  },
  {
    id: "animals-length-goliath-birdeater-leg-span",
    category: "animals",
    measure: "size",
    subtype: "length",
    prompt: "How wide is the leg span of a Goliath bird-eating spider, the largest tarantula?",
    answer: 0.28,
    min: 0.05,
    max: 0.6,
    scale: "linear",
    unit: "metre",
    source: {
      title: "San Diego Zoo Wildlife Alliance — Tarantula",
      url: "https://animals.sandiegozoo.org/animals/tarantula",
    },
    explanation: "Male Goliath bird-eaters span 28 centimetres across the legs — about the size of a dinner plate.",
  },
  {
    id: "animals-length-greater-flamingo-height",
    category: "animals",
    measure: "size",
    subtype: "length",
    prompt: "How tall can a greater flamingo stand?",
    answer: 1.45,
    min: 0.5,
    max: 2.5,
    scale: "linear",
    unit: "metre",
    source: {
      title: "San Diego Zoo Wildlife Alliance — Flamingo",
      url: "https://animals.sandiegozoo.org/animals/flamingo",
    },
    explanation: "The greater flamingo reaches 145 centimetres, roughly eye-to-eye with a ten-year-old child, yet weighs only about 4 kilograms.",
  },
  {
    id: "animals-length-lion-roar-audible-distance",
    category: "animals",
    measure: "size",
    subtype: "length",
    prompt: "How far away can a lion's roar be heard?",
    answer: 4.8,
    min: 0.5,
    max: 20,
    scale: "log",
    unit: "kilometre",
    source: {
      title: "San Diego Zoo Wildlife Alliance — Lion",
      url: "https://animals.sandiegozoo.org/animals/lion",
    },
    explanation: "A lion's roar carries about 4.8 kilometres (3 miles) across the savanna, which is how prides advertise their territory without moving a paw.",
  },
  {
    id: "animals-length-narwhal-tusk",
    category: "animals",
    measure: "size",
    subtype: "length",
    prompt: "How long can a narwhal's tusk grow?",
    answer: 3,
    min: 0.5,
    max: 8,
    scale: "linear",
    unit: "metre",
    source: {
      title: "NOAA Fisheries — Narwhal",
      url: "https://www.fisheries.noaa.gov/species/narwhal",
    },
    explanation: "The spiralled tusk — actually an overgrown left canine tooth — can reach 3 metres (9.8 feet) and weigh over 20 pounds.",
  },
  {
    id: "daily-monarch-butterfly-migration-distance",
    category: "animals",
    measure: "size",
    subtype: "length",
    prompt: "How far can a monarch butterfly migrate to reach its wintering grounds?",
    answer: 4828,
    min: 60,
    max: 10000,
    scale: "log",
    unit: "kilometre",
    source: {
      title: "National Park Service - Around the Country with the Monarch Butterfly",
      url: "https://www.nps.gov/articles/monarch-cross-country.htm",
    },
    explanation: "Some monarch butterflies migrate up to about 4,828 kilometres to reach wintering forests in central Mexico.",
  },
  {
    id: "daily-red-kangaroo-bound-length",
    category: "animals",
    measure: "size",
    subtype: "length",
    prompt: "How far can a red kangaroo travel in a single bound?",
    answer: 8,
    min: 0.5,
    max: 12,
    scale: "log",
    unit: "metre",
    source: {
      title: "Australian Museum - Swifter, Higher, Stronger",
      url: "https://australian.museum/blog/museullaneous/Swifter-Higher-Stronger/",
    },
    explanation: "A red kangaroo can cover as much as eight metres in a single bound when moving quickly.",
  },
  {
    id: "daily-whale-shark-maximum-length",
    category: "animals",
    measure: "size",
    subtype: "length",
    prompt: "About how long can a whale shark grow?",
    answer: 12.2,
    min: 0.6,
    max: 25,
    scale: "log",
    unit: "metre",
    source: {
      title: "NOAA Fisheries - Shark Identification",
      url: "https://www.fisheries.noaa.gov/new-england-mid-atlantic/atlantic-highly-migratory-species/shark-identification-cooperative-shark-0",
    },
    explanation: "Whale sharks can grow to about 12.2 metres long, making them the largest living fish.",
  },
  {
    id: "animals-area-yellowstone-wolf-pack-home-range",
    category: "animals",
    measure: "size",
    subtype: "area",
    prompt: "How large is the average wolf pack home range on Yellowstone's northern range?",
    answer: 274,
    min: 10,
    max: 3000,
    scale: "log",
    unit: "square-kilometre",
    source: {
      title: "U.S. National Park Service — Yellowstone Wolf Ecology",
      url: "https://www.nps.gov/yell/learn/nature/wolf.htm",
    },
    explanation: "Northern-range packs patrol about 274 square kilometres each, while packs in the park's interior roam more than twice that area.",
  },
  {
    id: "animals-mass-antarctic-krill-biomass",
    category: "animals",
    measure: "size",
    subtype: "mass",
    prompt: "What is the estimated total weight of all the Antarctic krill in the Southern Ocean?",
    answer: 400000000,
    min: 1000000,
    max: 5000000000,
    scale: "log",
    unit: "tonne",
    source: {
      title: "Australian Antarctic Program — Krill",
      url: "https://www.antarctica.gov.au/about-antarctica/animals/krill/",
    },
    explanation: "Around 400 million tonnes of these shrimp-like creatures drift in the Southern Ocean, making them one of the most abundant animals on Earth by sheer mass.",
  },
  {
    id: "animals-mass-galapagos-tortoise-male",
    category: "animals",
    measure: "size",
    subtype: "mass",
    prompt: "How much can a large male Galápagos giant tortoise weigh?",
    answer: 260,
    min: 20,
    max: 1000,
    scale: "log",
    unit: "kilogram",
    source: {
      title: "San Diego Zoo Wildlife Alliance — Galápagos Tortoise",
      url: "https://animals.sandiegozoo.org/animals/galapagos-tortoise",
    },
    explanation: "Males reach about 260 kilograms (573 pounds), roughly three times the weight of the females they share the islands with.",
  },
  {
    id: "animals-mass-gorilla-adult-male",
    category: "animals",
    measure: "size",
    subtype: "mass",
    prompt: "What does a large adult male gorilla weigh?",
    answer: 181,
    min: 40,
    max: 500,
    scale: "log",
    unit: "kilogram",
    source: {
      title: "San Diego Zoo Wildlife Alliance — Gorilla",
      url: "https://animals.sandiegozoo.org/animals/gorilla",
    },
    explanation: "A silverback tops out around 181 kilograms (400 pounds) — heavy, but only about double a grown man, despite the fearsome reputation.",
  },
  {
    id: "animals-mass-northern-elephant-seal-male",
    category: "animals",
    measure: "size",
    subtype: "mass",
    prompt: "How much can a fully grown male northern elephant seal weigh?",
    answer: 2000,
    min: 200,
    max: 6000,
    scale: "log",
    unit: "kilogram",
    source: {
      title: "NOAA Fisheries — Northern Elephant Seal",
      url: "https://www.fisheries.noaa.gov/species/northern-elephant-seal",
    },
    explanation: "Bulls reach nearly 4,400 pounds, about 2,000 kilograms, which is roughly three times the weight of the females they tower over on the beach.",
  },
  {
    id: "animals-mass-polar-bear",
    category: "animals",
    measure: "size",
    subtype: "mass",
    prompt: "What does an adult male polar bear typically weigh?",
    answer: 450,
    min: 30,
    max: 1500,
    scale: "log",
    unit: "kilogram",
    source: {
      title: "World Wildlife Fund — Polar bear",
      url: "https://www.worldwildlife.org/species/polar-bear",
    },
    explanation: "Around 450 kilograms for a typical adult male, though the largest individuals exceed 700.",
  },
  {
    id: "daily-bee-hummingbird-mass",
    category: "animals",
    measure: "size",
    subtype: "mass",
    prompt: "How much does a bee hummingbird, the world's smallest bird, weigh?",
    answer: 0.002,
    min: 0.001,
    max: 100,
    scale: "log",
    unit: "kilogram",
    source: {
      title: "Encyclopaedia Britannica — Hummingbird",
      url: "https://www.britannica.com/animal/hummingbird",
    },
    explanation: "The bee hummingbird weighs about two grams, less than a common paperclip.",
  },
  {
    id: "size-mass-african-elephant",
    category: "animals",
    measure: "size",
    subtype: "mass",
    prompt: "What does an adult male African bush elephant weigh?",
    answer: 6000,
    min: 50,
    max: 50000,
    scale: "log",
    unit: "kilogram",
    source: {
      title: "World Wildlife Fund — African elephant",
      url: "https://www.worldwildlife.org/species/african-elephant",
    },
    explanation: "About 6,000 kilograms, which makes the African bush elephant the largest land animal alive today.",
  },
  {
    id: "size-mass-blue-whale",
    category: "animals",
    measure: "size",
    subtype: "mass",
    prompt: "What does a large adult blue whale weigh?",
    answer: 150000,
    min: 100,
    max: 1000000,
    scale: "log",
    unit: "kilogram",
    source: {
      title: "NOAA Fisheries — Blue whale",
      url: "https://www.fisheries.noaa.gov/species/blue-whale",
    },
    explanation: "Around 150,000 kilograms, making the blue whale the heaviest animal known to have existed, heavier than any dinosaur yet found.",
  },
  {
    id: "size-mass-giraffe",
    category: "animals",
    measure: "size",
    subtype: "mass",
    prompt: "What does an adult male giraffe weigh?",
    answer: 1200,
    min: 10,
    max: 10000,
    scale: "log",
    unit: "kilogram",
    source: {
      title: "Encyclopaedia Britannica — Giraffe",
      url: "https://www.britannica.com/animal/giraffe",
    },
    explanation: "About 1,200 kilograms. Its neck alone can weigh 250 kilograms, yet contains the same seven vertebrae as a human neck.",
  },
  {
    id: "animals-count-alligator-lifetime-teeth",
    category: "animals",
    measure: "quantity",
    subtype: "count",
    prompt: "How many teeth can an American alligator go through in its lifetime?",
    answer: 3000,
    min: 80,
    max: 20000,
    scale: "log",
    unit: "count",
    source: {
      title: "Smithsonian's National Zoo — American Alligator",
      url: "https://nationalzoo.si.edu/animals/american-alligator",
    },
    explanation: "An alligator holds 74 to 80 teeth at a time but replaces them endlessly, working through some 3,000 over a life of about 50 years.",
  },
  {
    id: "animals-count-bald-eagle-breeding-pairs-1963",
    category: "animals",
    measure: "quantity",
    subtype: "count",
    prompt: "At their lowest point in 1963, how many breeding pairs of bald eagles were left in the lower 48 states?",
    answer: 417,
    min: 50,
    max: 50000,
    scale: "log",
    unit: "count",
    referenceYear: "1963",
    source: {
      title: "Smithsonian's National Zoo — Bald Eagle",
      url: "https://nationalzoo.si.edu/animals/bald-eagle",
    },
    explanation: "Just 417 breeding pairs remained in 1963; after DDT was banned the population rebounded to more than 71,400 pairs by 2020.",
  },
  {
    id: "animals-count-carlsbad-cavern-bat-colony",
    category: "animals",
    measure: "quantity",
    subtype: "count",
    prompt: "Roughly how many Brazilian free-tailed bats made up Carlsbad Cavern's resident summer colony in 2005?",
    answer: 400000,
    min: 10000,
    max: 5000000,
    scale: "log",
    unit: "count",
    referenceYear: "2005",
    source: {
      title: "U.S. National Park Service — Bats of Carlsbad Caverns",
      url: "https://www.nps.gov/cave/learn/nature/bats.htm",
    },
    explanation: "About 400,000 bats formed the summer colony in 2005, and migration pushed the cavern's total as high as 793,000 that same year.",
  },
  {
    id: "animals-count-chameleon-species",
    category: "animals",
    measure: "quantity",
    subtype: "count",
    prompt: "According to San Diego Zoo Wildlife Alliance's 2026 listing, how many chameleon species are there?",
    answer: 158,
    min: 20,
    max: 1000,
    scale: "log",
    unit: "count",
    referenceYear: "2026",
    source: {
      title: "San Diego Zoo Wildlife Alliance — Chameleon",
      url: "https://animals.sandiegozoo.org/animals/chameleon",
    },
    explanation: "There are 158 chameleon species, and nearly two-thirds of them live nowhere but Madagascar.",
  },
  {
    id: "animals-count-giant-anteater-tongue-flicks",
    category: "animals",
    measure: "quantity",
    subtype: "count",
    prompt: "How many times per minute can a giant anteater flick its tongue in and out?",
    answer: 150,
    min: 10,
    max: 600,
    scale: "log",
    unit: "count",
    source: {
      title: "Smithsonian's National Zoo — Giant Anteater",
      url: "https://nationalzoo.si.edu/animals/giant-anteater",
    },
    explanation: "The tongue darts up to 150 times a minute — two and a half flicks every second — though the anteater takes only about 140 insects from each mound before moving on.",
  },
  {
    id: "animals-count-green-turtle-eggs-per-nest",
    category: "animals",
    measure: "quantity",
    subtype: "count",
    prompt: "About how many eggs does a green sea turtle lay in one nest?",
    answer: 110,
    min: 10,
    max: 600,
    scale: "log",
    unit: "count",
    source: {
      title: "NOAA Fisheries — Green Turtle",
      url: "https://www.fisheries.noaa.gov/species/green-turtle",
    },
    explanation: "Each nest holds about 110 eggs, buried in warm sand for roughly two months before the hatchlings dig out and race for the sea.",
  },
  {
    id: "animals-count-honeybee-queen-eggs-per-day",
    category: "animals",
    measure: "quantity",
    subtype: "count",
    prompt: "How many eggs can a honeybee queen lay in a single day?",
    answer: 2000,
    min: 50,
    max: 20000,
    scale: "log",
    unit: "count",
    source: {
      title: "San Diego Zoo Wildlife Alliance — Bee",
      url: "https://animals.sandiegozoo.org/animals/bee",
    },
    explanation: "A queen lays up to 2,000 eggs a day — more than her own body weight — and keeps it up for two to five years.",
  },
  {
    id: "animals-count-meerkat-burrow-entrances",
    category: "animals",
    measure: "quantity",
    subtype: "count",
    prompt: "On average, how many entrance and exit holes does a meerkat burrow have?",
    answer: 15,
    min: 1,
    max: 60,
    scale: "linear",
    unit: "count",
    source: {
      title: "San Diego Zoo Wildlife Alliance — Meerkat",
      url: "https://animals.sandiegozoo.org/animals/meerkat",
    },
    explanation: "A typical burrow has about 15 doorways leading into tunnels that run 2 metres deep, so a meerkat is never far from an escape route.",
  },
  {
    id: "animals-count-porcupine-quills",
    category: "animals",
    measure: "quantity",
    subtype: "count",
    prompt: "Roughly how many quills does a North American porcupine carry?",
    answer: 30000,
    min: 500,
    max: 200000,
    scale: "log",
    unit: "count",
    source: {
      title: "San Diego Zoo Wildlife Alliance — Porcupine",
      url: "https://animals.sandiegozoo.org/animals/porcupine",
    },
    explanation: "A single porcupine bristles with over 30,000 quills, packed as densely as 150 to the square inch — and contrary to myth, it cannot shoot them.",
  },
  {
    id: "animals-count-sea-otter-hairs-per-square-inch",
    category: "animals",
    measure: "quantity",
    subtype: "count",
    prompt: "Roughly how many hairs grow in a single square inch of a sea otter's fur?",
    answer: 1000000,
    min: 10000,
    max: 5000000,
    scale: "log",
    unit: "count",
    source: {
      title: "Monterey Bay Aquarium — Sea Otter",
      url: "https://www.montereybayaquarium.org/animals/animals-a-to-z/sea-otter",
    },
    explanation: "Sea otters pack more than a million hairs into each square inch — the densest fur of any animal, and the only insulation they have, since they carry no blubber.",
  },
  {
    id: "animals-count-yellowstone-bison-population",
    category: "animals",
    measure: "quantity",
    subtype: "count",
    prompt: "According to the 2025 estimate, how many bison lived in Yellowstone National Park?",
    answer: 5300,
    min: 300,
    max: 40000,
    scale: "log",
    unit: "count",
    referenceYear: "2025",
    source: {
      title: "U.S. National Park Service — Yellowstone Bison",
      url: "https://www.nps.gov/yell/learn/nature/bison.htm",
    },
    explanation: "About 5,300 bison roamed Yellowstone in 2025, descended from the couple of dozen wild animals that survived there in the early 1900s.",
  },
  {
    id: "daily-elephant-trunk-muscle-count",
    category: "animals",
    measure: "quantity",
    subtype: "count",
    prompt: "Roughly how many muscle units make up an elephant's trunk?",
    answer: 40000,
    min: 1000,
    max: 10000000,
    scale: "log",
    unit: "count",
    source: {
      title: "Encyclopaedia Britannica — Elephant",
      url: "https://www.britannica.com/animal/elephant-mammal",
    },
    explanation: "The trunk has on the order of 40,000 muscle units and no bones at all.",
  },
  {
    id: "quantity-count-ant-species",
    category: "animals",
    measure: "quantity",
    subtype: "count",
    prompt: "Roughly how many species of ant have been described by science?",
    answer: 14000,
    min: 200,
    max: 100000,
    scale: "log",
    unit: "count",
    source: {
      title: "Encyclopaedia Britannica — Ant",
      url: "https://www.britannica.com/animal/ant",
    },
    explanation: "Around 14,000 described so far, and the true figure is thought to be considerably higher. Ants live on every continent except Antarctica.",
  },
  {
    id: "quantity-count-bird-species",
    category: "animals",
    measure: "quantity",
    subtype: "count",
    prompt: "Roughly how many living species of bird have been described?",
    answer: 11000,
    min: 100,
    max: 50000,
    scale: "log",
    unit: "count",
    source: {
      title: "BirdLife International",
      url: "https://www.birdlife.org/",
    },
    explanation: "Around 11,000. The total keeps drifting as genetic work splits populations that were once counted as a single species.",
  },
  {
    id: "animals-percentage-alligator-hatchling-losses",
    category: "animals",
    measure: "quantity",
    subtype: "percentage",
    prompt: "What percentage of young American alligators are lost to predators?",
    answer: 80,
    min: 0,
    max: 100,
    scale: "linear",
    unit: "percent",
    source: {
      title: "Smithsonian's National Zoo — American Alligator",
      url: "https://nationalzoo.si.edu/animals/american-alligator",
    },
    explanation: "Some 80 percent of hatchlings are eaten by birds, raccoons and even other alligators, which is why a female may lay up to 90 eggs at once.",
  },
  {
    id: "animals-percentage-camel-survivable-weight-loss",
    category: "animals",
    measure: "quantity",
    subtype: "percentage",
    prompt: "What percentage of its body weight can a camel lose and still survive?",
    answer: 40,
    min: 0,
    max: 100,
    scale: "linear",
    unit: "percent",
    source: {
      title: "San Diego Zoo Wildlife Alliance — Camel",
      url: "https://animals.sandiegozoo.org/animals/camel",
    },
    explanation: "A camel can shed 40 percent of its body weight and live, then rehydrate by drinking up to 145 litres in a single session.",
  },
  {
    id: "animals-percentage-dangerous-snake-species",
    category: "animals",
    measure: "quantity",
    subtype: "percentage",
    prompt: "What percentage of the world's snake species are considered dangerous to humans?",
    answer: 15,
    min: 0,
    max: 100,
    scale: "linear",
    unit: "percent",
    source: {
      title: "San Diego Zoo Wildlife Alliance — Snake",
      url: "https://animals.sandiegozoo.org/animals/snake",
    },
    explanation: "Only about 15 percent of the roughly 2,978 known snake species pose any danger to people — more people are struck by lightning than bitten by a venomous snake.",
  },
  {
    id: "animals-percentage-jellyfish-water",
    category: "animals",
    measure: "quantity",
    subtype: "percentage",
    prompt: "Approximately what percentage of a jellyfish is water?",
    answer: 95,
    min: 0,
    max: 100,
    scale: "linear",
    unit: "percent",
    referenceYear: "2026",
    source: {
      title: "NOAA Ocean Service - Jellyfish",
      url: "https://oceanservice.noaa.gov/facts/jellyfish.html",
    },
    explanation: "NOAA says jellyfish are about 95 percent water, with only around five percent solid matter.",
  },
  {
    id: "animals-percentage-kiwi-chick-survival",
    category: "animals",
    measure: "quantity",
    subtype: "percentage",
    prompt: "Without predator control, what percentage of wild kiwi chicks survive to six months old?",
    answer: 10,
    min: 0,
    max: 100,
    scale: "linear",
    unit: "percent",
    source: {
      title: "New Zealand Department of Conservation — Kiwi Facts",
      url: "https://www.doc.govt.nz/nature/native-animals/birds/birds-a-z/kiwi/facts/",
    },
    explanation: "Only 10 percent of kiwi chicks reach six months where predators go unmanaged, which is why around 70,000 birds are left and unmanaged populations fall 2 percent a year.",
  },
  {
    id: "animals-money-us-alaska-pollock-landings-value",
    category: "animals",
    measure: "quantity",
    subtype: "money",
    prompt: "How much were US commercial Alaska pollock landings worth in 2024?",
    answer: 432000000,
    min: 20000000,
    max: 3000000000,
    scale: "log",
    unit: "usd",
    referenceYear: "2024",
    source: {
      title: "NOAA Fisheries — Alaska Pollock",
      url: "https://www.fisheries.noaa.gov/species/alaska-pollock",
    },
    explanation: "Over 3 billion pounds of Alaska pollock came ashore in 2024 for about $432 million — a colossal catch that ends up in fish sticks and imitation crab.",
  },
  {
    id: "animals-money-us-lobster-landings-value",
    category: "animals",
    measure: "quantity",
    subtype: "money",
    prompt: "How much were US commercial American lobster landings worth in 2024?",
    answer: 720000000,
    min: 10000000,
    max: 5000000000,
    scale: "log",
    unit: "usd",
    referenceYear: "2024",
    source: {
      title: "NOAA Fisheries — American Lobster",
      url: "https://www.fisheries.noaa.gov/species/american-lobster",
    },
    explanation: "Fishers landed 113 million pounds of lobster in 2024, worth about $720 million — one of the most valuable single-species fisheries in the United States.",
  },
  {
    id: "animals-duration-beaver-underwater",
    category: "animals",
    measure: "physics",
    subtype: "duration",
    prompt: "How long can a beaver stay underwater?",
    answer: 15,
    min: 1,
    max: 45,
    scale: "linear",
    unit: "minute",
    source: {
      title: "Smithsonian's National Zoo — Beaver",
      url: "https://nationalzoo.si.edu/animals/beaver",
    },
    explanation: "Oversized lungs let a beaver stay submerged for up to 15 minutes, long enough to swim more than half a mile without surfacing.",
  },
  {
    id: "animals-duration-bowhead-whale-lifespan",
    category: "animals",
    measure: "physics",
    subtype: "duration",
    prompt: "Approximately how long can a bowhead whale live, in years?",
    answer: 200,
    min: 10,
    max: 800,
    scale: "log",
    unit: "duration-year",
    referenceYear: "2026",
    source: {
      title: "NOAA Fisheries - Bowhead Whale",
      url: "https://www.fisheries.noaa.gov/species/bowhead-whale",
    },
    explanation: "NOAA says evidence suggests bowhead whales can live over 200 years.",
  },
  {
    id: "animals-duration-cheetah-acceleration",
    category: "animals",
    measure: "physics",
    subtype: "duration",
    prompt: "How many seconds does a cheetah need to accelerate from a standstill to 72 kilometres per hour?",
    answer: 2.5,
    min: 0.5,
    max: 12,
    scale: "linear",
    unit: "second",
    source: {
      title: "Smithsonian's National Zoo — Cheetah",
      url: "https://nationalzoo.si.edu/animals/cheetah",
    },
    explanation: "A cheetah hits 45 miles per hour in 2.5 seconds, out-accelerating most sports cars, and covers 7 metres in a single stride.",
  },
  {
    id: "animals-duration-emperor-penguin-breath-hold",
    category: "animals",
    measure: "physics",
    subtype: "duration",
    prompt: "How long can an emperor penguin hold its breath while diving, in minutes?",
    answer: 20,
    min: 1,
    max: 80,
    scale: "log",
    unit: "minute",
    referenceYear: "2026",
    source: {
      title: "Woods Hole Oceanographic Institution - Penguins",
      url: "https://www.whoi.edu/emperor-penguins/",
    },
    explanation: "Woods Hole Oceanographic Institution says emperor penguins are known to hold their breath for about 20 minutes while diving.",
  },
  {
    id: "animals-duration-greenland-shark-lifespan",
    category: "animals",
    measure: "physics",
    subtype: "duration",
    prompt: "Approximately how long can a Greenland shark live, in years?",
    answer: 400,
    min: 20,
    max: 1200,
    scale: "log",
    unit: "duration-year",
    referenceYear: "2026",
    source: {
      title: "University of Copenhagen - Greenland Shark",
      url: "https://science.ku.dk/english/press/news/2024/the-longest-living-vertebrate-genome/",
    },
    explanation: "Greenland sharks are considered the longest-living vertebrates, with an estimated lifespan of about 400 years.",
  },
  {
    id: "animals-duration-humpback-alaska-hawaii-crossing",
    category: "animals",
    measure: "physics",
    subtype: "duration",
    prompt: "In as few as how many days can a humpback whale swim from Alaska to Hawaii?",
    answer: 28,
    min: 3,
    max: 150,
    scale: "linear",
    unit: "day",
    source: {
      title: "NOAA Fisheries — Humpback Whale",
      url: "https://www.fisheries.noaa.gov/species/humpback-whale",
    },
    explanation: "Some humpbacks cover the 3,000-mile crossing in just 28 days, and they do it largely without stopping to feed.",
  },
  {
    id: "animals-duration-killer-whale-female-lifespan",
    category: "animals",
    measure: "physics",
    subtype: "duration",
    prompt: "How old can a female killer whale live to be in the wild?",
    answer: 90,
    min: 20,
    max: 160,
    scale: "linear",
    unit: "duration-year",
    source: {
      title: "NOAA Fisheries — Killer Whale",
      url: "https://www.fisheries.noaa.gov/species/killer-whale",
    },
    explanation: "Females can reach at least 90 years — typically 50 — while males average about 30, one of the widest lifespan gaps between sexes in the animal kingdom.",
  },
  {
    id: "animals-duration-koala-daily-sleep",
    category: "animals",
    measure: "physics",
    subtype: "duration",
    prompt: "At most, how many hours a day does a koala sleep?",
    answer: 22,
    min: 6,
    max: 24,
    scale: "linear",
    unit: "hour",
    source: {
      title: "San Diego Zoo Wildlife Alliance — Koala",
      url: "https://animals.sandiegozoo.org/animals/koala",
    },
    explanation: "Koalas rest 18 to 22 hours a day, because a diet of tough, low-energy eucalyptus leaves simply cannot fuel anything more ambitious.",
  },
  {
    id: "animals-duration-naked-mole-rat-lifespan",
    category: "animals",
    measure: "physics",
    subtype: "duration",
    prompt: "How long can a naked mole-rat live in human care?",
    answer: 30,
    min: 2,
    max: 80,
    scale: "linear",
    unit: "duration-year",
    source: {
      title: "Smithsonian's National Zoo — Naked Mole-Rat",
      url: "https://nationalzoo.si.edu/animals/naked-mole-rat",
    },
    explanation: "Naked mole-rats reach around 30 years, extraordinary for a rodent the size of a sausage — most mice are gone within three.",
  },
  {
    id: "animals-duration-platypus-water-foraging",
    category: "animals",
    measure: "physics",
    subtype: "duration",
    prompt: "At most, how many hours can a platypus spend in the water feeding at one time?",
    answer: 10,
    min: 1,
    max: 24,
    scale: "linear",
    unit: "hour",
    source: {
      title: "NSW Environment and Heritage - Platypus",
      url: "https://www.environment.nsw.gov.au/topics/animals-and-plants/native-animals/native-animal-facts/land-mammals/platypus",
    },
    explanation: "A platypus can spend up to 10 hours in the water feeding, hunting with its eyes and ears closed and using its sensitive bill to detect prey.",
  },
  {
    id: "daily-housefly-adult-lifespan",
    category: "animals",
    measure: "physics",
    subtype: "duration",
    prompt: "How long does an adult housefly typically live?",
    answer: 28,
    min: 1,
    max: 10000,
    scale: "log",
    unit: "day",
    source: {
      title: "Encyclopaedia Britannica — Housefly",
      url: "https://www.britannica.com/animal/housefly",
    },
    explanation: "Adult houseflies live about four weeks, long enough to lay several batches of eggs.",
  },
  {
    id: "daily-opossum-gestation-period",
    category: "animals",
    measure: "physics",
    subtype: "duration",
    prompt: "How long is a Virginia opossum's pregnancy, the shortest of any mammal?",
    answer: 12,
    min: 1,
    max: 2000,
    scale: "log",
    unit: "day",
    source: {
      title: "Encyclopaedia Britannica — Opossum",
      url: "https://www.britannica.com/animal/opossum-mammal-family-Didelphidae",
    },
    explanation: "Opossums are born after about twelve days and finish developing in the pouch.",
  },
  {
    id: "physics-duration-cat-gestation",
    category: "animals",
    measure: "physics",
    subtype: "duration",
    prompt: "How long is a domestic cat's pregnancy?",
    answer: 64,
    min: 1,
    max: 200,
    scale: "log",
    unit: "day",
    source: {
      title: "Encyclopaedia Britannica — Cat",
      url: "https://www.britannica.com/animal/cat",
    },
    explanation: "About 64 days, roughly nine weeks, typically producing a litter of three to five kittens.",
  },
  {
    id: "physics-duration-elephant-gestation",
    category: "animals",
    measure: "physics",
    subtype: "duration",
    prompt: "How long is an African elephant's pregnancy?",
    answer: 645,
    min: 30,
    max: 2000,
    scale: "log",
    unit: "day",
    source: {
      title: "Encyclopaedia Britannica — Elephant",
      url: "https://www.britannica.com/animal/elephant-mammal",
    },
    explanation: "About 645 days, close to 22 months. It is the longest gestation of any land mammal, and calves are born able to walk.",
  },
  {
    id: "animals-speed-hippo-charge",
    category: "animals",
    measure: "physics",
    subtype: "speed",
    prompt: "How fast can an agitated hippo charge on land?",
    answer: 30,
    min: 5,
    max: 80,
    scale: "linear",
    unit: "kph",
    source: {
      title: "San Diego Zoo Wildlife Alliance — Hippo",
      url: "https://animals.sandiegozoo.org/animals/hippo",
    },
    explanation: "A hippo can charge at 30 kilometres per hour — faster than most people can sprint — despite weighing up to 4,500 kilograms.",
  },
  {
    id: "daily-ostrich-running-speed",
    category: "animals",
    measure: "physics",
    subtype: "speed",
    prompt: "How fast can an ostrich sprint?",
    answer: 69,
    min: 4,
    max: 120,
    scale: "log",
    unit: "kph",
    source: {
      title: "Smithsonian's National Zoo - How Fast Is an Ostrich?",
      url: "https://nationalzoo.si.edu/animals/news/how-fast-ostrich-and-more-fun-facts",
    },
    explanation: "An ostrich can sprint at about 69 kilometres per hour, making it the fastest bird on land.",
  },
  {
    id: "physics-speed-cheetah",
    category: "animals",
    measure: "physics",
    subtype: "speed",
    prompt: "What is a cheetah's top running speed?",
    answer: 110,
    min: 5,
    max: 500,
    scale: "log",
    unit: "kph",
    source: {
      title: "Encyclopaedia Britannica — Cheetah",
      url: "https://www.britannica.com/animal/cheetah-mammal",
    },
    explanation: "About 110 kilometres per hour, but only in bursts of a few hundred metres before it has to stop and cool down.",
  },
  {
    id: "physics-speed-peregrine-falcon",
    category: "animals",
    measure: "physics",
    subtype: "speed",
    prompt: "How fast can a peregrine falcon travel in a full hunting dive?",
    answer: 390,
    min: 10,
    max: 2000,
    scale: "log",
    unit: "kph",
    source: {
      title: "Encyclopaedia Britannica — Peregrine falcon",
      url: "https://www.britannica.com/animal/peregrine-falcon",
    },
    explanation: "Around 390 kilometres per hour in a stoop, which makes it the fastest animal on Earth. In level flight it is far slower.",
  },
  {
    id: "animals-temperature-emperor-penguin-huddle",
    category: "animals",
    measure: "physics",
    subtype: "temperature",
    prompt: "How warm can it get inside an emperor penguin huddle?",
    answer: 24,
    min: -30,
    max: 40,
    scale: "linear",
    unit: "celsius",
    source: {
      title: "Australian Antarctic Program — Emperor Penguins",
      url: "https://www.antarctica.gov.au/about-antarctica/animals/penguins/emperor-penguins/",
    },
    explanation: "Packed ten birds to the square metre, the middle of a huddle reaches a balmy +24 °C while the Antarctic winter rages outside.",
  },
  {
    id: "animals-temperature-two-toed-sloth-body",
    category: "animals",
    measure: "physics",
    subtype: "temperature",
    prompt: "How low can a two-toed sloth's body temperature drop?",
    answer: 30,
    min: 18,
    max: 42,
    scale: "linear",
    unit: "celsius",
    source: {
      title: "Smithsonian's National Zoo — Two-Toed Sloth",
      url: "https://nationalzoo.si.edu/animals/two-toed-sloth",
    },
    explanation: "Sloths run a famously cool and variable 30 to 34 degrees Celsius, part of an energy-saving lifestyle so slow that a meal takes a month to digest.",
  },
  {
    id: "space-event-first-spacewalk",
    category: "space",
    measure: "history",
    subtype: "event",
    prompt: "In what year did Alexei Leonov make the first spacewalk?",
    answer: 1965,
    min: 1940,
    max: 1980,
    scale: "linear",
    unit: "year",
    source: {
      title: "NASA - What Is a Spacewalk?",
      url: "https://www.nasa.gov/learning-resources/for-kids-and-students/what-is-a-spacewalk-grades-5-8/",
    },
    explanation: "Alexei Leonov floated outside his Voskhod 2 spacecraft on 18 March 1965 for history's first spacewalk.",
  },
  {
    id: "space-event-hubble-launch",
    category: "space",
    measure: "history",
    subtype: "event",
    prompt: "In what year was the Hubble Space Telescope launched into orbit?",
    answer: 1990,
    min: 1960,
    max: 2025,
    scale: "linear",
    unit: "year",
    source: {
      title: "NASA - Hubble Launch Anniversary",
      url: "https://www.nasa.gov/missions/hubble/30-years-ago-hubble-launched-to-unlock-the-secrets-of-the-universe/",
    },
    explanation: "Hubble rode to orbit aboard Space Shuttle Discovery in April 1990 and transformed astronomy from above Earth's atmosphere.",
  },
  {
    id: "space-event-iss-first-module",
    category: "space",
    measure: "history",
    subtype: "event",
    prompt: "In what year was Zarya, the first module of the International Space Station, launched?",
    answer: 1998,
    min: 1970,
    max: 2025,
    scale: "linear",
    unit: "year",
    source: {
      title: "NASA - Zarya Module",
      url: "https://www.nasa.gov/international-space-station/zarya-module/",
    },
    explanation: "The Russian-built Zarya module launched in November 1998 and became the first piece of the International Space Station in orbit.",
  },
  {
    id: "space-event-viking-one-mars-landing",
    category: "space",
    measure: "history",
    subtype: "event",
    prompt: "In what year did Viking 1 make the first fully successful landing on Mars?",
    answer: 1976,
    min: 1950,
    max: 2000,
    scale: "linear",
    unit: "year",
    source: {
      title: "NASA Science - Viking 1",
      url: "https://science.nasa.gov/mission/viking-1/",
    },
    explanation: "Viking 1 landed safely on 20 July 1976 and immediately returned the first clear images from the Martian surface.",
  },
  {
    id: "space-event-voyager-one-launch",
    category: "space",
    measure: "history",
    subtype: "event",
    prompt: "In what year was Voyager 1 launched on its journey through the outer Solar System?",
    answer: 1977,
    min: 1950,
    max: 2005,
    scale: "linear",
    unit: "year",
    source: {
      title: "NASA Science - Voyager 1",
      url: "https://science.nasa.gov/mission/voyager/voyager-1/",
    },
    explanation: "Voyager 1 launched in 1977, visited Jupiter and Saturn, and later became the first spacecraft to enter interstellar space.",
  },
  {
    id: "space-event-webb-launch",
    category: "space",
    measure: "history",
    subtype: "event",
    prompt: "In what year was the James Webb Space Telescope launched?",
    answer: 2021,
    min: 1990,
    max: 2030,
    scale: "linear",
    unit: "year",
    source: {
      title: "NASA Science - Webb Fact Sheet",
      url: "https://science.nasa.gov/mission/webb/fact-sheet/",
    },
    explanation: "Webb launched on Christmas Day 2021, then travelled to its observing position about 1.5 million kilometres from Earth.",
  },
  {
    id: "daily-james-webb-primary-mirror-diameter",
    category: "space",
    measure: "size",
    subtype: "length",
    prompt: "What is the diameter of the James Webb Space Telescope's primary mirror?",
    answer: 6.5,
    min: 0.2,
    max: 10,
    scale: "log",
    unit: "metre",
    source: {
      title: "NASA Science - Webb Fact Sheet",
      url: "https://science.nasa.gov/mission/webb/fact-sheet/",
    },
    explanation: "NASA lists Webb's primary mirror as approximately 6.5 metres across, made from 18 gold-coated segments.",
  },
  {
    id: "daily-jupiter-equatorial-diameter",
    category: "space",
    measure: "size",
    subtype: "length",
    prompt: "Roughly how wide is Jupiter at its equator?",
    answer: 143000,
    min: 4000,
    max: 300000,
    scale: "log",
    unit: "kilometre",
    source: {
      title: "NASA Science - Juno Redefines Jupiter's Size",
      url: "https://science.nasa.gov/blogs/science-news/2026/02/04/nasas-juno-mission-redefines-size-shape-of-jupiter/",
    },
    explanation: "Jupiter is roughly 143,000 kilometres wide at its equator, more than eleven times Earth's diameter.",
  },
  {
    id: "daily-olympus-mons-height",
    category: "space",
    measure: "size",
    subtype: "length",
    prompt: "Approximately how high is Olympus Mons on Mars above its surrounding plains?",
    answer: 27,
    min: 1.2,
    max: 60,
    scale: "log",
    unit: "kilometre",
    source: {
      title: "NASA Science - Olympus Mons",
      url: "https://science.nasa.gov/photojournal/olympus-mons/",
    },
    explanation: "Olympus Mons rises roughly 27 kilometres above the surrounding plains, nearly three times Mount Everest's height.",
  },
  {
    id: "daily-titan-diameter",
    category: "space",
    measure: "size",
    subtype: "length",
    prompt: "What is the diameter of Saturn's largest moon, Titan?",
    answer: 5150,
    min: 120,
    max: 8000,
    scale: "log",
    unit: "kilometre",
    source: {
      title: "NASA Science - Titan",
      url: "https://science.nasa.gov/asset/webb/titan-cassini/",
    },
    explanation: "Titan is about 5,150 kilometres across, making it wider than the planet Mercury.",
  },
  {
    id: "size-length-moon-distance",
    category: "space",
    measure: "size",
    subtype: "length",
    prompt: "What is the mean distance from the Earth to the Moon, centre to centre?",
    answer: 384400,
    min: 1000,
    max: 10000000,
    scale: "log",
    unit: "kilometre",
    source: {
      title: "NASA Science — Earth's Moon facts",
      url: "https://science.nasa.gov/moon/facts/",
    },
    explanation: "The Moon averages about 384,400 kilometres away, though its elliptical orbit swings that distance by more than 40,000 kilometres.",
  },
  {
    id: "space-length-bennu-diameter",
    category: "space",
    measure: "size",
    subtype: "length",
    prompt: "Roughly how wide is the asteroid Bennu?",
    answer: 500,
    min: 20,
    max: 5000,
    scale: "log",
    unit: "metre",
    source: {
      title: "NASA Science - Bennu Facts",
      url: "https://science.nasa.gov/solar-system/asteroids/101955-bennu/facts/",
    },
    explanation: "Bennu is about 500 metres wide, roughly the height of a very large skyscraper turned on its side.",
  },
  {
    id: "space-length-earth-equatorial-diameter",
    category: "space",
    measure: "size",
    subtype: "length",
    prompt: "What is Earth's diameter around the equator?",
    answer: 12756,
    min: 1000,
    max: 100000,
    scale: "log",
    unit: "kilometre",
    source: {
      title: "NASA Science - Earth Facts",
      url: "https://science.nasa.gov/earth/facts/",
    },
    explanation: "Earth is 12,756 kilometres wide at the equator, slightly wider than it is from pole to pole.",
  },
  {
    id: "space-length-mars-distance-from-sun",
    category: "space",
    measure: "size",
    subtype: "length",
    prompt: "What is Mars' average distance from the Sun?",
    answer: 228000000,
    min: 10000000,
    max: 2000000000,
    scale: "log",
    unit: "kilometre",
    source: {
      title: "NASA Science - Mars Facts",
      url: "https://science.nasa.gov/mars/facts/",
    },
    explanation: "Mars orbits at an average distance of about 228 million kilometres from the Sun, around one and a half times Earth's distance.",
  },
  {
    id: "space-length-moon-diameter",
    category: "space",
    measure: "size",
    subtype: "length",
    prompt: "Approximately how wide is Earth's Moon?",
    answer: 3480,
    min: 500,
    max: 20000,
    scale: "log",
    unit: "kilometre",
    source: {
      title: "NASA Science - Moon Facts",
      url: "https://science.nasa.gov/moon/facts/",
    },
    explanation: "NASA gives the Moon a radius of about 1,740 kilometres, making its diameter roughly 3,480 kilometres.",
  },
  {
    id: "space-length-new-horizons-pluto-journey",
    category: "space",
    measure: "size",
    subtype: "length",
    prompt: "About how far did New Horizons travel from Earth to reach Pluto?",
    answer: 4800000000,
    min: 100000000,
    max: 20000000000,
    scale: "log",
    unit: "kilometre",
    referenceYear: "2015",
    source: {
      title: "NASA - New Horizons Nears Pluto",
      url: "https://www.nasa.gov/news-release/nasas-new-horizons-spacecraft-nears-historic-july-14-encounter-with-pluto/",
    },
    explanation: "New Horizons covered more than three billion miles, about 4.8 billion kilometres, before its 2015 Pluto flyby.",
  },
  {
    id: "space-length-perseverance-rover",
    category: "space",
    measure: "size",
    subtype: "length",
    prompt: "About how long is NASA's Perseverance Mars rover?",
    answer: 3,
    min: 0.5,
    max: 30,
    scale: "log",
    unit: "metre",
    source: {
      title: "NASA Science - Perseverance Rover Components",
      url: "https://science.nasa.gov/mission/mars-2020-perseverance/rover-components/",
    },
    explanation: "Perseverance is about three metres long, comparable to a small car, but packed with cameras, instruments and sample tubes.",
  },
  {
    id: "space-length-proxima-centauri-distance",
    category: "space",
    measure: "size",
    subtype: "length",
    prompt: "How far away is Proxima Centauri, the nearest star to the Sun?",
    answer: 40170000000000,
    min: 2000000000000,
    max: 120000000000000,
    scale: "log",
    unit: "kilometre",
    referenceYear: "2026",
    source: {
      title: "NASA Science - Sun Facts",
      url: "https://science.nasa.gov/sun/facts/",
    },
    explanation: "Proxima Centauri is about 4.24 light-years away, which is roughly 40 trillion kilometres.",
  },
  {
    id: "space-length-saturn-five-height",
    category: "space",
    measure: "size",
    subtype: "length",
    prompt: "How tall was a fully assembled Saturn V Moon rocket?",
    answer: 111,
    min: 20,
    max: 250,
    scale: "linear",
    unit: "metre",
    source: {
      title: "NASA - What Was the Saturn V?",
      url: "https://www.nasa.gov/learning-resources/for-kids-and-students/what-was-the-saturn-v-grades-5-8/",
    },
    explanation: "The Saturn V stood 111 metres tall, about the height of a 36-storey building.",
  },
  {
    id: "space-length-sun-diameter",
    category: "space",
    measure: "size",
    subtype: "length",
    prompt: "Approximately how wide is the Sun?",
    answer: 1400000,
    min: 100000,
    max: 10000000,
    scale: "log",
    unit: "kilometre",
    source: {
      title: "NASA Science - Sun Facts",
      url: "https://science.nasa.gov/sun/facts/",
    },
    explanation: "The Sun is about 1.4 million kilometres across, wide enough to line up roughly 109 Earths from side to side.",
  },
  {
    id: "space-length-voyager-one-distance-from-earth",
    category: "space",
    measure: "size",
    subtype: "length",
    prompt: "How far from Earth was Voyager 1, the most distant human-made object, in 2025?",
    answer: 25000000000,
    min: 500000000,
    max: 100000000000,
    scale: "log",
    unit: "kilometre",
    referenceYear: "2025",
    source: {
      title: "NASA - Turns Off 2 Voyager Science Instruments to Extend Mission",
      url: "https://www.nasa.gov/centers-and-facilities/jpl/nasa-turns-off-2-voyager-science-instruments-to-extend-mission/",
    },
    explanation: "NASA described Voyager 1 in 2025 as more than 25 billion kilometres from Earth, making it the most distant human-made object.",
  },
  {
    id: "size-mass-iss",
    category: "space",
    measure: "size",
    subtype: "mass",
    prompt: "What is the approximate mass of the International Space Station?",
    answer: 420000,
    min: 1000,
    max: 5000000,
    scale: "log",
    unit: "kilogram",
    source: {
      title: "NASA — International Space Station",
      url: "https://www.nasa.gov/international-space-station/",
    },
    explanation: "Roughly 420,000 kilograms, assembled piece by piece across more than thirty flights because nothing could lift it in one go.",
  },
  {
    id: "size-mass-saturn-v",
    category: "space",
    measure: "size",
    subtype: "mass",
    prompt: "What was the fully fuelled mass of a Saturn V rocket at launch?",
    answer: 2970000,
    min: 10000,
    max: 20000000,
    scale: "log",
    unit: "kilogram",
    source: {
      title: "Encyclopaedia Britannica — Saturn V",
      url: "https://www.britannica.com/technology/launch-vehicle/Saturn-V",
    },
    explanation: "About 2.97 million kilograms on the pad, the overwhelming majority of it propellant that burned away in minutes.",
  },
  {
    id: "space-mass-apollo-lunar-samples",
    category: "space",
    measure: "size",
    subtype: "mass",
    prompt: "How many kilograms of Moon rocks and soil did the Apollo missions bring back to Earth?",
    answer: 382,
    min: 10,
    max: 10000,
    scale: "log",
    unit: "kilogram",
    source: {
      title: "NASA Science - Apollo Samples",
      url: "https://science.nasa.gov/science-research/planetary-science/astrobiology/nasas-apollo-samples-yield-new-information-about-the-moon/",
    },
    explanation: "Six Apollo landing crews returned a combined 382 kilograms of lunar rocks, soil and core samples for scientists to study.",
  },
  {
    id: "space-mass-curiosity-rover",
    category: "space",
    measure: "size",
    subtype: "mass",
    prompt: "What is the mass of NASA's Curiosity Mars rover?",
    answer: 899,
    min: 100,
    max: 10000,
    scale: "log",
    unit: "kilogram",
    source: {
      title: "NASA Science - Curiosity Rover",
      url: "https://science.nasa.gov/mission/msl-curiosity/",
    },
    explanation: "Curiosity has a mass of 899 kilograms, close to the weight of a small car.",
  },
  {
    id: "space-mass-iss-spacesuit",
    category: "space",
    measure: "size",
    subtype: "mass",
    prompt: "About how much does a complete ISS spacesuit weigh on Earth, including its backpack?",
    answer: 145,
    min: 20,
    max: 1000,
    scale: "log",
    unit: "kilogram",
    source: {
      title: "NASA - Extravehicular Mobility Unit",
      url: "https://www.nasa.gov/wp-content/uploads/2015/07/2019_07_ea_emu.pdf",
    },
    explanation: "A complete Extravehicular Mobility Unit with its life-support backpack weighs about 145 kilograms on Earth, though it feels weightless in orbit.",
  },
  {
    id: "space-mass-voyager-one",
    category: "space",
    measure: "size",
    subtype: "mass",
    prompt: "What was Voyager 1's mass at launch?",
    answer: 722,
    min: 100,
    max: 10000,
    scale: "log",
    unit: "kilogram",
    source: {
      title: "NASA Science - Voyager 1",
      url: "https://science.nasa.gov/mission/voyager/voyager-1/",
    },
    explanation: "Voyager 1 had a launch mass of about 722 kilograms, including its instruments and nuclear power source.",
  },
  {
    id: "daily-known-asteroids-count",
    category: "space",
    measure: "quantity",
    subtype: "count",
    prompt: "Roughly how many asteroids had been catalogued in the Solar System by 2023?",
    answer: 1300000,
    min: 500000,
    max: 25000000,
    scale: "log",
    unit: "count",
    source: {
      title: "NASA Jet Propulsion Laboratory — Small-Body Database",
      url: "https://ssd.jpl.nasa.gov/",
    },
    explanation: "Just over 1.3 million asteroids had been catalogued, most of them in the main belt.",
  },
  {
    id: "daily-moons-of-saturn-confirmed",
    category: "space",
    measure: "quantity",
    subtype: "count",
    prompt: "Roughly how many moons of Saturn had been confirmed by 2024?",
    answer: 146,
    min: 10,
    max: 100000,
    scale: "log",
    unit: "count",
    source: {
      title: "NASA Science — Saturn Moons",
      url: "https://science.nasa.gov/saturn/moons/",
    },
    explanation: "Saturn's confirmed moon count reached 146 in 2023, overtaking Jupiter.",
  },
  {
    id: "quantity-count-moonwalkers",
    category: "space",
    measure: "quantity",
    subtype: "count",
    prompt: "How many people have walked on the surface of the Moon?",
    answer: 12,
    min: 1,
    max: 1000,
    scale: "log",
    unit: "count",
    source: {
      title: "Encyclopaedia Britannica — Apollo program",
      url: "https://www.britannica.com/science/Apollo-space-program",
    },
    explanation: "Twelve, all between 1969 and 1972 across six Apollo landings. Twelve more flew to the Moon without landing on it.",
  },
  {
    id: "space-count-earths-inside-sun",
    category: "space",
    measure: "quantity",
    subtype: "count",
    prompt: "How many Earths would fit inside the Sun?",
    answer: 1300000,
    min: 50000,
    max: 5000000,
    scale: "log",
    unit: "count",
    referenceYear: "2026",
    source: {
      title: "NASA Science - Sun Facts",
      url: "https://science.nasa.gov/sun/facts/",
    },
    explanation: "NASA says it would take about 1.3 million Earths to fill the Sun's volume.",
  },
  {
    id: "space-count-milky-way-stars",
    category: "space",
    measure: "quantity",
    subtype: "count",
    prompt: "Roughly how many stars are there in the Milky Way?",
    answer: 100000000000,
    min: 5000000000,
    max: 300000000000,
    scale: "log",
    unit: "count",
    referenceYear: "2026",
    source: {
      title: "NASA Imagine the Universe - The Milky Way Galaxy",
      url: "https://imagine.gsfc.nasa.gov/science/objects/milkyway1.html",
    },
    explanation: "NASA gives a best estimate of approximately 100 billion stars in the Milky Way.",
  },
  {
    id: "space-count-observable-universe-galaxies",
    category: "space",
    measure: "quantity",
    subtype: "count",
    prompt: "Roughly how many galaxies are there in the observable universe?",
    answer: 2000000000000,
    min: 10000000000,
    max: 10000000000000,
    scale: "log",
    unit: "count",
    referenceYear: "2026",
    source: {
      title: "NASA Science - Our Milky Way Galaxy: How Big is Space?",
      url: "https://science.nasa.gov/universe/exoplanets/our-milky-way-galaxy-how-big-is-space/",
    },
    explanation: "NASA describes the observable universe as containing about 2 trillion galaxies, each holding vast numbers of stars.",
  },
  {
    id: "space-count-shuttle-missions",
    category: "space",
    measure: "quantity",
    subtype: "count",
    prompt: "How many missions did NASA's Space Shuttle programme fly?",
    answer: 135,
    min: 10,
    max: 1000,
    scale: "log",
    unit: "count",
    source: {
      title: "NASA - Space Shuttle",
      url: "https://www.nasa.gov/space-shuttle/",
    },
    explanation: "The Space Shuttle fleet flew 135 missions between Columbia's first launch in 1981 and Atlantis' final landing in 2011.",
  },
  {
    id: "space-count-shuttle-orbiters",
    category: "space",
    measure: "quantity",
    subtype: "count",
    prompt: "How many different Space Shuttle orbiters flew in space?",
    answer: 5,
    min: 1,
    max: 10,
    scale: "linear",
    unit: "count",
    source: {
      title: "NASA - What Was the Space Shuttle?",
      url: "https://www.nasa.gov/learning-resources/for-kids-and-students/what-was-the-space-shuttle-grades-5-8/",
    },
    explanation: "Five orbiters flew in space: Columbia, Challenger, Discovery, Atlantis and Endeavour. Enterprise was used only for atmospheric tests.",
  },
  {
    id: "space-count-voyager-record-languages",
    category: "space",
    measure: "quantity",
    subtype: "count",
    prompt: "How many languages are represented by spoken greetings on the Voyager Golden Record?",
    answer: 55,
    min: 5,
    max: 500,
    scale: "log",
    unit: "count",
    source: {
      title: "NASA Science - Voyager 1",
      url: "https://science.nasa.gov/mission/voyager/voyager-1/",
    },
    explanation: "The Golden Record carries spoken greetings in 55 languages alongside music, natural sounds and images from Earth.",
  },
  {
    id: "space-percentage-mars-gravity",
    category: "space",
    measure: "quantity",
    subtype: "percentage",
    prompt: "Mars surface gravity is roughly what percentage of Earth's?",
    answer: 38,
    min: 0,
    max: 100,
    scale: "linear",
    unit: "percent",
    source: {
      title: "NASA - Interesting Fact of the Month 2023",
      url: "https://www.nasa.gov/space-science-and-astrobiology-at-ames/interesting-fact-of-the-month-current/interesting-fact-of-the-month-2023/",
    },
    explanation: "Mars has only about 38 per cent of Earth's surface gravity, so a person weighing 80 kilograms on Earth would feel like about 30 kilograms there.",
  },
  {
    id: "daily-mars-day-length",
    category: "space",
    measure: "physics",
    subtype: "duration",
    prompt: "How long is one solar day on Mars, measured in Earth hours?",
    answer: 24.6,
    min: 0.8,
    max: 40,
    scale: "log",
    unit: "hour",
    source: {
      title: "NASA Science - Mars Facts",
      url: "https://science.nasa.gov/mars/facts/",
    },
    explanation: "A Martian solar day lasts about 24.6 Earth hours, only around 39 minutes longer than a day on Earth.",
  },
  {
    id: "physics-duration-apollo-11-surface",
    category: "space",
    measure: "physics",
    subtype: "duration",
    prompt: "How long did Armstrong and Aldrin spend on the lunar surface before lifting off again?",
    answer: 22,
    min: 2,
    max: 1000,
    scale: "log",
    unit: "hour",
    source: {
      title: "Encyclopaedia Britannica — Apollo 11",
      url: "https://www.britannica.com/topic/Apollo-11",
    },
    explanation: "About 21 hours 36 minutes in total, of which only around two and a half hours were spent outside the lunar module.",
  },
  {
    id: "physics-duration-halleys-comet",
    category: "space",
    measure: "physics",
    subtype: "duration",
    prompt: "How long does Halley's Comet take to complete one orbit of the Sun?",
    answer: 76,
    min: 2,
    max: 500,
    scale: "log",
    unit: "duration-year",
    source: {
      title: "Encyclopaedia Britannica — Halley's Comet",
      url: "https://www.britannica.com/topic/Halleys-Comet",
    },
    explanation: "About 76 years. It last appeared in 1986 and is due back in 2061, so most people see it at most once.",
  },
  {
    id: "physics-duration-moon-orbit",
    category: "space",
    measure: "physics",
    subtype: "duration",
    prompt: "How long does the Moon take to complete one orbit of the Earth, measured against the stars?",
    answer: 27,
    min: 5,
    max: 2000,
    scale: "log",
    unit: "day",
    source: {
      title: "NASA Science — Earth's Moon facts",
      url: "https://science.nasa.gov/moon/facts/",
    },
    explanation: "About 27.3 days against the stars, but 29.5 days from one full moon to the next, because the Earth moves along its own orbit meanwhile.",
  },
  {
    id: "physics-duration-sunlight-to-earth",
    category: "space",
    measure: "physics",
    subtype: "duration",
    prompt: "How long does light from the Sun take to reach the Earth?",
    answer: 499,
    min: 5,
    max: 2000,
    scale: "log",
    unit: "second",
    source: {
      title: "NASA Science — Sun facts",
      url: "https://science.nasa.gov/sun/facts/",
    },
    explanation: "About 499 seconds, or 8 minutes 19 seconds. The Sun you see has always already moved on from where it appears to be.",
  },
  {
    id: "space-duration-age-of-universe",
    category: "space",
    measure: "physics",
    subtype: "duration",
    prompt: "How long ago did the Big Bang happen?",
    answer: 13800000000,
    min: 200000000,
    max: 80000000000,
    scale: "log",
    unit: "duration-year",
    referenceYear: "2026",
    source: {
      title: "NASA Science - Overview of the Universe",
      url: "https://science.nasa.gov/universe/overview/",
    },
    explanation: "NASA gives the age of the universe as about 13.8 billion years, measured from the Big Bang.",
  },
  {
    id: "space-duration-day-on-venus",
    category: "space",
    measure: "physics",
    subtype: "duration",
    prompt: "How long does a single day on Venus last, measured in Earth days?",
    answer: 243,
    min: 10,
    max: 600,
    scale: "log",
    unit: "day",
    referenceYear: "2026",
    source: {
      title: "NASA Science - Venus Facts",
      url: "https://science.nasa.gov/venus/venus-facts/",
    },
    explanation: "A Venus day lasts about 243 Earth days, longer than the planet's 225-day trip around the Sun.",
  },
  {
    id: "space-duration-jupiter-year",
    category: "space",
    measure: "physics",
    subtype: "duration",
    prompt: "About how many Earth years does Jupiter take to orbit the Sun?",
    answer: 12,
    min: 1,
    max: 200,
    scale: "log",
    unit: "duration-year",
    source: {
      title: "NASA Science - Jupiter Facts",
      url: "https://science.nasa.gov/jupiter/jupiter-facts/",
    },
    explanation: "Jupiter completes one trip around the Sun in just under twelve Earth years.",
  },
  {
    id: "space-duration-light-crossing-milky-way",
    category: "space",
    measure: "physics",
    subtype: "duration",
    prompt: "How long does light take to cross the Milky Way from one side to the other?",
    answer: 100000,
    min: 5000,
    max: 300000,
    scale: "log",
    unit: "duration-year",
    referenceYear: "2026",
    source: {
      title: "NASA Imagine the Universe - The Milky Way Galaxy",
      url: "https://imagine.gsfc.nasa.gov/science/objects/milkyway1.html",
    },
    explanation: "The Milky Way is about 100,000 light-years across, so light takes about 100,000 years to cross it.",
  },
  {
    id: "space-duration-mars-year",
    category: "space",
    measure: "physics",
    subtype: "duration",
    prompt: "How many Earth days does one year on Mars last?",
    answer: 687,
    min: 100,
    max: 5000,
    scale: "log",
    unit: "day",
    source: {
      title: "NASA Science - Mars Facts",
      url: "https://science.nasa.gov/mars/facts/",
    },
    explanation: "Mars takes 687 Earth days to complete one orbit of the Sun, so its seasons last nearly twice as long as ours.",
  },
  {
    id: "space-duration-new-horizons-pluto",
    category: "space",
    measure: "physics",
    subtype: "duration",
    prompt: "Roughly how many years did New Horizons take to travel from Earth to Pluto?",
    answer: 9,
    min: 1,
    max: 30,
    scale: "linear",
    unit: "duration-year",
    referenceYear: "2015",
    source: {
      title: "NASA Science - New Horizons",
      url: "https://science.nasa.gov/mission/new-horizons/",
    },
    explanation: "New Horizons launched in January 2006 and reached Pluto in July 2015 after a journey of a little over nine years.",
  },
  {
    id: "space-duration-saturn-year",
    category: "space",
    measure: "physics",
    subtype: "duration",
    prompt: "About how many Earth years does Saturn take to orbit the Sun?",
    answer: 29,
    min: 1,
    max: 200,
    scale: "log",
    unit: "duration-year",
    source: {
      title: "NASA Science - Saturn Facts",
      url: "https://science.nasa.gov/saturn/facts/",
    },
    explanation: "A Saturn year lasts about 29.4 Earth years, meaning each Saturn season continues for more than seven Earth years.",
  },
  {
    id: "daily-neptune-fastest-winds",
    category: "space",
    measure: "physics",
    subtype: "speed",
    prompt: "How fast can the strongest winds on Neptune blow?",
    answer: 2000,
    min: 30,
    max: 5000,
    scale: "log",
    unit: "kph",
    source: {
      title: "NASA Science - Neptune Facts",
      url: "https://science.nasa.gov/neptune/neptune-facts/",
    },
    explanation: "Neptune's winds can exceed 2,000 kilometres per hour, the fastest measured anywhere in the solar system.",
  },
  {
    id: "physics-speed-earth-orbit",
    category: "space",
    measure: "physics",
    subtype: "speed",
    prompt: "How fast does the Earth travel along its orbit around the Sun?",
    answer: 107000,
    min: 1000,
    max: 1000000,
    scale: "log",
    unit: "kph",
    source: {
      title: "NASA Science — Earth facts",
      url: "https://science.nasa.gov/earth/facts/",
    },
    explanation: "About 107,000 kilometres per hour, roughly 30 kilometres every second, and you feel none of it.",
  },
  {
    id: "physics-speed-escape-velocity",
    category: "space",
    measure: "physics",
    subtype: "speed",
    prompt: "What is escape velocity at the Earth's surface, the speed needed to leave without further propulsion?",
    answer: 40270,
    min: 500,
    max: 200000,
    scale: "log",
    unit: "kph",
    source: {
      title: "Encyclopaedia Britannica — Escape velocity",
      url: "https://www.britannica.com/science/escape-velocity",
    },
    explanation: "About 40,270 kilometres per hour, or 11.2 kilometres per second. Rockets never actually travel that fast at the surface, because they keep burning fuel as they climb.",
  },
  {
    id: "physics-speed-iss",
    category: "space",
    measure: "physics",
    subtype: "speed",
    prompt: "How fast does the International Space Station travel in its orbit?",
    answer: 27600,
    min: 500,
    max: 200000,
    scale: "log",
    unit: "kph",
    source: {
      title: "NASA — International Space Station",
      url: "https://www.nasa.gov/international-space-station/",
    },
    explanation: "About 27,600 kilometres per hour, circling the Earth roughly every 90 minutes, so its crew sees sixteen sunrises a day.",
  },
  {
    id: "space-speed-apollo-ten",
    category: "space",
    measure: "physics",
    subtype: "speed",
    prompt: "How fast was Apollo 10 travelling when its crew set the human speed record?",
    answer: 39900,
    min: 5000,
    max: 100000,
    scale: "log",
    unit: "kph",
    source: {
      title: "NASA - Apollo 10 Clears the Way",
      url: "https://www.nasa.gov/history/apollo-10-clears-the-way-for-the-first-moon-landing/",
    },
    explanation: "Apollo 10 hit 24,791 miles per hour on re-entry, about 39,900 kilometres per hour, a human speed record that still stands.",
  },
  {
    id: "space-speed-parker-solar-probe",
    category: "space",
    measure: "physics",
    subtype: "speed",
    prompt: "About how fast has Parker Solar Probe travelled at its closest approach to the Sun?",
    answer: 700000,
    min: 10000,
    max: 2000000,
    scale: "log",
    unit: "kph",
    referenceYear: "2024",
    source: {
      title: "NASA Science - Parker Solar Probe",
      url: "https://science.nasa.gov/mission/parker-solar-probe/",
    },
    explanation: "Parker Solar Probe reached about 700,000 kilometres per hour in 2024, making it the fastest human-made object.",
  },
  {
    id: "space-speed-sun-orbit-milky-way",
    category: "space",
    measure: "physics",
    subtype: "speed",
    prompt: "How fast does the Sun travel on its orbit around the centre of the Milky Way?",
    answer: 828000,
    min: 40000,
    max: 2500000,
    scale: "log",
    unit: "kph",
    referenceYear: "2026",
    source: {
      title: "NASA StarChild - Does the Sun move around the Milky Way?",
      url: "https://starchild.gsfc.nasa.gov/docs/StarChild/questions/question18.html",
    },
    explanation: "NASA StarChild gives the Sun's galactic orbital speed as about 828,000 km/h, with one orbit taking about 230 million years.",
  },
  {
    id: "space-speed-voyager-one",
    category: "space",
    measure: "physics",
    subtype: "speed",
    prompt: "Approximately how fast is Voyager 1 moving relative to the Sun?",
    answer: 61200,
    min: 5000,
    max: 500000,
    scale: "log",
    unit: "kph",
    referenceYear: "2024",
    source: {
      title: "NASA Science - Voyager 1",
      url: "https://science.nasa.gov/mission/voyager/voyager-1/",
    },
    explanation: "NASA lists Voyager 1's speed at about 17 kilometres per second, equivalent to roughly 61,200 kilometres per hour.",
  },
  {
    id: "daily-pluto-surface-temperature",
    category: "space",
    measure: "physics",
    subtype: "temperature",
    prompt: "What is the average surface temperature on Pluto?",
    answer: -229,
    min: -273,
    max: 100,
    scale: "linear",
    unit: "celsius",
    source: {
      title: "NASA Science — Pluto",
      url: "https://science.nasa.gov/dwarf-planets/pluto/",
    },
    explanation: "Pluto sits at about -229 degrees Celsius, cold enough for nitrogen to freeze onto the surface.",
  },
  {
    id: "daily-uranus-average-temperature",
    category: "space",
    measure: "physics",
    subtype: "temperature",
    prompt: "What is the average temperature of Uranus' upper atmosphere?",
    answer: -224,
    min: -273,
    max: 100,
    scale: "linear",
    unit: "celsius",
    source: {
      title: "NASA Science — Uranus",
      url: "https://science.nasa.gov/uranus/",
    },
    explanation: "Uranus is the coldest planet in the Solar System, averaging about -224 degrees Celsius.",
  },
  {
    id: "physics-temperature-cmb",
    category: "space",
    measure: "physics",
    subtype: "temperature",
    prompt: "What is the temperature of the cosmic microwave background, the leftover heat of the early universe?",
    answer: -270.4,
    min: -273,
    max: 0,
    scale: "linear",
    unit: "celsius",
    source: {
      title: "Encyclopaedia Britannica — Cosmic microwave background",
      url: "https://www.britannica.com/science/cosmic-microwave-background",
    },
    explanation: "About −270.4°C, or 2.7 degrees above absolute zero. It fills all of space and is the coldest thing that occurs naturally.",
  },
  {
    id: "physics-temperature-mars-average",
    category: "space",
    measure: "physics",
    subtype: "temperature",
    prompt: "What is the average surface temperature on Mars?",
    answer: -63,
    min: -150,
    max: 100,
    scale: "linear",
    unit: "celsius",
    source: {
      title: "NASA Science — Mars facts",
      url: "https://science.nasa.gov/mars/facts/",
    },
    explanation: "About −63°C on average, though a summer afternoon at the equator can reach 20°C while the night falls to −100°C.",
  },
  {
    id: "physics-temperature-sun-surface",
    category: "space",
    measure: "physics",
    subtype: "temperature",
    prompt: "What is the temperature of the Sun's visible surface, the photosphere?",
    answer: 5500,
    min: 0,
    max: 30000,
    scale: "linear",
    unit: "celsius",
    source: {
      title: "NASA Science — Sun facts",
      url: "https://science.nasa.gov/sun/facts/",
    },
    explanation: "About 5,500°C. Oddly the corona above it is far hotter still, over a million degrees, and why remains an open question.",
  },
  {
    id: "physics-temperature-venus-surface",
    category: "space",
    measure: "physics",
    subtype: "temperature",
    prompt: "What is the mean surface temperature of Venus?",
    answer: 464,
    min: -100,
    max: 1500,
    scale: "linear",
    unit: "celsius",
    source: {
      title: "NASA Science — Venus facts",
      url: "https://science.nasa.gov/venus/facts/",
    },
    explanation: "About 464°C, hot enough to melt lead, and hotter than Mercury despite being further from the Sun. A runaway greenhouse effect is the reason.",
  },
  {
    id: "space-temperature-moon-sunlight",
    category: "space",
    measure: "physics",
    subtype: "temperature",
    prompt: "How hot can the Moon's surface become in full sunlight?",
    answer: 127,
    min: -200,
    max: 300,
    scale: "linear",
    unit: "celsius",
    source: {
      title: "NASA Science - Moon Facts",
      url: "https://science.nasa.gov/moon/facts/",
    },
    explanation: "In full sunlight the lunar surface can reach about 127 degrees Celsius, then plunge far below freezing at night.",
  },
  {
    id: "space-temperature-sun-core",
    category: "space",
    measure: "physics",
    subtype: "temperature",
    prompt: "How hot is the core of the Sun?",
    answer: 15000000,
    min: 0,
    max: 50000000,
    scale: "linear",
    unit: "celsius",
    referenceYear: "2026",
    source: {
      title: "NASA Science - Sun Facts",
      url: "https://science.nasa.gov/sun/facts/",
    },
    explanation: "NASA puts the Sun's core temperature at about 15 million degrees Celsius, far hotter than the surface.",
  },
  {
    id: "technology-event-first-arpanet-message",
    category: "technology",
    measure: "history",
    subtype: "event",
    prompt: "In what year was the first message sent over ARPANET?",
    answer: 1969,
    min: 1930,
    max: 2010,
    scale: "linear",
    unit: "year",
    source: {
      title: "UCLA Newsroom — Leonard Kleinrock receives UCLA Medal",
      url: "https://newsroom.ucla.edu/stories/internet-architect-dr-leonard-kleinrock-receives-ucla-medal",
    },
    explanation: "UCLA sent the first ARPANET message to the Stanford Research Institute on 29 October 1969.",
  },
  {
    id: "technology-event-google-founded",
    category: "technology",
    measure: "history",
    subtype: "event",
    prompt: "In what year was Google Inc. officially founded?",
    answer: 1998,
    min: 1900,
    max: 2030,
    scale: "linear",
    unit: "year",
    source: {
      title: "Google — From the garage to the Googleplex",
      url: "https://about.google/company-info/our-story/",
    },
    explanation: "Google says the company was officially born in August 1998 after receiving its first major investment.",
  },
  {
    id: "technology-event-ibm-5150-introduced",
    category: "technology",
    measure: "history",
    subtype: "event",
    prompt: "In what year did IBM introduce the 5150 Personal Computer?",
    answer: 1981,
    min: 1940,
    max: 2020,
    scale: "linear",
    unit: "year",
    source: {
      title: "IBM Heritage — The IBM PC",
      url: "https://www.ibm.com/history/personal-computer?linkId=14355980",
    },
    explanation: "IBM introduced the 5150 Personal Computer in August 1981 and unveiled it in New York on 12 August.",
  },
  {
    id: "technology-event-microsoft-founded",
    category: "technology",
    measure: "history",
    subtype: "event",
    prompt: "In what year was Microsoft founded?",
    answer: 1975,
    min: 1900,
    max: 2030,
    scale: "linear",
    unit: "year",
    source: {
      title: "Microsoft — Facts About Microsoft",
      url: "https://news.microsoft.com/facts-about-microsoft/",
    },
    explanation: "Microsoft lists 1975 as the year the company was founded by Bill Gates and Paul Allen.",
  },
  {
    id: "technology-event-original-macintosh",
    category: "technology",
    measure: "history",
    subtype: "event",
    prompt: "In what year did Apple introduce the original Macintosh?",
    answer: 1984,
    min: 1900,
    max: 2030,
    scale: "linear",
    unit: "year",
    source: {
      title: "Apple Newsroom — Introducing the next generation of Mac",
      url: "https://www.apple.com/newsroom/2020/11/introducing-the-next-generation-of-mac/",
    },
    explanation: "Apple introduced the original Macintosh in 1984, helping popularise the graphical personal computer.",
  },
  {
    id: "technology-event-telstar-1-live-tv",
    category: "technology",
    measure: "history",
    subtype: "event",
    prompt: "In what year did Telstar 1 relay live television across the Atlantic?",
    answer: 1962,
    min: 1930,
    max: 1995,
    scale: "linear",
    unit: "year",
    source: {
      title: "NASA — Exploring the Unknown, Volume III",
      url: "https://www.nasa.gov/wp-content/uploads/2023/04/sp-4407-etuv3.pdf?emrc=fe2581",
    },
    explanation: "NASA's history records that Telstar 1 broadcast live television between the United States, England and France in 1962.",
  },
  {
    id: "daily-channel-tunnel-length",
    category: "technology",
    measure: "size",
    subtype: "length",
    prompt: "How long is the Channel Tunnel between England and France?",
    answer: 50.5,
    min: 1.5,
    max: 80,
    scale: "log",
    unit: "kilometre",
    source: {
      title: "Eurostar - The Channel Tunnel",
      url: "https://www.eurostar.com/uk-en/travel-info/eurostar-experience/the-channel-tunnel",
    },
    explanation: "Eurostar gives the Channel Tunnel's length as 50.45 kilometres, with 37.9 kilometres under the sea.",
  },
  {
    id: "daily-large-hadron-collider-circumference",
    category: "technology",
    measure: "size",
    subtype: "length",
    prompt: "What is the circumference of the Large Hadron Collider?",
    answer: 27,
    min: 0.8,
    max: 50,
    scale: "log",
    unit: "kilometre",
    source: {
      title: "CERN - The Large Hadron Collider",
      url: "https://home.cern/science/accelerators/large-hadron-collider/",
    },
    explanation: "CERN describes the Large Hadron Collider as a 27-kilometre ring of superconducting magnets.",
  },
  {
    id: "size-length-burj-khalifa",
    category: "technology",
    measure: "size",
    subtype: "length",
    prompt: "How tall is the Burj Khalifa in Dubai, measured to its architectural tip?",
    answer: 828,
    min: 50,
    max: 2000,
    scale: "log",
    unit: "metre",
    source: {
      title: "Encyclopaedia Britannica — Burj Khalifa",
      url: "https://www.britannica.com/topic/Burj-Khalifa",
    },
    explanation: "At 828 metres the Burj Khalifa has been the world's tallest building since it opened in 2010, roughly twice the height of the Empire State Building.",
  },
  {
    id: "size-length-eiffel-tower",
    category: "technology",
    measure: "size",
    subtype: "length",
    prompt: "How tall is the Eiffel Tower, including the antennas at its summit?",
    answer: 330,
    min: 10,
    max: 1000,
    scale: "log",
    unit: "metre",
    source: {
      title: "Encyclopaedia Britannica — Eiffel Tower",
      url: "https://www.britannica.com/topic/Eiffel-Tower-Paris-France",
    },
    explanation: "The tower stands about 330 metres to the tip. It was the tallest structure in the world from 1889 until the Chrysler Building overtook it in 1930.",
  },
  {
    id: "size-length-great-wall",
    category: "technology",
    measure: "size",
    subtype: "length",
    prompt: "How long is the Great Wall of China in total, counting every branch and spur surveyed in 2012?",
    answer: 21196,
    min: 500,
    max: 100000,
    scale: "log",
    unit: "kilometre",
    source: {
      title: "Encyclopaedia Britannica — Great Wall of China",
      url: "https://www.britannica.com/topic/Great-Wall-of-China",
    },
    explanation: "A five-year government survey put the total at about 21,196 kilometres across all dynasties. The single best-known Ming stretch is far shorter.",
  },
  {
    id: "size-length-panama-canal",
    category: "technology",
    measure: "size",
    subtype: "length",
    prompt: "How long is the Panama Canal from deep water in the Caribbean to deep water in the Pacific?",
    answer: 82,
    min: 2,
    max: 200,
    scale: "log",
    unit: "kilometre",
    source: {
      title: "Encyclopaedia Britannica — Panama Canal",
      url: "https://www.britannica.com/topic/Panama-Canal",
    },
    explanation: "The canal runs about 82 kilometres. Ships are lifted 26 metres above sea level to cross, then lowered again on the far side.",
  },
  {
    id: "technology-length-akashi-kaikyo-main-span",
    category: "technology",
    measure: "size",
    subtype: "length",
    prompt: "What is the main span length of Japan's Akashi Kaikyo Bridge?",
    answer: 1991,
    min: 200,
    max: 10000,
    scale: "log",
    unit: "metre",
    source: {
      title: "JAXA Earth-graphy — Akashi-Kaikyo Bridge",
      url: "https://earth.jaxa.jp/en/earthview/2011/02/23/845/index.html",
    },
    explanation: "JAXA gives the distance between the Akashi Kaikyo Bridge's towers, its main span, as 1,991 metres.",
  },
  {
    id: "technology-length-boeing-777-300er-wingspan",
    category: "technology",
    measure: "size",
    subtype: "length",
    prompt: "What is the wingspan of Boeing's 777-300ER?",
    answer: 64.8,
    min: 10,
    max: 500,
    scale: "log",
    unit: "metre",
    source: {
      title: "Boeing — 777 Passenger Airplane Characteristics",
      url: "https://www.boeing.com/content/dam/boeing/boeingdotcom/company/about_bca/startup/pdf/historical/777_passenger.pdf?pubDate=20250916",
    },
    explanation: "Boeing's 777-300ER has a wingspan of 64.8 metres.",
  },
  {
    id: "technology-length-cn-tower",
    category: "technology",
    measure: "size",
    subtype: "length",
    prompt: "How tall is Toronto's CN Tower?",
    answer: 553.33,
    min: 80,
    max: 2500,
    scale: "log",
    unit: "metre",
    source: {
      title: "CN Tower — Common questions",
      url: "https://www.cntower.ca/plan-your-visit/at-the-tower/common-questions",
    },
    explanation: "The CN Tower measures 553.33 metres from its base to the top of its antenna.",
  },
  {
    id: "technology-length-dsn-dss14-dish",
    category: "technology",
    measure: "size",
    subtype: "length",
    prompt: "What is the dish diameter of NASA's Deep Space Station 14 antenna?",
    answer: 70,
    min: 10,
    max: 500,
    scale: "log",
    unit: "metre",
    source: {
      title: "NASA — Antennas of the Deep Space Network",
      url: "https://www.nasa.gov/directorates/somd/space-communications-navigation-program/antennas-of-the-dsn/",
    },
    explanation: "NASA's Deep Space Station 14 dish was enlarged from 64 metres to 70 metres in 1988.",
  },
  {
    id: "technology-length-faster-cable-system",
    category: "technology",
    measure: "size",
    subtype: "length",
    prompt: "How long is the FASTER trans-Pacific submarine cable system?",
    answer: 9000,
    min: 1000,
    max: 50000,
    scale: "log",
    unit: "kilometre",
    source: {
      title: "NEC — FASTER Cable System Ready for Service",
      url: "https://www.nec.com/en/global/prod/nw/submarine/news/20160629.html",
    },
    explanation: "The FASTER submarine cable system spans 9,000 kilometres between Japan and the west coast of the United States.",
  },
  {
    id: "technology-length-golden-gate-main-span",
    category: "technology",
    measure: "size",
    subtype: "length",
    prompt: "How long is the Golden Gate Bridge's main span?",
    answer: 1280,
    min: 200,
    max: 8000,
    scale: "log",
    unit: "metre",
    source: {
      title: "Golden Gate Bridge — Design & Construction Stats",
      url: "https://www.goldengate.org/bridge/history-research/statistics-data/design-construction-stats/",
    },
    explanation: "The suspended structure's main span between the Golden Gate Bridge's towers is 1,280 metres.",
  },
  {
    id: "technology-length-gotthard-base-tunnel",
    category: "technology",
    measure: "size",
    subtype: "length",
    prompt: "How long is Switzerland's Gotthard Base Tunnel?",
    answer: 57.1,
    min: 5,
    max: 500,
    scale: "log",
    unit: "kilometre",
    source: {
      title: "Swiss Federal Authorities — New Rail Link through the Alps",
      url: "https://www.aboutswitzerland.eda.admin.ch/en/the-new-rail-link-through-the-alps-nrla-serving-europe",
    },
    explanation: "Switzerland's federal information service lists the Gotthard Base Tunnel at 57.1 kilometres long.",
  },
  {
    id: "technology-length-iridium-orbit-altitude",
    category: "technology",
    measure: "size",
    subtype: "length",
    prompt: "How high above Earth does the Iridium satellite network orbit?",
    answer: 780,
    min: 100,
    max: 5000,
    scale: "log",
    unit: "kilometre",
    source: {
      title: "Iridium — Network",
      url: "https://www.iridium.com/network/",
    },
    explanation: "Iridium’s communications constellation operates in low Earth orbit about 780 kilometres above Earth.",
  },
  {
    id: "technology-length-millau-viaduct",
    category: "technology",
    measure: "size",
    subtype: "length",
    prompt: "How long is France's Millau Viaduct?",
    answer: 2460,
    min: 300,
    max: 12000,
    scale: "log",
    unit: "metre",
    source: {
      title: "Eiffage — Millau Viaduct documentary",
      url: "https://www.eiffage.com/en/media/news/millau-le-viaduc-de-limpossible--the-documentary-that-broke-ratings-records-is-being-rebroadcast-on-thursday-20-april",
    },
    explanation: "Eiffage states that the Millau Viaduct is 2,460 metres long.",
  },
  {
    id: "technology-length-queen-mary-2",
    category: "technology",
    measure: "size",
    subtype: "length",
    prompt: "How long is Cunard's Queen Mary 2?",
    answer: 345,
    min: 50,
    max: 2000,
    scale: "log",
    unit: "metre",
    source: {
      title: "Cunard — Queen Mary 2",
      url: "https://www.cunard.com/en-us/cruise-ships/queen-mary-2/9",
    },
    explanation: "Cunard lists its Queen Mary 2 ocean liner at 345 metres long.",
  },
  {
    id: "technology-length-sg-14-222-rotor",
    category: "technology",
    measure: "size",
    subtype: "length",
    prompt: "What rotor diameter does the Siemens Gamesa SG 14-222 turbine use?",
    answer: 222,
    min: 20,
    max: 2000,
    scale: "log",
    unit: "metre",
    source: {
      title: "Siemens Gamesa — SG 14-222",
      url: "https://www.siemensgamesa.com/global/en/home/products-and-services/offshore/wind-turbine-sg-14-222-dd.html",
    },
    explanation: "The Siemens Gamesa SG 14-222 offshore wind turbine uses a 222-metre rotor with 108-metre blades.",
  },
  {
    id: "technology-length-sydney-harbour-bridge-height",
    category: "technology",
    measure: "size",
    subtype: "length",
    prompt: "How high is the Sydney Harbour Bridge above the harbour at its highest point?",
    answer: 134,
    min: 20,
    max: 1000,
    scale: "log",
    unit: "metre",
    source: {
      title: "NSW Government — Sydney Harbour Bridge",
      url: "https://www.nsw.gov.au/visiting-and-exploring-nsw/locations-and-attractions/sydney-harbour-bridge",
    },
    explanation: "The highest point of the Sydney Harbour Bridge stands 134 metres above the harbour.",
  },
  {
    id: "technology-length-vlt-primary-mirror",
    category: "technology",
    measure: "size",
    subtype: "length",
    prompt: "What is the diameter of each primary mirror on ESO's Very Large Telescope?",
    answer: 8.2,
    min: 1,
    max: 50,
    scale: "log",
    unit: "metre",
    source: {
      title: "European Southern Observatory — Very Large Telescope",
      url: "https://www.eso.org/public/teles-instr/paranal-observatory/vlt/",
    },
    explanation: "Each of the Very Large Telescope's four Unit Telescopes has an 8.2-metre primary mirror.",
  },
  {
    id: "technology-area-balbina-dam-reservoir",
    category: "technology",
    measure: "size",
    subtype: "area",
    prompt: "What surface area does the Balbina Dam reservoir cover?",
    answer: 2360,
    min: 100,
    max: 30000,
    scale: "log",
    unit: "square-kilometre",
    source: {
      title: "NASA Science — Balbina Dam impact, Brazil",
      url: "https://science.nasa.gov/earth/balbina-dam-impact-brazil/",
    },
    explanation: "NASA reports that the reservoir behind Brazil's Balbina Dam covers 2,360 square kilometres.",
  },
  {
    id: "technology-area-three-gorges-reservoir",
    category: "technology",
    measure: "size",
    subtype: "area",
    prompt: "What surface area does the Three Gorges Reservoir cover?",
    answer: 1045,
    min: 100,
    max: 20000,
    scale: "log",
    unit: "square-kilometre",
    source: {
      title: "U.S. Geological Survey — Three Gorges Dam",
      url: "https://www.usgs.gov/water-science-school/science/three-gorges-dam-worlds-largest-hydroelectric-plant",
    },
    explanation: "The U.S. Geological Survey gives the Three Gorges Reservoir a surface area of about 1,045 square kilometres.",
  },
  {
    id: "size-mass-big-ben-bell",
    category: "technology",
    measure: "size",
    subtype: "mass",
    prompt: "How heavy is Big Ben, the great bell in the Elizabeth Tower at Westminster?",
    answer: 13760,
    min: 50,
    max: 200000,
    scale: "log",
    unit: "kilogram",
    source: {
      title: "Encyclopaedia Britannica — Big Ben",
      url: "https://www.britannica.com/topic/Big-Ben-clock-London",
    },
    explanation: "About 13,760 kilograms. Big Ben is the bell itself, not the tower or the clock, and it cracked shortly after being installed.",
  },
  {
    id: "size-mass-boeing-747",
    category: "technology",
    measure: "size",
    subtype: "mass",
    prompt: "What is the maximum take-off weight of a Boeing 747-400?",
    answer: 396890,
    min: 5000,
    max: 2000000,
    scale: "log",
    unit: "kilogram",
    source: {
      title: "Encyclopaedia Britannica — Boeing 747",
      url: "https://www.britannica.com/technology/Boeing-747",
    },
    explanation: "About 396,890 kilograms fully loaded, of which more than a third can be fuel on the longest routes.",
  },
  {
    id: "size-mass-eiffel-tower",
    category: "technology",
    measure: "size",
    subtype: "mass",
    prompt: "How much does the iron structure of the Eiffel Tower weigh, excluding its foundations?",
    answer: 7300,
    min: 50,
    max: 100000,
    scale: "log",
    unit: "tonne",
    source: {
      title: "Encyclopaedia Britannica — Eiffel Tower",
      url: "https://www.britannica.com/topic/Eiffel-Tower-Paris-France",
    },
    explanation: "The puddled iron lattice weighs about 7,300 tonnes. Spread over its base, the tower presses down about as hard as a seated adult.",
  },
  {
    id: "size-mass-great-pyramid",
    category: "technology",
    measure: "size",
    subtype: "mass",
    prompt: "Roughly how much stone was used to build the Great Pyramid of Giza?",
    answer: 5750000,
    min: 10000,
    max: 50000000,
    scale: "log",
    unit: "tonne",
    source: {
      title: "Encyclopaedia Britannica — Pyramids of Giza",
      url: "https://www.britannica.com/topic/Pyramids-of-Giza",
    },
    explanation: "Estimates centre on about 5.75 million tonnes, made up of roughly 2.3 million blocks averaging over two tonnes each.",
  },
  {
    id: "size-mass-titanic",
    category: "technology",
    measure: "size",
    subtype: "mass",
    prompt: "What was the displacement of the RMS Titanic when fully loaded?",
    answer: 52310,
    min: 500,
    max: 500000,
    scale: "log",
    unit: "tonne",
    source: {
      title: "Encyclopaedia Britannica — Titanic",
      url: "https://www.britannica.com/topic/Titanic",
    },
    explanation: "About 52,310 tonnes. She was the largest ship afloat when she sailed, and modern cruise ships are several times heavier.",
  },
  {
    id: "technology-mass-airbus-a380-mtow",
    category: "technology",
    measure: "size",
    subtype: "mass",
    prompt: "What is the maximum take-off weight of the Airbus A380?",
    answer: 575,
    min: 50,
    max: 5000,
    scale: "log",
    unit: "tonne",
    source: {
      title: "Airbus — A380 Facts and Figures",
      url: "https://www.airbus.com/sites/g/files/jlcbta136/files/2021-10/EN-Airbus-A380-Facts-and-Figures_0.pdf",
    },
    explanation: "Airbus lists the A380's maximum take-off weight as 575 tonnes.",
  },
  {
    id: "technology-mass-ariane-5-eca-gto-payload",
    category: "technology",
    measure: "size",
    subtype: "mass",
    prompt: "What payload could Ariane 5 ECA carry into geostationary transfer orbit?",
    answer: 10,
    min: 1,
    max: 80,
    scale: "log",
    unit: "tonne",
    source: {
      title: "ESA — Ariane 5 ECA",
      url: "https://www.esa.int/Enabling_Support/Space_Transportation/Ariane/Ariane_5_ECA",
    },
    explanation: "ESA lists Ariane 5 ECA's payload mass into geostationary transfer orbit as 10 tonnes.",
  },
  {
    id: "technology-mass-cat-797f-payload",
    category: "technology",
    measure: "size",
    subtype: "mass",
    prompt: "What is the nominal payload of a Caterpillar 797F mining truck?",
    answer: 363,
    min: 50,
    max: 1000,
    scale: "log",
    unit: "tonne",
    source: {
      title: "Caterpillar — 797F Mining Trucks",
      url: "https://www.cat.com/en_US/products/new/equipment/off-highway-trucks/mining-trucks/18093014.html",
    },
    explanation: "Caterpillar rates the 797F mining truck's nominal payload at 363 tonnes.",
  },
  {
    id: "technology-mass-cern-atlas-detector",
    category: "technology",
    measure: "size",
    subtype: "mass",
    prompt: "How much does CERN's ATLAS detector weigh?",
    answer: 7000,
    min: 500,
    max: 100000,
    scale: "log",
    unit: "tonne",
    source: {
      title: "ATLAS Experiment — Detector & Technology",
      url: "https://atlas.cern/Discover/Detector",
    },
    explanation: "CERN's ATLAS particle detector weighs 7,000 tonnes and is 46 metres long.",
  },
  {
    id: "technology-mass-liebherr-t284-gvw",
    category: "technology",
    measure: "size",
    subtype: "mass",
    prompt: "What is the gross vehicle weight of a Liebherr T 284 mining truck?",
    answer: 605,
    min: 50,
    max: 5000,
    scale: "log",
    unit: "tonne",
    source: {
      title: "Liebherr — T 284",
      url: "https://www.liebherr.com/en-gb/mining-equipment/equipment/mining-trucks/t284-8361178",
    },
    explanation: "Liebherr lists the T 284 mining truck's gross vehicle weight as 605 tonnes.",
  },
  {
    id: "technology-mass-macbook-air-m1-2020",
    category: "technology",
    measure: "size",
    subtype: "mass",
    prompt: "How much did Apple's 2020 M1 MacBook Air weigh?",
    answer: 1.29,
    min: 0.3,
    max: 5,
    scale: "log",
    unit: "kilogram",
    source: {
      title: "Apple Support — MacBook Air (M1, 2020) Technical Specifications",
      url: "https://support.apple.com/en-gb/111883",
    },
    explanation: "Apple lists the 2020 M1 MacBook Air's weight as 1.29 kilograms.",
  },
  {
    id: "technology-mass-ps5-launch-model",
    category: "technology",
    measure: "size",
    subtype: "mass",
    prompt: "How much did the disc-drive PlayStation 5 launch model weigh in 2020?",
    answer: 4.5,
    min: 0.5,
    max: 50,
    scale: "log",
    unit: "kilogram",
    source: {
      title: "PlayStation Blog — PlayStation 5 launches in November",
      url: "https://blog.playstation.com/2020/09/16/playstation-5-launches-in-november-starting-at-399-for-ps5-digital-edition-and-499-for-ps5-with-ultra-hd-blu-ray-disc-drive/",
    },
    explanation: "Sony listed the 2020 disc-drive PlayStation 5 launch model at 4.5 kilograms.",
  },
  {
    id: "daily-eniac-vacuum-tube-count",
    category: "technology",
    measure: "quantity",
    subtype: "count",
    prompt: "About how many vacuum tubes did the ENIAC computer use?",
    answer: 18000,
    min: 200,
    max: 40000,
    scale: "log",
    unit: "count",
    source: {
      title: "National Museum of American History - ENIAC Accumulator",
      url: "https://americanhistory.si.edu/collections/nmah_334742",
    },
    explanation: "ENIAC used roughly 18,000 vacuum tubes and filled an entire room while performing electronic calculations.",
  },
  {
    id: "daily-intel-4004-transistor-count",
    category: "technology",
    measure: "quantity",
    subtype: "count",
    prompt: "How many transistors did Intel's 4004 microprocessor contain?",
    answer: 2300,
    min: 1000,
    max: 80000,
    scale: "log",
    unit: "count",
    source: {
      title: "Intel - 30th Anniversary of the Microprocessor",
      url: "https://www.intel.com/pressroom/archive/releases/2001/20011115corp_a.htm",
    },
    explanation: "Intel's 4004 microprocessor contained just 2,300 transistors when it was introduced in 1971.",
  },
  {
    id: "technology-count-apple-m1-transistors",
    category: "technology",
    measure: "quantity",
    subtype: "count",
    prompt: "How many transistors are on Apple's M1 chip, released in 2020?",
    answer: 16000000000,
    min: 100000000,
    max: 200000000000,
    scale: "log",
    unit: "count",
    source: {
      title: "Apple Newsroom — Apple unleashes M1",
      url: "https://www.apple.com/newsroom/2020/11/apple-unleashes-m1/",
    },
    explanation: "Apple's 2020 M1 system on a chip contains 16 billion transistors and was built using a 5-nanometre process.",
  },
  {
    id: "technology-count-ibm-305-ramac-storage",
    category: "technology",
    measure: "quantity",
    subtype: "count",
    prompt: "How many characters could IBM's 305 RAMAC store when unveiled in 1956?",
    answer: 5000000,
    min: 100000,
    max: 100000000,
    scale: "log",
    unit: "count",
    source: {
      title: "IBM Heritage — RAMAC",
      url: "https://www.ibm.com/history/ramac",
    },
    explanation: "IBM's RAMAC disk storage system held 5 million seven-bit, binary decimal encoded characters.",
  },
  {
    id: "technology-count-intel-pentium-transistors",
    category: "technology",
    measure: "quantity",
    subtype: "count",
    prompt: "How many transistors did Intel's original Pentium processor have in 1993?",
    answer: 3100000,
    min: 100000,
    max: 100000000,
    scale: "log",
    unit: "count",
    source: {
      title: "Intel Timeline — The Birth of Pentium",
      url: "https://timeline.intel.com/1993/the-birth-of-pentium",
    },
    explanation: "Intel's original Pentium processor, released in 1993, contained 3.1 million transistors.",
  },
  {
    id: "technology-count-nvidia-h100-transistors",
    category: "technology",
    measure: "quantity",
    subtype: "count",
    prompt: "How many transistors are on NVIDIA's H100 GPU, announced in 2022?",
    answer: 80000000000,
    min: 1000000000,
    max: 1000000000000,
    scale: "log",
    unit: "count",
    source: {
      title: "NVIDIA Newsroom — NVIDIA Announces Hopper Architecture",
      url: "https://nvidianews.nvidia.com/news/nvidia-announces-hopper-architecture-the-next-generation-of-accelerated-computing",
    },
    explanation: "NVIDIA announced the H100 GPU in 2022 with 80 billion transistors, manufactured using a customised TSMC 4N process.",
  },
  {
    id: "technology-money-elon-musk-net-worth-2025",
    category: "technology",
    measure: "quantity",
    subtype: "money",
    prompt: "What was Elon Musk's net worth on Forbes' 2025 billionaires list?",
    answer: 342000000000,
    min: 1000000000,
    max: 1000000000000,
    scale: "log",
    unit: "usd",
    referenceYear: "2025",
    source: {
      title: "Forbes Australia — World’s Billionaires List 2025",
      url: "https://www.forbes.com.au/news/billionaires/forbes-worlds-billionaires-list-2025-the-top-200/",
    },
    explanation: "Forbes valued Elon Musk at $342 billion using stock prices and exchange rates from 7 March 2025.",
  },
  {
    id: "technology-money-iphone-8gb-launch-price",
    category: "technology",
    measure: "quantity",
    subtype: "money",
    prompt: "What was the US launch price of the 8GB original iPhone in 2007?",
    answer: 599,
    min: 100,
    max: 3000,
    scale: "log",
    unit: "usd",
    referenceYear: "2007",
    source: {
      title: "Apple Newsroom — Apple Reinvents the Phone with iPhone",
      url: "https://www.apple.com/newsroom/2007/01/09Apple-Reinvents-the-Phone-with-iPhone/",
    },
    explanation: "Apple announced the 8GB original iPhone for $599 in the United States, with availability planned for June 2007.",
  },
  {
    id: "technology-money-jensen-huang-net-worth-2025",
    category: "technology",
    measure: "quantity",
    subtype: "money",
    prompt: "What was Jensen Huang's net worth on Forbes' 2025 billionaires list?",
    answer: 98700000000,
    min: 1000000000,
    max: 1000000000000,
    scale: "log",
    unit: "usd",
    referenceYear: "2025",
    source: {
      title: "Forbes Australia — World’s Billionaires List 2025",
      url: "https://www.forbes.com.au/news/billionaires/forbes-worlds-billionaires-list-2025-the-top-200/",
    },
    explanation: "Forbes valued NVIDIA cofounder and CEO Jensen Huang at $98.7 billion on its 2025 list.",
  },
  {
    id: "technology-money-voyager-mission-cost",
    category: "technology",
    measure: "quantity",
    subtype: "money",
    prompt: "What did the Voyager 1 and 2 missions cost through the 1989 Neptune encounter?",
    answer: 865000000,
    min: 10000000,
    max: 10000000000,
    scale: "log",
    unit: "usd",
    referenceYear: "1989",
    source: {
      title: "NASA Science — Voyager Fact Sheet",
      url: "https://science.nasa.gov/mission/voyager/fact-sheet/",
    },
    explanation: "NASA puts the combined cost through Voyager 2's 1989 Neptune encounter at $865 million, including launch, operations and nuclear batteries.",
  },
  {
    id: "technology-duration-apollo-11-mission",
    category: "technology",
    measure: "physics",
    subtype: "duration",
    prompt: "How long did Apollo 11 last from launch to splashdown?",
    answer: 195.3,
    min: 24,
    max: 1000,
    scale: "log",
    unit: "hour",
    source: {
      title: "NASA — Apollo 11 Mission Overview",
      url: "https://www.nasa.gov/history/apollo-11-mission-overview/",
    },
    explanation: "Apollo 11 lasted 195 hours, 18 minutes and 35 seconds from launch to splashdown.",
  },
  {
    id: "physics-speed-boeing-747",
    category: "technology",
    measure: "physics",
    subtype: "speed",
    prompt: "What is the typical cruising speed of a Boeing 747?",
    answer: 917,
    min: 50,
    max: 5000,
    scale: "log",
    unit: "kph",
    source: {
      title: "Encyclopaedia Britannica — Boeing 747",
      url: "https://www.britannica.com/technology/Boeing-747",
    },
    explanation: "About 917 kilometres per hour, roughly 85 percent of the speed of sound, which is close to the practical limit for a subsonic airliner.",
  },
  {
    id: "physics-speed-concorde",
    category: "technology",
    measure: "physics",
    subtype: "speed",
    prompt: "What was Concorde's normal cruising speed?",
    answer: 2180,
    min: 50,
    max: 10000,
    scale: "log",
    unit: "kph",
    source: {
      title: "Encyclopaedia Britannica — Concorde",
      url: "https://www.britannica.com/technology/Concorde",
    },
    explanation: "About 2,180 kilometres per hour, twice the speed of sound, crossing the Atlantic in under three and a half hours.",
  },
  {
    id: "technology-speed-tokaido-shinkansen-2023",
    category: "technology",
    measure: "physics",
    subtype: "speed",
    prompt: "What maximum speed did JR Central list for the Tokaido Shinkansen in 2023?",
    answer: 285,
    min: 50,
    max: 1000,
    scale: "log",
    unit: "kph",
    source: {
      title: "JR Central — About the Shinkansen",
      url: "https://global.jr-central.co.jp/en/company/about_shinkansen/?Tag=Google",
    },
    explanation: "JR Central listed the Tokaido Shinkansen’s maximum operating speed as 285 kilometres per hour in March 2023.",
  },
  {
    id: "technology-speed-x15-1967-flight",
    category: "technology",
    measure: "physics",
    subtype: "speed",
    prompt: "What top speed did NASA's X-15 rocket plane reach in 1967?",
    answer: 7274,
    min: 500,
    max: 30000,
    scale: "log",
    unit: "kph",
    source: {
      title: "NASA — X-15 speed flight, 3 October 1967",
      url: "https://www.nasa.gov/image-article/december-3-1968/",
    },
    explanation: "Pete Knight flew the X-15A-2 to 7,274 kilometres per hour, or Mach 6.72, on 3 October 1967.",
  },
  {
    id: "movies-event-casablanca-release",
    category: "movies",
    measure: "history",
    subtype: "event",
    prompt: "In what year was the film Casablanca released?",
    answer: 1942,
    min: 1920,
    max: 2000,
    scale: "linear",
    unit: "year",
    source: {
      title: "Encyclopaedia Britannica — Casablanca",
      url: "https://www.britannica.com/topic/Casablanca-film-by-Curtiz",
    },
    explanation: "Released in 1942, it won three Academy Awards including best picture from eight nominations.",
  },
  {
    id: "movies-event-et-extra-terrestrial-release-year",
    category: "movies",
    measure: "history",
    subtype: "event",
    prompt: "In what year was E.T. the Extra-Terrestrial first released in cinemas?",
    answer: 1982,
    min: 1895,
    max: 2026,
    scale: "linear",
    unit: "year",
    referenceYear: "2026",
    source: {
      title: "Box Office Mojo - E.T. the Extra-Terrestrial",
      url: "https://www.boxofficemojo.com/releasegroup/gr2980663813/",
    },
    explanation: "E.T. the Extra-Terrestrial was first released in cinemas in 1982 and became one of Steven Spielberg's most famous films.",
  },
  {
    id: "movies-event-forrest-gump-release-year",
    category: "movies",
    measure: "history",
    subtype: "event",
    prompt: "In what year was Forrest Gump first released in cinemas?",
    answer: 1994,
    min: 1895,
    max: 2026,
    scale: "linear",
    unit: "year",
    referenceYear: "2026",
    source: {
      title: "Box Office Mojo - Forrest Gump",
      url: "https://www.boxofficemojo.com/releasegroup/gr2428654085/",
    },
    explanation: "Forrest Gump was first released in cinemas in 1994 and became one of the year's biggest films.",
  },
  {
    id: "movies-event-guardians-galaxy-vol-two-release-year",
    category: "movies",
    measure: "history",
    subtype: "event",
    prompt: "In what year was Guardians of the Galaxy Vol. 2 first released in cinemas?",
    answer: 2017,
    min: 1996,
    max: 2026,
    scale: "linear",
    unit: "year",
    referenceYear: "2026",
    source: {
      title: "Box Office Mojo - Guardians of the Galaxy Vol. 2",
      url: "https://www.boxofficemojo.com/releasegroup/gr388583941/",
    },
    explanation: "Guardians of the Galaxy Vol. 2 was first released in cinemas in 2017 as the second Guardians film in the MCU.",
  },
  {
    id: "movies-event-ice-age-release-year",
    category: "movies",
    measure: "history",
    subtype: "event",
    prompt: "In what year was Ice Age first released in cinemas?",
    answer: 2002,
    min: 1960,
    max: 2026,
    scale: "linear",
    unit: "year",
    referenceYear: "2026",
    source: {
      title: "Box Office Mojo - Ice Age",
      url: "https://www.boxofficemojo.com/releasegroup/gr3068547589/",
    },
    explanation: "Ice Age was first released in cinemas in 2002 and launched Blue Sky Studios' long-running animated franchise.",
  },
  {
    id: "movies-event-jaws-release",
    category: "movies",
    measure: "history",
    subtype: "event",
    prompt: "In what year was Steven Spielberg's Jaws released?",
    answer: 1975,
    min: 1900,
    max: 2000,
    scale: "linear",
    unit: "year",
    source: {
      title: "Encyclopaedia Britannica — Jaws",
      url: "https://www.britannica.com/topic/Jaws-film-by-Spielberg",
    },
    explanation: "Jaws opened in June 1975 and is widely credited with inventing the summer blockbuster.",
  },
  {
    id: "movies-event-jurassic-park-release",
    category: "movies",
    measure: "history",
    subtype: "event",
    prompt: "In what year was Jurassic Park released?",
    answer: 1993,
    min: 1940,
    max: 2010,
    scale: "linear",
    unit: "year",
    source: {
      title: "Encyclopaedia Britannica — Jurassic Park",
      url: "https://www.britannica.com/topic/Jurassic-Park-film-by-Spielberg",
    },
    explanation: "The 1993 original mixed animatronics with early computer animation and grossed over a billion dollars.",
  },
  {
    id: "movies-event-kung-fu-panda-two-release-year",
    category: "movies",
    measure: "history",
    subtype: "event",
    prompt: "In what year was Kung Fu Panda 2 first released in cinemas?",
    answer: 2011,
    min: 1980,
    max: 2026,
    scale: "linear",
    unit: "year",
    referenceYear: "2026",
    source: {
      title: "Box Office Mojo - Kung Fu Panda 2",
      url: "https://www.boxofficemojo.com/releasegroup/gr796611077/",
    },
    explanation: "Kung Fu Panda 2 was first released in cinemas in 2011 as the sequel to DreamWorks Animation's 2008 hit.",
  },
  {
    id: "movies-event-marley-and-me-release-year",
    category: "movies",
    measure: "history",
    subtype: "event",
    prompt: "In what year was Marley & Me first released in cinemas?",
    answer: 2008,
    min: 1975,
    max: 2026,
    scale: "linear",
    unit: "year",
    referenceYear: "2026",
    source: {
      title: "Box Office Mojo - Marley & Me",
      url: "https://www.boxofficemojo.com/releasegroup/gr2166903301/",
    },
    explanation: "Marley & Me was first released in cinemas in 2008, adapting John Grogan's memoir for the screen.",
  },
  {
    id: "movies-event-murder-on-orient-express-release-year",
    category: "movies",
    measure: "history",
    subtype: "event",
    prompt: "In what year was Murder on the Orient Express first released in cinemas?",
    answer: 2017,
    min: 1996,
    max: 2026,
    scale: "linear",
    unit: "year",
    referenceYear: "2026",
    source: {
      title: "Box Office Mojo - Murder on the Orient Express",
      url: "https://www.boxofficemojo.com/releasegroup/gr550195717/",
    },
    explanation: "Murder on the Orient Express was first released in cinemas in 2017, with Kenneth Branagh directing and starring as Hercule Poirot.",
  },
  {
    id: "movies-event-pulp-fiction-release-year",
    category: "movies",
    measure: "history",
    subtype: "event",
    prompt: "In what year was Pulp Fiction first released in cinemas?",
    answer: 1994,
    min: 1895,
    max: 2026,
    scale: "linear",
    unit: "year",
    referenceYear: "2026",
    source: {
      title: "Box Office Mojo - Pulp Fiction",
      url: "https://www.boxofficemojo.com/releasegroup/gr1674924549/",
    },
    explanation: "Pulp Fiction was first released in cinemas in 1994 and became one of Quentin Tarantino's defining films.",
  },
  {
    id: "movies-event-snow-white-release",
    category: "movies",
    measure: "history",
    subtype: "event",
    prompt: "In what year was Snow White and the Seven Dwarfs, the first full-length animated feature from an American studio, released?",
    answer: 1937,
    min: 1920,
    max: 2000,
    scale: "linear",
    unit: "year",
    source: {
      title: "Encyclopaedia Britannica — Snow White and the Seven Dwarfs",
      url: "https://www.britannica.com/topic/Snow-White-and-the-Seven-Dwarfs-film-1937",
    },
    explanation: "Disney released it in 1937, proving a feature-length cartoon could hold an audience.",
  },
  {
    id: "movies-event-star-wars-release",
    category: "movies",
    measure: "history",
    subtype: "event",
    prompt: "In what year was the first Star Wars film, Episode IV: A New Hope, released?",
    answer: 1977,
    min: 1900,
    max: 2000,
    scale: "linear",
    unit: "year",
    source: {
      title: "Encyclopaedia Britannica — Star Wars: Episode IV—A New Hope",
      url: "https://www.britannica.com/topic/Star-Wars-film-by-Lucas",
    },
    explanation: "It reached cinemas in May 1977 and changed what special effects were expected to do.",
  },
  {
    id: "movies-event-the-matrix-release",
    category: "movies",
    measure: "history",
    subtype: "event",
    prompt: "In what year was The Matrix released?",
    answer: 1999,
    min: 1950,
    max: 2020,
    scale: "linear",
    unit: "year",
    source: {
      title: "Encyclopaedia Britannica — The Matrix",
      url: "https://www.britannica.com/topic/The-Matrix",
    },
    explanation: "The Wachowskis released it in 1999, and its bullet-time effect was imitated for a decade.",
  },
  {
    id: "movies-event-the-simpsons-movie-release-year",
    category: "movies",
    measure: "history",
    subtype: "event",
    prompt: "In what year was The Simpsons Movie first released in cinemas?",
    answer: 2007,
    min: 1970,
    max: 2026,
    scale: "linear",
    unit: "year",
    referenceYear: "2026",
    source: {
      title: "Box Office Mojo - The Simpsons Movie",
      url: "https://www.boxofficemojo.com/releasegroup/gr218583557/",
    },
    explanation: "The Simpsons Movie was first released in cinemas in 2007, bringing the long-running animated TV series to theatres.",
  },
  {
    id: "movies-event-uncle-buck-release-year",
    category: "movies",
    measure: "history",
    subtype: "event",
    prompt: "In what year was Uncle Buck first released in cinemas?",
    answer: 1989,
    min: 1895,
    max: 2026,
    scale: "linear",
    unit: "year",
    referenceYear: "2026",
    source: {
      title: "Box Office Mojo - Uncle Buck",
      url: "https://www.boxofficemojo.com/releasegroup/gr1091785221/",
    },
    explanation: "Uncle Buck was first released in cinemas in 1989, with John Candy starring in the title role.",
  },
  {
    id: "movies-et-extra-terrestrial-oscar-wins",
    category: "movies",
    measure: "quantity",
    subtype: "count",
    prompt: "How many Academy Awards did E.T. the Extra-Terrestrial win at the 1983 Oscars?",
    answer: 4,
    min: 0,
    max: 9,
    scale: "linear",
    unit: "count",
    source: {
      title: "Academy of Motion Picture Arts and Sciences — The 55th Academy Awards | 1983",
      url: "https://www.oscars.org/oscars/ceremonies/1983",
    },
    explanation: "E.T. the Extra-Terrestrial won four Academy Awards from nine nominations.",
  },
  {
    id: "movies-finding-dory-maximum-theaters",
    category: "movies",
    measure: "quantity",
    subtype: "count",
    prompt: "According to The Numbers as of 2026, what was Finding Dory's maximum domestic theater count?",
    answer: 4305,
    min: 3000,
    max: 5000,
    scale: "linear",
    unit: "count",
    referenceYear: "2026",
    source: {
      title: "The Numbers — Finding Dory",
      url: "https://www.the-numbers.com/movie/Finding-Dory",
    },
    explanation: "Finding Dory reached a maximum of 4,305 domestic theaters, the same total listed for its opening.",
  },
  {
    id: "movies-force-awakens-maximum-theaters",
    category: "movies",
    measure: "quantity",
    subtype: "count",
    prompt: "According to The Numbers as of 2026, what was Star Wars: The Force Awakens' maximum domestic theater count?",
    answer: 4134,
    min: 3000,
    max: 4700,
    scale: "linear",
    unit: "count",
    referenceYear: "2026",
    source: {
      title: "The Numbers — Star Wars Ep. VII: The Force Awakens",
      url: "https://www.the-numbers.com/movie/Star-Wars-Ep-VII-The-Force-Awakens",
    },
    explanation: "The Force Awakens reached a maximum of 4,134 domestic theaters, matching its opening theater count.",
  },
  {
    id: "movies-forrest-gump-oscar-wins",
    category: "movies",
    measure: "quantity",
    subtype: "count",
    prompt: "How many Academy Awards did Forrest Gump win at the 1995 Oscars?",
    answer: 6,
    min: 0,
    max: 12,
    scale: "linear",
    unit: "count",
    source: {
      title: "Academy of Motion Picture Arts and Sciences — The 67th Academy Awards | 1995",
      url: "https://www.oscars.org/oscars/ceremonies/1995",
    },
    explanation: "Forrest Gump won six Academy Awards from 13 nominations, including Best Picture.",
  },
  {
    id: "movies-inception-oscar-wins",
    category: "movies",
    measure: "quantity",
    subtype: "count",
    prompt: "How many Academy Awards did Inception win at the 2011 Oscars?",
    answer: 4,
    min: 0,
    max: 9,
    scale: "linear",
    unit: "count",
    source: {
      title: "Academy of Motion Picture Arts and Sciences — The 83rd Academy Awards | 2011",
      url: "https://www.oscars.org/oscars/ceremonies/2011",
    },
    explanation: "Inception won four Academy Awards from eight nominations, taking cinematography, sound editing, sound mixing and visual effects.",
  },
  {
    id: "movies-jurassic-park-oscar-wins",
    category: "movies",
    measure: "quantity",
    subtype: "count",
    prompt: "How many Academy Awards did Jurassic Park win at the 1994 Oscars?",
    answer: 3,
    min: 0,
    max: 7,
    scale: "linear",
    unit: "count",
    source: {
      title: "Academy of Motion Picture Arts and Sciences — The 66th Academy Awards | 1994",
      url: "https://www.oscars.org/oscars/ceremonies/1994",
    },
    explanation: "Jurassic Park won all three Academy Awards for which it was nominated: sound, sound effects editing and visual effects.",
  },
  {
    id: "movies-jurassic-world-dominion-maximum-theaters",
    category: "movies",
    measure: "quantity",
    subtype: "count",
    prompt: "According to The Numbers as of 2026, what was Jurassic World: Dominion's maximum domestic theater count?",
    answer: 4697,
    min: 3500,
    max: 5200,
    scale: "linear",
    unit: "count",
    referenceYear: "2026",
    source: {
      title: "The Numbers — Jurassic World: Dominion (2022)",
      url: "https://www.the-numbers.com/movie/Jurassic-World-Dominion-%282022%29",
    },
    explanation: "Jurassic World: Dominion peaked at 4,697 domestic theaters after opening in 4,676.",
  },
  {
    id: "movies-mad-max-fury-road-oscar-wins",
    category: "movies",
    measure: "quantity",
    subtype: "count",
    prompt: "How many Academy Awards did Mad Max: Fury Road win at the 2016 Oscars?",
    answer: 6,
    min: 1,
    max: 10,
    scale: "linear",
    unit: "count",
    source: {
      title: "Academy of Motion Picture Arts and Sciences — The 88th Academy Awards | 2016",
      url: "https://www.oscars.org/oscars/ceremonies/2016",
    },
    explanation: "Mad Max: Fury Road won six Academy Awards from ten nominations.",
  },
  {
    id: "movies-mary-poppins-oscar-nominations",
    category: "movies",
    measure: "quantity",
    subtype: "count",
    prompt: "How many Academy Award nominations did Mary Poppins receive at the 1965 Oscars?",
    answer: 13,
    min: 2,
    max: 18,
    scale: "linear",
    unit: "count",
    source: {
      title: "Academy of Motion Picture Arts and Sciences — The 37th Academy Awards | 1965",
      url: "https://www.oscars.org/oscars/ceremonies/1965",
    },
    explanation: "Mary Poppins received 13 nominations and won five Academy Awards.",
  },
  {
    id: "movies-raiders-lost-ark-1982-oscar-awards",
    category: "movies",
    measure: "quantity",
    subtype: "count",
    prompt: "How many Academy Awards did Raiders of the Lost Ark receive at the 1982 ceremony, including its Special Achievement Award?",
    answer: 5,
    min: 0,
    max: 10,
    scale: "linear",
    unit: "count",
    source: {
      title: "Academy of Motion Picture Arts and Sciences — The 54th Academy Awards | 1982",
      url: "https://www.oscars.org/oscars/ceremonies/1982",
    },
    explanation: "Raiders of the Lost Ark received five awards: four competitive wins plus a Special Achievement Award for sound effects editing.",
  },
  {
    id: "movies-silence-of-the-lambs-oscar-wins",
    category: "movies",
    measure: "quantity",
    subtype: "count",
    prompt: "How many Academy Awards did The Silence of the Lambs win at the 1992 Oscars?",
    answer: 5,
    min: 0,
    max: 8,
    scale: "linear",
    unit: "count",
    source: {
      title: "Academy of Motion Picture Arts and Sciences — The 64th Academy Awards | 1992",
      url: "https://www.oscars.org/oscars/ceremonies/1992",
    },
    explanation: "The Silence of the Lambs won five Academy Awards from seven nominations, including Best Picture.",
  },
  {
    id: "movies-spider-man-no-way-home-maximum-theaters",
    category: "movies",
    measure: "quantity",
    subtype: "count",
    prompt: "According to The Numbers as of 2026, what was Spider-Man: No Way Home's maximum domestic theater count?",
    answer: 4336,
    min: 3000,
    max: 5000,
    scale: "linear",
    unit: "count",
    referenceYear: "2026",
    source: {
      title: "The Numbers — Spider-Man: No Way Home (2021)",
      url: "https://www.the-numbers.com/movie/Spider-Man-No-Way-Home-%282021%29",
    },
    explanation: "Spider-Man: No Way Home reached a maximum of 4,336 domestic theaters, the same number listed for its opening weekend.",
  },
  {
    id: "movies-star-wars-1978-oscar-awards",
    category: "movies",
    measure: "quantity",
    subtype: "count",
    prompt: "How many Academy Awards did Star Wars receive at the 1978 ceremony, including its Special Achievement Award?",
    answer: 7,
    min: 1,
    max: 12,
    scale: "linear",
    unit: "count",
    source: {
      title: "Academy of Motion Picture Arts and Sciences — The 50th Academy Awards | 1978",
      url: "https://www.oscars.org/oscars/ceremonies/1978",
    },
    explanation: "Star Wars received seven awards: six competitive wins plus a Special Achievement Award for sound effects.",
  },
  {
    id: "movies-the-dark-knight-oscar-wins",
    category: "movies",
    measure: "quantity",
    subtype: "count",
    prompt: "How many Academy Awards did The Dark Knight win at the 2009 Oscars?",
    answer: 2,
    min: 0,
    max: 7,
    scale: "linear",
    unit: "count",
    source: {
      title: "Academy of Motion Picture Arts and Sciences — The 81st Academy Awards | 2009",
      url: "https://www.oscars.org/oscars/ceremonies/2009",
    },
    explanation: "The Dark Knight won two Academy Awards from eight nominations: Supporting Actor and Sound Editing.",
  },
  {
    id: "movies-the-matrix-oscar-wins",
    category: "movies",
    measure: "quantity",
    subtype: "count",
    prompt: "How many Academy Awards did The Matrix win at the 2000 Oscars?",
    answer: 4,
    min: 0,
    max: 8,
    scale: "linear",
    unit: "count",
    source: {
      title: "Academy of Motion Picture Arts and Sciences — The 72nd Academy Awards | 2000",
      url: "https://www.oscars.org/oscars/ceremonies/2000",
    },
    explanation: "The Matrix won all four of its nominations: film editing, sound, sound effects editing and visual effects.",
  },
  {
    id: "movies-titanic-oscar-nominations",
    category: "movies",
    measure: "quantity",
    subtype: "count",
    prompt: "How many Academy Award nominations did Titanic receive at the 1998 Oscars?",
    answer: 14,
    min: 2,
    max: 18,
    scale: "linear",
    unit: "count",
    source: {
      title: "Academy of Motion Picture Arts and Sciences — The 70th Academy Awards | 1998",
      url: "https://www.oscars.org/oscars/ceremonies/1998",
    },
    explanation: "Titanic received 14 nominations and converted 11 of them into wins.",
  },
  {
    id: "movies-avatar-domestic-gross-share",
    category: "movies",
    measure: "quantity",
    subtype: "percentage",
    prompt: "According to The Numbers as of 2026, what percentage of Avatar's worldwide box office came from the domestic market?",
    answer: 26.9,
    min: 0,
    max: 100,
    scale: "linear",
    unit: "percent",
    referenceYear: "2026",
    source: {
      title: "The Numbers — Avatar (2009)",
      url: "https://www.the-numbers.com/movie/Avatar-%282009%29",
    },
    explanation: "The domestic market supplied 26.9% of Avatar's worldwide box office, leaving about 73.1% from international markets.",
  },
  {
    id: "movies-black-panther-domestic-gross-share",
    category: "movies",
    measure: "quantity",
    subtype: "percentage",
    prompt: "According to The Numbers as of 2026, what percentage of Black Panther's worldwide box office came from the domestic market?",
    answer: 52.5,
    min: 0,
    max: 100,
    scale: "linear",
    unit: "percent",
    referenceYear: "2026",
    source: {
      title: "The Numbers — Black Panther (2018)",
      url: "https://www.the-numbers.com/movie/Black-Panther-%282018%29",
    },
    explanation: "The domestic market supplied 52.5% of Black Panther's worldwide box office, narrowly exceeding its international share.",
  },
  {
    id: "movies-bohemian-rhapsody-domestic-gross-share",
    category: "movies",
    measure: "quantity",
    subtype: "percentage",
    prompt: "According to The Numbers as of 2026, what percentage of Bohemian Rhapsody's worldwide box office came from the domestic market?",
    answer: 24.6,
    min: 0,
    max: 100,
    scale: "linear",
    unit: "percent",
    referenceYear: "2026",
    source: {
      title: "The Numbers — Bohemian Rhapsody (2018)",
      url: "https://www.the-numbers.com/movie/Bohemian-Rhapsody-%282018%29",
    },
    explanation: "The domestic market supplied 24.6% of Bohemian Rhapsody's worldwide box office, with about 75.4% coming internationally.",
  },
  {
    id: "movies-despicable-me-3-domestic-gross-share",
    category: "movies",
    measure: "quantity",
    subtype: "percentage",
    prompt: "According to The Numbers as of 2026, what percentage of Despicable Me 3's worldwide box office came from the domestic market?",
    answer: 25.6,
    min: 0,
    max: 100,
    scale: "linear",
    unit: "percent",
    referenceYear: "2026",
    source: {
      title: "The Numbers — Despicable Me 3",
      url: "https://www.the-numbers.com/movie/Despicable-Me-3",
    },
    explanation: "The domestic market supplied 25.6% of Despicable Me 3's worldwide box office, so roughly three quarters came internationally.",
  },
  {
    id: "movies-frozen-domestic-gross-share",
    category: "movies",
    measure: "quantity",
    subtype: "percentage",
    prompt: "According to The Numbers as of 2026, what percentage of Frozen's worldwide box office came from the domestic market?",
    answer: 31.6,
    min: 0,
    max: 100,
    scale: "linear",
    unit: "percent",
    referenceYear: "2026",
    source: {
      title: "The Numbers — Frozen (2013)",
      url: "https://www.the-numbers.com/movie/Frozen-%282013%29",
    },
    explanation: "The domestic market supplied 31.6% of Frozen's worldwide box office, leaving about 68.4% from international markets.",
  },
  {
    id: "movies-hunger-games-domestic-gross-share",
    category: "movies",
    measure: "quantity",
    subtype: "percentage",
    prompt: "According to The Numbers as of 2026, what percentage of The Hunger Games' worldwide box office came from the domestic market?",
    answer: 60.2,
    min: 0,
    max: 100,
    scale: "linear",
    unit: "percent",
    referenceYear: "2026",
    source: {
      title: "The Numbers — The Hunger Games",
      url: "https://www.the-numbers.com/movie/Hunger-Games-The",
    },
    explanation: "The domestic market supplied 60.2% of The Hunger Games' worldwide box office, making it the larger side of the film's global total.",
  },
  {
    id: "movies-skyfall-domestic-gross-share",
    category: "movies",
    measure: "quantity",
    subtype: "percentage",
    prompt: "According to The Numbers as of 2026, what percentage of Skyfall's worldwide box office came from the domestic market?",
    answer: 27.4,
    min: 0,
    max: 100,
    scale: "linear",
    unit: "percent",
    referenceYear: "2026",
    source: {
      title: "The Numbers — Skyfall",
      url: "https://www.the-numbers.com/movie/Skyfall",
    },
    explanation: "The domestic market supplied 27.4% of Skyfall's worldwide box office, so nearly three quarters came from international markets.",
  },
  {
    id: "movies-super-mario-bros-domestic-gross-share",
    category: "movies",
    measure: "quantity",
    subtype: "percentage",
    prompt: "According to The Numbers as of 2026, what percentage of The Super Mario Bros. Movie's worldwide box office came from the domestic market?",
    answer: 42.3,
    min: 0,
    max: 100,
    scale: "linear",
    unit: "percent",
    referenceYear: "2026",
    source: {
      title: "The Numbers — The Super Mario Bros. Movie (2023)",
      url: "https://www.the-numbers.com/movie/Super-Mario-Bros-Movie-The-%282022%29",
    },
    explanation: "The domestic market supplied 42.3% of The Super Mario Bros. Movie's worldwide box office, with the larger 57.7% share coming internationally.",
  },
  {
    id: "movies-money-avatar-gross",
    category: "movies",
    measure: "quantity",
    subtype: "money",
    prompt: "How much has Avatar (2009) taken at the worldwide box office in its lifetime?",
    answer: 2923710708,
    min: 500000000,
    max: 5000000000,
    scale: "log",
    unit: "usd",
    referenceYear: "lifetime worldwide gross, 2026",
    source: {
      title: "Box Office Mojo — Top Lifetime Grosses (Worldwide)",
      url: "https://www.boxofficemojo.com/chart/ww_top_lifetime_gross/",
    },
    explanation: "About 2.92 billion dollars, a total it regained from Avengers: Endgame after a 2021 re-release in China.",
  },
  {
    id: "movies-money-avengers-endgame-gross",
    category: "movies",
    measure: "quantity",
    subtype: "money",
    prompt: "How much has Avengers: Endgame taken at the worldwide box office in its lifetime?",
    answer: 2799439100,
    min: 400000000,
    max: 6000000000,
    scale: "log",
    unit: "usd",
    referenceYear: "lifetime worldwide gross, 2026",
    source: {
      title: "Box Office Mojo — Top Lifetime Grosses (Worldwide)",
      url: "https://www.boxofficemojo.com/chart/ww_top_lifetime_gross/",
    },
    explanation: "About 2.80 billion dollars, which briefly made it the highest-grossing film ever released.",
  },
  {
    id: "movies-money-deadpool-and-wolverine-worldwide-box-office",
    category: "movies",
    measure: "quantity",
    subtype: "money",
    prompt: "According to Box Office Mojo, approximately how much had Deadpool & Wolverine grossed worldwide across all releases as of 2026, in nominal US dollars?",
    answer: 1338073645,
    min: 70000000,
    max: 4000000000,
    scale: "log",
    unit: "usd",
    referenceYear: "2026",
    source: {
      title: "Box Office Mojo - Deadpool & Wolverine",
      url: "https://www.boxofficemojo.com/releasegroup/gr1015239173/",
    },
    explanation: "Deadpool & Wolverine had a Box Office Mojo worldwide total of approximately $1.34 billion across all listed releases.",
  },
  {
    id: "movies-money-dune-part-two-worldwide-box-office",
    category: "movies",
    measure: "quantity",
    subtype: "money",
    prompt: "According to Box Office Mojo, approximately how much had Dune: Part Two grossed worldwide across all releases as of 2026, in nominal US dollars?",
    answer: 714844358,
    min: 35000000,
    max: 2200000000,
    scale: "log",
    unit: "usd",
    referenceYear: "2026",
    source: {
      title: "Box Office Mojo - Dune: Part Two",
      url: "https://www.boxofficemojo.com/releasegroup/gr2058375685/",
    },
    explanation: "Dune: Part Two had a Box Office Mojo worldwide total of approximately $714.8 million across all listed releases.",
  },
  {
    id: "movies-money-gladiator-two-worldwide-box-office",
    category: "movies",
    measure: "quantity",
    subtype: "money",
    prompt: "According to Box Office Mojo, approximately how much had Gladiator II grossed worldwide across all releases as of 2026, in nominal US dollars?",
    answer: 462180717,
    min: 25000000,
    max: 1500000000,
    scale: "log",
    unit: "usd",
    referenceYear: "2026",
    source: {
      title: "Box Office Mojo - Gladiator II",
      url: "https://www.boxofficemojo.com/releasegroup/gr293949957/",
    },
    explanation: "Gladiator II had a Box Office Mojo worldwide total of approximately $462.2 million across all listed releases.",
  },
  {
    id: "movies-money-guardians-galaxy-vol-three-worldwide-box-office",
    category: "movies",
    measure: "quantity",
    subtype: "money",
    prompt: "According to Box Office Mojo, approximately how much had Guardians of the Galaxy Vol. 3 grossed worldwide across all releases as of 2026, in nominal US dollars?",
    answer: 845555777,
    min: 45000000,
    max: 2600000000,
    scale: "log",
    unit: "usd",
    referenceYear: "2026",
    source: {
      title: "Box Office Mojo - Guardians of the Galaxy Vol. 3",
      url: "https://www.boxofficemojo.com/releasegroup/gr1455378949/",
    },
    explanation: "Guardians of the Galaxy Vol. 3 had a Box Office Mojo worldwide total of approximately $845.6 million across all listed releases.",
  },
  {
    id: "movies-money-harry-potter-chamber-secrets-worldwide-box-office",
    category: "movies",
    measure: "quantity",
    subtype: "money",
    prompt: "According to Box Office Mojo, approximately how much had Harry Potter and the Chamber of Secrets grossed worldwide across all releases as of 2026, in nominal US dollars?",
    answer: 883386103,
    min: 45000000,
    max: 2700000000,
    scale: "log",
    unit: "usd",
    referenceYear: "2026",
    source: {
      title: "Box Office Mojo - Harry Potter and the Chamber of Secrets",
      url: "https://www.boxofficemojo.com/title/tt0295297/",
    },
    explanation: "Harry Potter and the Chamber of Secrets had a Box Office Mojo worldwide total of approximately $883.4 million across all listed releases.",
  },
  {
    id: "movies-money-harry-potter-goblet-fire-worldwide-box-office",
    category: "movies",
    measure: "quantity",
    subtype: "money",
    prompt: "According to Box Office Mojo, approximately how much had Harry Potter and the Goblet of Fire grossed worldwide across all releases as of 2026, in nominal US dollars?",
    answer: 900435886,
    min: 45000000,
    max: 2800000000,
    scale: "log",
    unit: "usd",
    referenceYear: "2026",
    source: {
      title: "Box Office Mojo - Harry Potter and the Goblet of Fire",
      url: "https://www.boxofficemojo.com/title/tt0330373/",
    },
    explanation: "Harry Potter and the Goblet of Fire had a Box Office Mojo worldwide total of approximately $900.4 million across all listed releases.",
  },
  {
    id: "movies-money-oppenheimer-worldwide-box-office",
    category: "movies",
    measure: "quantity",
    subtype: "money",
    prompt: "According to Box Office Mojo, approximately how much had Oppenheimer grossed worldwide across all releases as of 2026, in nominal US dollars?",
    answer: 975811333,
    min: 50000000,
    max: 3000000000,
    scale: "log",
    unit: "usd",
    referenceYear: "2026",
    source: {
      title: "Box Office Mojo - Oppenheimer",
      url: "https://www.boxofficemojo.com/releasegroup/gr531714565/",
    },
    explanation: "Oppenheimer had a Box Office Mojo worldwide total of approximately $975.8 million across all listed releases.",
  },
  {
    id: "movies-money-sinners-worldwide-box-office",
    category: "movies",
    measure: "quantity",
    subtype: "money",
    prompt: "According to Box Office Mojo, approximately how much had Sinners grossed worldwide across all releases as of 2026, in nominal US dollars?",
    answer: 370289632,
    min: 20000000,
    max: 1200000000,
    scale: "log",
    unit: "usd",
    referenceYear: "2026",
    source: {
      title: "Box Office Mojo - Sinners",
      url: "https://www.boxofficemojo.com/releasegroup/gr3429585669/",
    },
    explanation: "Sinners had a Box Office Mojo worldwide total of approximately $370.3 million across all listed releases.",
  },
  {
    id: "movies-money-skyfall-worldwide-box-office",
    category: "movies",
    measure: "quantity",
    subtype: "money",
    prompt: "According to Box Office Mojo, approximately how much had Skyfall grossed worldwide across all releases as of 2026, in nominal US dollars?",
    answer: 1108594137,
    min: 55000000,
    max: 3400000000,
    scale: "log",
    unit: "usd",
    referenceYear: "2026",
    source: {
      title: "Box Office Mojo - Skyfall",
      url: "https://www.boxofficemojo.com/title/tt1074638/",
    },
    explanation: "Skyfall had a Box Office Mojo worldwide total of approximately $1.11 billion across all listed releases.",
  },
  {
    id: "movies-money-spider-man-across-spider-verse-worldwide-box-office",
    category: "movies",
    measure: "quantity",
    subtype: "money",
    prompt: "According to Box Office Mojo, approximately how much had Spider-Man: Across the Spider-Verse grossed worldwide across all releases as of 2026, in nominal US dollars?",
    answer: 690542303,
    min: 35000000,
    max: 2100000000,
    scale: "log",
    unit: "usd",
    referenceYear: "2026",
    source: {
      title: "Box Office Mojo - Spider-Man: Across the Spider-Verse",
      url: "https://www.boxofficemojo.com/releasegroup/gr3501150725/",
    },
    explanation: "Spider-Man: Across the Spider-Verse had a Box Office Mojo worldwide total of approximately $690.5 million across all listed releases.",
  },
  {
    id: "movies-money-titanic-gross",
    category: "movies",
    measure: "quantity",
    subtype: "money",
    prompt: "How much has Titanic (1997) taken at the worldwide box office in its lifetime?",
    answer: 2264812968,
    min: 300000000,
    max: 4000000000,
    scale: "log",
    unit: "usd",
    referenceYear: "lifetime worldwide gross, 2026",
    source: {
      title: "Box Office Mojo — Top Lifetime Grosses (Worldwide)",
      url: "https://www.boxofficemojo.com/chart/ww_top_lifetime_gross/",
    },
    explanation: "About 2.26 billion dollars across its original run and several re-releases.",
  },
  {
    id: "movies-money-way-of-water-gross",
    category: "movies",
    measure: "quantity",
    subtype: "money",
    prompt: "How much has Avatar: The Way of Water taken at the worldwide box office in its lifetime?",
    answer: 2334484620,
    min: 250000000,
    max: 5000000000,
    scale: "log",
    unit: "usd",
    referenceYear: "lifetime worldwide gross, 2026",
    source: {
      title: "Box Office Mojo — Top Lifetime Grosses (Worldwide)",
      url: "https://www.boxofficemojo.com/chart/ww_top_lifetime_gross/",
    },
    explanation: "About 2.33 billion dollars, arriving thirteen years after the first Avatar.",
  },
  {
    id: "movies-avengers-endgame-theatrical-runtime",
    category: "movies",
    measure: "physics",
    subtype: "duration",
    prompt: "What is the theatrical runtime of Avengers: Endgame, in minutes?",
    answer: 181,
    min: 120,
    max: 220,
    scale: "linear",
    unit: "minute",
    source: {
      title: "The Numbers — Avengers: Endgame (2019)",
      url: "https://www.the-numbers.com/movie/Avengers-Endgame-%282019%29",
    },
    explanation: "Avengers: Endgame runs for 181 minutes, putting it just over the three-hour mark.",
  },
  {
    id: "movies-back-to-the-future-theatrical-runtime",
    category: "movies",
    measure: "physics",
    subtype: "duration",
    prompt: "What is the theatrical runtime of Back to the Future, in minutes?",
    answer: 116,
    min: 75,
    max: 170,
    scale: "linear",
    unit: "minute",
    source: {
      title: "The Numbers — Back to the Future (1985)",
      url: "https://www.the-numbers.com/movie/Back-to-the-Future-%281985%29",
    },
    explanation: "Back to the Future runs for 116 minutes, or 1 hour and 56 minutes.",
  },
  {
    id: "movies-harry-potter-sorcerers-stone-runtime",
    category: "movies",
    measure: "physics",
    subtype: "duration",
    prompt: "What is the theatrical runtime of Harry Potter and the Sorcerer's Stone, in minutes?",
    answer: 152,
    min: 90,
    max: 210,
    scale: "linear",
    unit: "minute",
    source: {
      title: "The Numbers — Harry Potter and the Sorcerer's Stone (2001)",
      url: "https://www.the-numbers.com/movie/Harry-Potter-and-the-Sorcerers-Stone-%282001%29",
    },
    explanation: "Harry Potter and the Sorcerer's Stone runs for 152 minutes, or 2 hours and 32 minutes.",
  },
  {
    id: "movies-home-alone-classified-runtime",
    category: "movies",
    measure: "physics",
    subtype: "duration",
    prompt: "Approximately how many minutes long is Home Alone?",
    answer: 103,
    min: 70,
    max: 150,
    scale: "linear",
    unit: "minute",
    source: {
      title: "BBFC — Home Alone",
      url: "https://www.bbfc.co.uk/release/home-alone-q29sbgvjdglvbjpwwc0yoteymju",
    },
    explanation: "The BBFC lists Home Alone at approximately 103 minutes; its cinema classification is recorded more precisely as 102 minutes and 45 seconds.",
  },
  {
    id: "movies-jaws-theatrical-runtime",
    category: "movies",
    measure: "physics",
    subtype: "duration",
    prompt: "What is the theatrical runtime of Jaws, in minutes?",
    answer: 124,
    min: 80,
    max: 180,
    scale: "linear",
    unit: "minute",
    source: {
      title: "The Numbers — Jaws (1975)",
      url: "https://www.the-numbers.com/movie/Jaws-%281975%29",
    },
    explanation: "Jaws runs for 124 minutes, which is 2 hours and 4 minutes.",
  },
  {
    id: "movies-jurassic-park-theatrical-runtime",
    category: "movies",
    measure: "physics",
    subtype: "duration",
    prompt: "What is the theatrical runtime of Jurassic Park, in minutes?",
    answer: 126,
    min: 80,
    max: 180,
    scale: "linear",
    unit: "minute",
    source: {
      title: "The Numbers — Jurassic Park (1993)",
      url: "https://www.the-numbers.com/movie/Jurassic-Park-%281993%29",
    },
    explanation: "Jurassic Park runs for 126 minutes, which is 2 hours and 6 minutes.",
  },
  {
    id: "movies-oppenheimer-theatrical-runtime",
    category: "movies",
    measure: "physics",
    subtype: "duration",
    prompt: "What is the theatrical runtime of Oppenheimer, in minutes?",
    answer: 180,
    min: 110,
    max: 230,
    scale: "linear",
    unit: "minute",
    source: {
      title: "The Numbers — Oppenheimer (2023)",
      url: "https://www.the-numbers.com/movie/Oppenheimer-%282023%29",
    },
    explanation: "Oppenheimer runs for 180 minutes, exactly three hours.",
  },
  {
    id: "movies-return-of-the-king-theatrical-runtime",
    category: "movies",
    measure: "physics",
    subtype: "duration",
    prompt: "What is the theatrical runtime of The Lord of the Rings: The Return of the King, in minutes?",
    answer: 201,
    min: 130,
    max: 230,
    scale: "linear",
    unit: "minute",
    source: {
      title: "The Numbers — The Lord of the Rings: The Return of the King",
      url: "https://www.the-numbers.com/movie/Lord-of-the-Rings-The-Return-of-the-King-The",
    },
    explanation: "The theatrical version runs for 201 minutes, or 3 hours and 21 minutes.",
  },
  {
    id: "movies-shrek-theatrical-runtime",
    category: "movies",
    measure: "physics",
    subtype: "duration",
    prompt: "What is the theatrical runtime of Shrek, in minutes?",
    answer: 90,
    min: 65,
    max: 130,
    scale: "linear",
    unit: "minute",
    source: {
      title: "The Numbers — Shrek (2001)",
      url: "https://www.the-numbers.com/movie/Shrek-%282001%29",
    },
    explanation: "Shrek runs for 90 minutes, exactly 1 hour and 30 minutes.",
  },
  {
    id: "movies-the-batman-theatrical-runtime",
    category: "movies",
    measure: "physics",
    subtype: "duration",
    prompt: "What is the theatrical runtime of The Batman, in minutes?",
    answer: 175,
    min: 110,
    max: 220,
    scale: "linear",
    unit: "minute",
    source: {
      title: "The Numbers — The Batman (2022)",
      url: "https://www.the-numbers.com/movie/Batman-The-%282021%29",
    },
    explanation: "The Batman runs for 175 minutes, which is 2 hours and 55 minutes.",
  },
  {
    id: "movies-titanic-theatrical-runtime",
    category: "movies",
    measure: "physics",
    subtype: "duration",
    prompt: "What is the theatrical runtime of Titanic, in minutes?",
    answer: 194,
    min: 120,
    max: 230,
    scale: "linear",
    unit: "minute",
    source: {
      title: "The Numbers — Titanic (1997)",
      url: "https://www.the-numbers.com/movie/Titanic-%281997%29",
    },
    explanation: "Titanic runs for 194 minutes, which is 3 hours and 14 minutes.",
  },
  {
    id: "movies-toy-story-theatrical-runtime",
    category: "movies",
    measure: "physics",
    subtype: "duration",
    prompt: "What is the theatrical runtime of Toy Story, in minutes?",
    answer: 80,
    min: 60,
    max: 130,
    scale: "linear",
    unit: "minute",
    source: {
      title: "The Numbers — Toy Story (1995)",
      url: "https://www.the-numbers.com/movie/Toy-Story-%281995%29",
    },
    explanation: "Toy Story runs for 80 minutes, making its feature-length story just 1 hour and 20 minutes.",
  },
  {
    id: "dinosaurs-baryonyx-discovery-year",
    category: "dinosaurs",
    measure: "history",
    subtype: "event",
    prompt: "In what year was Baryonyx first discovered in a Surrey clay pit?",
    answer: 1983,
    min: 1900,
    max: 2025,
    scale: "linear",
    unit: "year",
    source: {
      title: "Natural History Museum — How did Baryonyx change what we knew about spinosaurs?",
      url: "https://www.nhm.ac.uk/discover/how-did-baryonyx-change-what-we-knew-about-spinosaurs.html",
    },
    explanation: "Baryonyx was discovered in 1983 after fossil hunter William Walker spotted a giant claw protruding from rock in Surrey.",
  },
  {
    id: "dinosaurs-deinonychus-naming-year",
    category: "dinosaurs",
    measure: "history",
    subtype: "event",
    prompt: "In what year did John Ostrom discover and name Deinonychus?",
    answer: 1969,
    min: 1850,
    max: 2025,
    scale: "linear",
    unit: "year",
    source: {
      title: "Yale Peabody Museum — Deinonychus",
      url: "https://peabody.yale.edu/article/deinonychus",
    },
    explanation: "John Ostrom discovered and named Deinonychus in 1969, helping trigger the dinosaur renaissance and renew the dinosaur-bird connection.",
  },
  {
    id: "dinosaurs-event-dinosauria-named",
    category: "dinosaurs",
    measure: "history",
    subtype: "event",
    prompt: "In what year was the word \"dinosaur\" invented?",
    answer: 1842,
    min: 1700,
    max: 1950,
    scale: "linear",
    unit: "year",
    source: {
      title: "University of California Museum of Paleontology — The Dinosauria",
      url: "https://ucmp.berkeley.edu/diapsids/dinosaur.html",
    },
    explanation: "Richard Owen coined \"Dinosauria\" — fearfully great reptiles — in 1842, on the strength of just three known kinds: Megalosaurus, Iguanodon and Hylaeosaurus.",
  },
  {
    id: "dinosaurs-event-megalosaurus-named",
    category: "dinosaurs",
    measure: "history",
    subtype: "event",
    prompt: "In what year was Megalosaurus, the first dinosaur given a scientific name, named?",
    answer: 1824,
    min: 1700,
    max: 1950,
    scale: "linear",
    unit: "year",
    source: {
      title: "Natural History Museum - Megalosaurus",
      url: "https://www.nhm.ac.uk/discover/dino-directory/megalosaurus.html",
    },
    explanation: "Megalosaurus was named in 1824, eighteen years before the word dinosaur was coined in 1842.",
  },
  {
    id: "dinosaurs-event-patagotitan-named",
    category: "dinosaurs",
    measure: "history",
    subtype: "event",
    prompt: "In what year was Patagotitan, one of the biggest dinosaurs ever, finally named?",
    answer: 2017,
    min: 1950,
    max: 2026,
    scale: "linear",
    unit: "year",
    source: {
      title: "The Field Museum — Putting the \"Titan\" in Titanosaur",
      url: "https://www.fieldmuseum.org/blog/putting-titan-titanosaur",
    },
    explanation: "Dug out of an Argentine farm in 2010, it was not formally named until 2017 — proof that the biggest dinosaurs are very recent science.",
  },
  {
    id: "dinosaurs-length-baryonyx-thumb-claw",
    category: "dinosaurs",
    measure: "size",
    subtype: "length",
    prompt: "How long was the giant thumb claw of Baryonyx?",
    answer: 0.3,
    min: 0.05,
    max: 1,
    scale: "linear",
    unit: "metre",
    source: {
      title: "The Field Museum — Let's Lend These Dinosaurs a Hand",
      url: "https://www.fieldmuseum.org/blog/lets-lend-these-dinosaurs-hand",
    },
    explanation: "The hooked claw measures 30 centimetres — about the length of your forearm — on a fish-eating dinosaur that probably hooked prey out of rivers like a bear.",
  },
  {
    id: "dinosaurs-length-chicxulub-asteroid-width",
    category: "dinosaurs",
    measure: "size",
    subtype: "length",
    prompt: "How wide was the asteroid that killed the dinosaurs?",
    answer: 10,
    min: 0.5,
    max: 100,
    scale: "log",
    unit: "kilometre",
    source: {
      title: "U.S. National Science Foundation — A Moment That Changed Earth",
      url: "https://www.nsf.gov/science-matters/moment-changed-earth",
    },
    explanation: "Nearly 10 kilometres across, it blasted an initial cavity 100 kilometres wide and 30 kilometres deep into what is now the Yucatán.",
  },
  {
    id: "dinosaurs-length-largest-footprint",
    category: "dinosaurs",
    measure: "size",
    subtype: "length",
    prompt: "How wide is the largest dinosaur footprint ever found?",
    answer: 1.5,
    min: 0.2,
    max: 4,
    scale: "linear",
    unit: "metre",
    source: {
      title: "Australian Museum — Western Australian Giant Sauropod",
      url: "https://australian.museum/learn/australia-over-time/extinct-animals/western-australian-giant-sauropod/",
    },
    explanation: "Sauropod prints on the Western Australian coast reach 1.5 metres across — wide enough to sit in — and are the only trace of an animal that may have topped 45 metres, since no bones have ever been found.",
  },
  {
    id: "dinosaurs-length-tyrannosaurus-rex",
    category: "dinosaurs",
    measure: "size",
    subtype: "length",
    prompt: "Approximately how long was a typical Tyrannosaurus rex?",
    answer: 12,
    min: 4,
    max: 20,
    scale: "linear",
    unit: "metre",
    source: {
      title: "Natural History Museum - Tyrannosaurus",
      url: "https://www.nhm.ac.uk/discover/dino-directory/tyrannosaurus.html",
    },
    explanation: "The Natural History Museum gives a typical T. rex length of about 12 metres, although the largest known specimens approached 13 metres.",
  },
  {
    id: "dinosaurs-length-utahceratops-skull",
    category: "dinosaurs",
    measure: "size",
    subtype: "length",
    prompt: "How long was the skull of Utahceratops, a cousin of Triceratops?",
    answer: 2.3,
    min: 0.3,
    max: 5,
    scale: "linear",
    unit: "metre",
    source: {
      title: "Natural History Museum of Utah — Utahceratops gettyi",
      url: "https://nhmu.utah.edu/utahceratops-gettyi",
    },
    explanation: "Its head alone ran 2.3 metres on a 6-metre body — horned dinosaurs carried the largest skulls of any land animal that has ever lived.",
  },
  {
    id: "dinosaurs-mass-carnegie-quarry-fossils",
    category: "dinosaurs",
    measure: "size",
    subtype: "mass",
    prompt: "How many tonnes of fossils were hauled out of the Carnegie Quarry?",
    answer: 300,
    min: 5,
    max: 3000,
    scale: "log",
    unit: "tonne",
    source: {
      title: "U.S. National Park Service — Historic Carnegie Quarry",
      url: "https://www.nps.gov/dino/learn/historyculture/carnegie_quarry.htm",
    },
    explanation: "Earl Douglass's crews shipped out over 300 tons between 1909 and 1922, including ten near-complete skeletons and fourteen skulls.",
  },
  {
    id: "dinosaurs-mass-patagotitan-weight",
    category: "dinosaurs",
    measure: "size",
    subtype: "mass",
    prompt: "How heavy was Patagotitan, one of the biggest dinosaurs ever found?",
    answer: 70,
    min: 3,
    max: 400,
    scale: "log",
    unit: "tonne",
    source: {
      title: "The Field Museum — Máximo the Titanosaur",
      url: "https://www.fieldmuseum.org/exhibition/halls-and-galleries/maximo-titanosaur",
    },
    explanation: "At about 70 tons it weighed as much as ten African elephants, yet it hatched from an egg small enough to hold in two hands.",
  },
  {
    id: "dinosaurs-amnh-dinosaur-wing-specimen-count",
    category: "dinosaurs",
    measure: "quantity",
    subtype: "count",
    prompt: "About how many specimens are displayed across the American Museum of Natural History's two dinosaur-wing halls?",
    answer: 100,
    min: 20,
    max: 180,
    scale: "linear",
    unit: "count",
    source: {
      title: "American Museum of Natural History — Hall of Ornithischian Dinosaurs",
      url: "https://www.amnh.org/exhibitions/permanent/ornithischian-dinosaurs",
    },
    explanation: "The two halls display about 100 specimens, drawn from one of the world's largest dinosaur fossil collections.",
  },
  {
    id: "dinosaurs-count-albertosaurus-bonebed",
    category: "dinosaurs",
    measure: "quantity",
    subtype: "count",
    prompt: "How many Albertosaurus were found buried together in one Alberta bonebed?",
    answer: 12,
    min: 1,
    max: 100,
    scale: "log",
    unit: "count",
    source: {
      title: "Royal Tyrrell Museum — Cretaceous Alberta",
      url: "https://tyrrellmuseum.com/whats_on/exhibits/cretaceous_alberta",
    },
    explanation: "At least 12 died together at Dry Island Buffalo Jump — the strongest hint yet that big tyrannosaurs may not have hunted alone.",
  },
  {
    id: "dinosaurs-count-cleveland-lloyd-allosaurus",
    category: "dinosaurs",
    measure: "quantity",
    subtype: "count",
    prompt: "How many Allosaurus have come out of a single Utah quarry?",
    answer: 46,
    min: 1,
    max: 300,
    scale: "log",
    unit: "count",
    source: {
      title: "Bureau of Land Management — Jurassic National Monument",
      url: "https://www.blm.gov/programs/national-conservation-lands/utah/jurassic-national-monument",
    },
    explanation: "The Cleveland-Lloyd quarry has yielded over 12,000 fossils from at least 74 animals, and more than 46 of them are Allosaurus — a pile-up of predators nobody has fully explained.",
  },
  {
    id: "dinosaurs-count-connecticut-tracks",
    category: "dinosaurs",
    measure: "quantity",
    subtype: "count",
    prompt: "How many dinosaur footprints were uncovered at Connecticut's Dinosaur State Park?",
    answer: 2600,
    min: 100,
    max: 30000,
    scale: "log",
    unit: "count",
    source: {
      title: "Connecticut State Parks — Dinosaur State Park",
      url: "https://ctparks.com/node/41",
    },
    explanation: "A bulldozer operator hit the first tracks in 1966 and over 2,600 were eventually exposed; about 750 sit under the park's dome and the rest were reburied to protect them.",
  },
  {
    id: "dinosaurs-count-lark-quarry-footprints",
    category: "dinosaurs",
    measure: "quantity",
    subtype: "count",
    prompt: "Roughly how many muddy dinosaur footprints are preserved at Queensland's Lark Quarry?",
    answer: 4000,
    min: 200,
    max: 50000,
    scale: "log",
    unit: "count",
    source: {
      title: "Queensland Parks - Lark Quarry Conservation Park",
      url: "https://parks.qld.gov.au/parks/lark-quarry/about",
    },
    explanation: "Queensland Parks describes more than 4,000 footprints preserved in the 95-million-year-old trackways.",
  },
  {
    id: "dinosaurs-count-sophie-stegosaurus-plates",
    category: "dinosaurs",
    measure: "quantity",
    subtype: "count",
    prompt: "How many back plates are preserved on the Natural History Museum's Sophie Stegosaurus?",
    answer: 19,
    min: 5,
    max: 40,
    scale: "linear",
    unit: "count",
    source: {
      title: "Natural History Museum - World's most complete Stegosaurus goes on show",
      url: "https://www.nhm.ac.uk/press-office/press-releases/world_s-most-complete-stegosaurus-goes-on-show.html",
    },
    explanation: "Sophie preserves 19 back plates as well as four tail spikes, making the skeleton unusually complete.",
  },
  {
    id: "dinosaurs-count-total-tyrannosaurus-ever-lived",
    category: "dinosaurs",
    measure: "quantity",
    subtype: "count",
    prompt: "How many Tyrannosaurus rex ever lived, by Berkeley's estimate?",
    answer: 2500000000,
    min: 1000000,
    max: 100000000000,
    scale: "log",
    unit: "count",
    referenceYear: "2021",
    source: {
      title: "Berkeley News — How many T. rexes were there? Billions.",
      url: "https://news.berkeley.edu/2021/04/15/how-many-t-rexes-were-there-billions/",
    },
    explanation: "Roughly 20,000 adults at a time across 127,000 generations works out at about 2.5 billion animals — and fewer than 100 individuals have ever been dug up.",
  },
  {
    id: "dinosaurs-count-wall-of-bones",
    category: "dinosaurs",
    measure: "quantity",
    subtype: "count",
    prompt: "How many dinosaur bones are in the Wall of Bones at Dinosaur National Monument?",
    answer: 1500,
    min: 50,
    max: 20000,
    scale: "log",
    unit: "count",
    source: {
      title: "U.S. National Park Service — Quarry Exhibit Hall",
      url: "https://www.nps.gov/thingstodo/quarry-exhibit-hall.htm",
    },
    explanation: "About 1,500 bones sit half-excavated in the cliff face, left deliberately in the rock so visitors can see Allosaurus, Stegosaurus and Diplodocus exactly where they were buried.",
  },
  {
    id: "dinosaurs-crystal-palace-dinosaur-statue-count",
    category: "dinosaurs",
    measure: "quantity",
    subtype: "count",
    prompt: "Despite the name, how many of the prehistoric animal statues at Crystal Palace Park actually represent dinosaurs?",
    answer: 4,
    min: 1,
    max: 12,
    scale: "linear",
    unit: "count",
    source: {
      title: "Natural History Museum — Missing Crystal Palace mammal recreated decades after disappearance",
      url: "https://www.nhm.ac.uk/discover/news/2023/july/missing-crystal-palace-mammal-recreated-decades-after-disappearance.html",
    },
    explanation: "Only 4 of the more than 30 Crystal Palace prehistoric statues represent dinosaurs; the rest include mammals, marine reptiles and other extinct animals.",
  },
  {
    id: "dinosaurs-dippy-skeleton-bone-count",
    category: "dinosaurs",
    measure: "quantity",
    subtype: "count",
    prompt: "How many bones make up London's Dippy Diplodocus cast?",
    answer: 292,
    min: 50,
    max: 400,
    scale: "linear",
    unit: "count",
    source: {
      title: "Natural History Museum — Dippy: this is your life",
      url: "https://www.nhm.ac.uk/discover/diplodocus-this-is-your-life.html",
    },
    explanation: "Dippy is a 292-bone cast that arrived in London packed into 36 cases before its 1905 unveiling.",
  },
  {
    id: "dinosaurs-sue-recovered-bone-count",
    category: "dinosaurs",
    measure: "quantity",
    subtype: "count",
    prompt: "How many bones from the roughly 380-bone T. rex skeleton were recovered for SUE?",
    answer: 250,
    min: 100,
    max: 600,
    scale: "linear",
    unit: "count",
    source: {
      title: "Field Museum — SUE the T. rex",
      url: "https://www.fieldmuseum.org/blog/sue-t-rex",
    },
    explanation: "SUE preserves 250 of the roughly 380 known bones in a T. rex skeleton, including the wishbone and belly ribs.",
  },
  {
    id: "dinosaurs-carnegie-original-fossil-percentage",
    category: "dinosaurs",
    measure: "quantity",
    subtype: "percentage",
    prompt: "Approximately what percentage of the objects in Carnegie Museum's Kamin Hall of Dinosaurs are original fossils?",
    answer: 75,
    min: 0,
    max: 100,
    scale: "linear",
    unit: "percent",
    source: {
      title: "Carnegie Museum of Natural History — Daniel G. And Carole L. Kamin Hall of Dinosaurs",
      url: "https://carnegiemnh.org/explore/kamin-hall-of-dinosaurs/",
    },
    explanation: "About 75% of the hall's more than 230 displayed objects are original fossils rather than replicas.",
  },
  {
    id: "dinosaurs-horridus-skeleton-completeness",
    category: "dinosaurs",
    measure: "quantity",
    subtype: "percentage",
    prompt: "What percentage complete is Melbourne Museum's Triceratops skeleton Horridus?",
    answer: 85,
    min: 0,
    max: 100,
    scale: "linear",
    unit: "percent",
    source: {
      title: "Museums Victoria — Horridus is here!",
      url: "https://museumsvictoria.com.au/media-releases/horridus-is-here/",
    },
    explanation: "Horridus is 85% complete and includes 266 fossil bones plus an entire vertebral column.",
  },
  {
    id: "dinosaurs-percentage-extinction-species-lost",
    category: "dinosaurs",
    measure: "quantity",
    subtype: "percentage",
    prompt: "What share of Earth's species died out alongside the dinosaurs?",
    answer: 70,
    min: 0,
    max: 100,
    scale: "linear",
    unit: "percent",
    source: {
      title: "U.S. National Science Foundation — A Moment That Changed Earth",
      url: "https://www.nsf.gov/science-matters/moment-changed-earth",
    },
    explanation: "Around 70 percent of species vanished, and it was the climate chaos afterwards — a deep freeze followed by greenhouse warming — that did most of the killing.",
  },
  {
    id: "dinosaurs-scotty-bones-recovered-percentage",
    category: "dinosaurs",
    measure: "quantity",
    subtype: "percentage",
    prompt: "About what percentage of Scotty the T. rex's fossilised bones were found at the Saskatchewan dig site?",
    answer: 65,
    min: 0,
    max: 100,
    scale: "linear",
    unit: "percent",
    source: {
      title: "Government of Saskatchewan — The Most Massive T.Rex Ever Discovered Calls Saskatchewan Home",
      url: "https://www.saskatchewan.ca/government/news-and-media/2019/march/26/scotty",
    },
    explanation: "About 65% of Scotty's fossilised bones were recovered, making it one of the most complete T. rex skeletons found.",
  },
  {
    id: "dinosaurs-trix-skeleton-completeness",
    category: "dinosaurs",
    measure: "quantity",
    subtype: "percentage",
    prompt: "Approximately what percentage complete is Naturalis museum's T. rex Trix when measured by bone volume?",
    answer: 80,
    min: 0,
    max: 100,
    scale: "linear",
    unit: "percent",
    source: {
      title: "Naturalis — Persdossier de T. rex van Naturalis",
      url: "https://www.naturalis.nl/over-ons/media/persdossier-t-rex-van-naturalis",
    },
    explanation: "Trix is approximately 80% complete by bone volume, placing the specimen among the world's most complete T. rex skeletons.",
  },
  {
    id: "dinosaurs-cretaceous-period-duration",
    category: "dinosaurs",
    measure: "physics",
    subtype: "duration",
    prompt: "How many million years did the Cretaceous Period last?",
    answer: 79000000,
    min: 30000000,
    max: 130000000,
    scale: "linear",
    unit: "duration-year",
    source: {
      title: "National Park Service — Cretaceous Period—145.0 to 66.0 MYA",
      url: "https://www.nps.gov/articles/000/cretaceous-period.htm",
    },
    explanation: "The Cretaceous lasted about 79 million years, ending 66 million years ago with the mass extinction that eliminated all non-bird dinosaurs.",
  },
  {
    id: "dinosaurs-deccan-traps-eruption-duration",
    category: "dinosaurs",
    measure: "physics",
    subtype: "duration",
    prompt: "For roughly how many million years did the major Deccan Traps volcanic activity continue around the end of the dinosaur era?",
    answer: 2000000,
    min: 100000,
    max: 20000000,
    scale: "log",
    unit: "duration-year",
    source: {
      title: "Natural History Museum — How an asteroid ended the age of the dinosaurs",
      url: "https://www.nhm.ac.uk/discover/how-an-asteroid-caused-extinction-of-dinosaurs.html",
    },
    explanation: "The major Deccan Traps volcanic activity continued for about 2 million years, adding long-term climate stress before and around the asteroid impact.",
  },
  {
    id: "dinosaurs-dippy-london-display-duration",
    category: "dinosaurs",
    measure: "physics",
    subtype: "duration",
    prompt: "For roughly how many years had Dippy the Diplodocus been displayed in London before leaving for a UK tour?",
    answer: 110,
    min: 50,
    max: 200,
    scale: "linear",
    unit: "duration-year",
    source: {
      title: "Natural History Museum — Dippy: this is your life",
      url: "https://www.nhm.ac.uk/discover/diplodocus-this-is-your-life.html",
    },
    explanation: "Dippy had been displayed in London for more than 110 years, having been unveiled in 1905 before leaving public display in 2017.",
  },
  {
    id: "dinosaurs-duration-extinction-age",
    category: "dinosaurs",
    measure: "physics",
    subtype: "duration",
    prompt: "How long ago did the dinosaurs die out?",
    answer: 66000000,
    min: 5000000,
    max: 500000000,
    scale: "log",
    unit: "duration-year",
    source: {
      title: "U.S. National Park Service — Geologic Time Scale",
      url: "https://www.nps.gov/subjects/geology/time-scale.htm",
    },
    explanation: "The Cretaceous ended 66 million years ago, taking every dinosaur except the birds with it.",
  },
  {
    id: "dinosaurs-duration-first-dinosaurs-appeared",
    category: "dinosaurs",
    measure: "physics",
    subtype: "duration",
    prompt: "How long ago did the first dinosaurs appear?",
    answer: 225000000,
    min: 50000000,
    max: 1000000000,
    scale: "log",
    unit: "duration-year",
    source: {
      title: "University of California Museum of Paleontology — The Dinosauria",
      url: "https://ucmp.berkeley.edu/diapsids/dinosaur.html",
    },
    explanation: "Dinosaurs show up late in the Triassic, about 225 million years ago, as small two-legged animals sharing the world with much larger reptiles.",
  },
  {
    id: "dinosaurs-duration-mesozoic-length",
    category: "dinosaurs",
    measure: "physics",
    subtype: "duration",
    prompt: "How long did the Age of the Dinosaurs last?",
    answer: 186000000,
    min: 20000000,
    max: 800000000,
    scale: "log",
    unit: "duration-year",
    source: {
      title: "U.S. National Park Service — Geologic Time Scale",
      url: "https://www.nps.gov/subjects/geology/time-scale.htm",
    },
    explanation: "The Mesozoic ran from 252.2 to 66 million years ago — about 186 million years, roughly 700 times longer than our own species has existed.",
  },
  {
    id: "dinosaurs-duration-non-avian-extinction",
    category: "dinosaurs",
    measure: "physics",
    subtype: "duration",
    prompt: "Approximately how many years ago did the non-avian dinosaurs become extinct?",
    answer: 66000000,
    min: 1000000,
    max: 500000000,
    scale: "log",
    unit: "duration-year",
    source: {
      title: "Natural History Museum - What killed the dinosaurs?",
      url: "https://www.nhm.ac.uk/discover/dinosaur-extinction.html",
    },
    explanation: "The mass extinction happened about 66 million years ago. Birds survived and are the only dinosaurs still alive today.",
  },
  {
    id: "dinosaurs-duration-stegosaurus-to-tyrannosaurus-gap",
    category: "dinosaurs",
    measure: "physics",
    subtype: "duration",
    prompt: "How many years separated Stegosaurus from Tyrannosaurus rex?",
    answer: 80000000,
    min: 5000000,
    max: 300000000,
    scale: "log",
    unit: "duration-year",
    source: {
      title: "University of California Museum of Paleontology — The Dinosauria",
      url: "https://ucmp.berkeley.edu/diapsids/dinosaur.html",
    },
    explanation: "Tyrannosaurus turned up around 80 million years after the last stegosaurs died out — a longer gap than the one between T. rex and us.",
  },
  {
    id: "dinosaurs-duration-sue-age-at-death",
    category: "dinosaurs",
    measure: "physics",
    subtype: "duration",
    prompt: "How old was SUE, the most complete T. rex ever found, when she died?",
    answer: 28,
    min: 3,
    max: 90,
    scale: "linear",
    unit: "duration-year",
    source: {
      title: "The Field Museum — SUE the T. rex",
      url: "https://www.fieldmuseum.org/blog/sue-t-rex",
    },
    explanation: "SUE was about 28 — the most geriatric Tyrannosaurus yet found — reaching full size at 19 after a teenage growth spurt of up to 4.5 pounds a day.",
  },
  {
    id: "dinosaurs-quarry-wall-fossil-age",
    category: "dinosaurs",
    measure: "physics",
    subtype: "duration",
    prompt: "Approximately how many million years old are the fossils still embedded in the Quarry Wall at Dinosaur National Monument?",
    answer: 150000000,
    min: 80000000,
    max: 250000000,
    scale: "linear",
    unit: "duration-year",
    source: {
      title: "National Park Service — Quarry Exhibit Hall",
      url: "https://www.nps.gov/dino/planyourvisit/quarry-exhibit-hall.htm",
    },
    explanation: "The Quarry Wall fossils are approximately 150 million years old and come from the Late Jurassic Morrison Formation.",
  },
  {
    id: "dinosaurs-sue-custody-battle-duration",
    category: "dinosaurs",
    measure: "physics",
    subtype: "duration",
    prompt: "How many years did the legal custody battle over SUE the T. rex last?",
    answer: 5,
    min: 1,
    max: 15,
    scale: "linear",
    unit: "duration-year",
    source: {
      title: "Field Museum — SUE the T. rex",
      url: "https://www.fieldmuseum.org/blog/sue-t-rex",
    },
    explanation: "The custody battle lasted 5 years and ended with SUE being sold at public auction in 1997.",
  },
  {
    id: "dinosaurs-speed-tyrannosaurus-top-speed",
    category: "dinosaurs",
    measure: "physics",
    subtype: "speed",
    prompt: "How fast could a Tyrannosaurus rex run, according to University of Manchester modelling?",
    answer: 12.4,
    min: 2,
    max: 60,
    scale: "linear",
    unit: "kph",
    referenceYear: "2017",
    source: {
      title: "University of Manchester Research IT — How fast can a T. rex run?",
      url: "https://research-it.manchester.ac.uk/news/2017/07/19/how-fast-can-a-t-rex-run/",
    },
    explanation: "The simulations capped T. rex at 7.7 mph — about 12.4 km/h — because at a full run its own weight would have snapped its leg bones, meaning an average human could just about outpace it.",
  },
  {
    id: "games-event-atari-founded",
    category: "games",
    measure: "history",
    subtype: "event",
    prompt: "In what year did Nolan Bushnell found Atari, the company behind Pong?",
    answer: 1972,
    min: 1940,
    max: 2000,
    scale: "linear",
    unit: "year",
    source: {
      title: "Wikipedia — Atari, Inc.",
      url: "https://en.wikipedia.org/wiki/Atari,_Inc.",
    },
    explanation: "Atari was founded in 1972 in Sunnyvale, California, and helped kickstart the entire video arcade industry.",
  },
  {
    id: "games-event-dungeons-dragons-first-publication",
    category: "games",
    measure: "history",
    subtype: "event",
    prompt: "In what year was Dungeons & Dragons first published?",
    answer: 1974,
    min: 1900,
    max: 2025,
    scale: "linear",
    unit: "year",
    source: {
      title: "Dungeons & Dragons - 50th anniversary",
      url: "https://www.dndbeyond.com/posts/1660-dungeons-dragons-turns-50-see-how-were-celebrating",
    },
    explanation: "Dungeons & Dragons celebrated 50 years since its first publication in 2024, placing the original release in 1974.",
  },
  {
    id: "games-event-famicom-launch",
    category: "games",
    measure: "history",
    subtype: "event",
    prompt: "In what year did Nintendo launch the Family Computer, sold abroad as the NES?",
    answer: 1983,
    min: 1965,
    max: 2000,
    scale: "linear",
    unit: "year",
    source: {
      title: "Nintendo Co., Ltd. — Company History",
      url: "https://www.nintendo.co.jp/corporate/en/history/index.html",
    },
    explanation: "The Famicom arrived in 1983 and rebuilt a games industry that had just collapsed in North America, reaching the West as the NES two years later.",
  },
  {
    id: "games-event-fide-founded",
    category: "games",
    measure: "history",
    subtype: "event",
    prompt: "In what year was FIDE, the international body that governs competitive chess, founded in Paris?",
    answer: 1924,
    min: 1850,
    max: 2000,
    scale: "linear",
    unit: "year",
    source: {
      title: "FIDE — World Chess Federation",
      url: "https://old.fide.com/fide/fide-world-chess-federation.html",
    },
    explanation: "FIDE was founded in Paris in July 1924, on the closing day of that year's unofficial Chess Olympiad.",
  },
  {
    id: "games-event-gamecube-north-america-launch",
    category: "games",
    measure: "history",
    subtype: "event",
    prompt: "In what year did the Nintendo GameCube launch in North America?",
    answer: 2001,
    min: 1970,
    max: 2020,
    scale: "linear",
    unit: "year",
    source: {
      title: "Wikipedia (via EPFL Graph Search) — GameCube",
      url: "https://graphsearch.epfl.ch/en/concept/29036/concepts",
    },
    explanation: "The GameCube launched in Japan in September 2001 and in North America two months later, competing with the PS2 and Xbox.",
  },
  {
    id: "games-event-league-of-legends-release",
    category: "games",
    measure: "history",
    subtype: "event",
    prompt: "In what year did League of Legends officially launch, becoming one of esports' defining games?",
    answer: 2009,
    min: 1980,
    max: 2020,
    scale: "linear",
    unit: "year",
    source: {
      title: "League of Legends Wiki — League of Legends (game)",
      url: "https://wiki.leagueoflegends.com/en-us/League_of_Legends",
    },
    explanation: "League of Legends launched on October 27, 2009, after being announced by Riot Games a year earlier.",
  },
  {
    id: "games-event-magic-the-gathering-first-released",
    category: "games",
    measure: "history",
    subtype: "event",
    prompt: "In what year did Wizards of the Coast release the very first Magic: The Gathering set?",
    answer: 1993,
    min: 1960,
    max: 2020,
    scale: "linear",
    unit: "year",
    source: {
      title: "ComicBook.com — Magic: The Gathering Card Sells for Over Half a Million Dollars",
      url: "https://comicbook.com/gaming/news/magic-the-gathering-mtg-black-lotus-record-auction-sale-half-million/",
    },
    explanation: "Magic: The Gathering's first set, later known as Alpha, was released in 1993, inventing the collectible card game genre.",
  },
  {
    id: "games-event-monopoly-first-published",
    category: "games",
    measure: "history",
    subtype: "event",
    prompt: "In what year did Parker Brothers first publish Monopoly?",
    answer: 1935,
    min: 1880,
    max: 1980,
    scale: "linear",
    unit: "year",
    source: {
      title: "Wikipedia — Monopoly (game)",
      url: "https://en.wikipedia.org/wiki/Monopoly_(game)",
    },
    explanation: "Parker Brothers published Monopoly in 1935 after buying the rights from salesman Charles Darrow and inventor Lizzie Magie.",
  },
  {
    id: "games-event-nes-north-america-launch",
    category: "games",
    measure: "history",
    subtype: "event",
    prompt: "In what year did the Nintendo Entertainment System launch in North America, reviving an industry many thought was dead?",
    answer: 1985,
    min: 1950,
    max: 2020,
    scale: "linear",
    unit: "year",
    source: {
      title: "Wikipedia — History of the Nintendo Entertainment System",
      url: "https://en.wikipedia.org/wiki/History_of_the_Nintendo_Entertainment_System",
    },
    explanation: "The NES launched in North America in 1985, two years after the 1983 video game crash had nearly killed the console market.",
  },
  {
    id: "games-event-nintendo-64-launch",
    category: "games",
    measure: "history",
    subtype: "event",
    prompt: "In what year did the Nintendo 64 launch?",
    answer: 1996,
    min: 1980,
    max: 2010,
    scale: "linear",
    unit: "year",
    source: {
      title: "Nintendo Co., Ltd. — Company History",
      url: "https://www.nintendo.co.jp/corporate/en/history/index.html",
    },
    explanation: "The N64 arrived in 1996 and put an analogue stick in players' hands, which is why 3D games feel the way they do today.",
  },
  {
    id: "games-event-nintendo-company-founded",
    category: "games",
    measure: "history",
    subtype: "event",
    prompt: "Long before Mario existed, what year was Nintendo founded as a company that sold hand-painted playing cards?",
    answer: 1889,
    min: 1700,
    max: 2000,
    scale: "linear",
    unit: "year",
    source: {
      title: "Britannica Money — Nintendo Company, Ltd.",
      url: "https://www.britannica.com/money/Nintendo-Company-Ltd",
    },
    explanation: "Nintendo was founded in Kyoto in 1889 to make hanafuda playing cards, nearly a century before it made a single video game.",
  },
  {
    id: "games-event-pac-man-release",
    category: "games",
    measure: "history",
    subtype: "event",
    prompt: "In what year did Pac-Man first gobble his way across Japanese arcades?",
    answer: 1980,
    min: 1950,
    max: 2010,
    scale: "linear",
    unit: "year",
    source: {
      title: "Wikipedia — Pac-Man",
      url: "https://en.wikipedia.org/wiki/Pac-Man",
    },
    explanation: "Pac-Man launched in Japan in May 1980 and reached North America that August, becoming a global pop-culture icon.",
  },
  {
    id: "games-event-playstation-original-launch",
    category: "games",
    measure: "history",
    subtype: "event",
    prompt: "In what year did Sony's original PlayStation first go on sale in Japan?",
    answer: 1994,
    min: 1970,
    max: 2020,
    scale: "linear",
    unit: "year",
    source: {
      title: "PlayStation.com — PlayStation History: 1994",
      url: "https://www.playstation.com/en-us/playstation-history/1994-ps-one/",
    },
    explanation: "The original PlayStation launched in Japan on December 3, 1994, and had sold 100,000 units by the end of its first day.",
  },
  {
    id: "games-event-pokemon-red-green-japan-release",
    category: "games",
    measure: "history",
    subtype: "event",
    prompt: "In what year did the very first Pokémon games, Red and Green, launch in Japan?",
    answer: 1996,
    min: 1970,
    max: 2020,
    scale: "linear",
    unit: "year",
    source: {
      title: "Bulbapedia — Pokémon Red and Green Versions",
      url: "https://bulbapedia.bulbagarden.net/wiki/Pok%C3%A9mon_Red_and_Green_Versions",
    },
    explanation: "Pocket Monsters Red and Green launched in Japan on February 27, 1996, starting a franchise that reached the West two years later.",
  },
  {
    id: "games-event-psp-japan-launch",
    category: "games",
    measure: "history",
    subtype: "event",
    prompt: "In what year did Sony's first handheld, the PlayStation Portable, launch in Japan?",
    answer: 2004,
    min: 1980,
    max: 2020,
    scale: "linear",
    unit: "year",
    source: {
      title: "PlayStation Wiki — PlayStation Portable",
      url: "https://playstation.fandom.com/wiki/PlayStation_Portable",
    },
    explanation: "The PSP launched in Japan in December 2004, arriving in North America the following March.",
  },
  {
    id: "games-event-scrabble-invented",
    category: "games",
    measure: "history",
    subtype: "event",
    prompt: "In what year did architect Alfred Butts invent the word game that became Scrabble?",
    answer: 1938,
    min: 1880,
    max: 1990,
    scale: "linear",
    unit: "year",
    source: {
      title: "Wikipedia — English-language Scrabble",
      url: "https://en.wikipedia.org/wiki/English-language_Scrabble",
    },
    explanation: "Butts invented the game in 1938, basing his letter values on a frequency count of letters in The New York Times.",
  },
  {
    id: "games-event-sega-genesis-north-america-launch",
    category: "games",
    measure: "history",
    subtype: "event",
    prompt: "In what year did the Sega Genesis launch in North America to take on Nintendo?",
    answer: 1989,
    min: 1950,
    max: 2020,
    scale: "linear",
    unit: "year",
    source: {
      title: "Wikipedia — History of the Nintendo Entertainment System",
      url: "https://en.wikipedia.org/wiki/History_of_the_Nintendo_Entertainment_System",
    },
    explanation: "Sega released its Mega Drive in Japan in 1988 and brought it to North America as the Genesis in 1989.",
  },
  {
    id: "games-event-space-invaders-release",
    category: "games",
    measure: "history",
    subtype: "event",
    prompt: "In what year did Space Invaders launch the golden age of arcade games, reportedly causing a coin shortage in Japan?",
    answer: 1978,
    min: 1950,
    max: 2010,
    scale: "linear",
    unit: "year",
    source: {
      title: "Wikipedia — History of the Nintendo Entertainment System",
      url: "https://en.wikipedia.org/wiki/History_of_the_Nintendo_Entertainment_System",
    },
    explanation: "Space Invaders was released by Taito in 1978 and became so popular that arcades reportedly ran short of 100-yen coins.",
  },
  {
    id: "games-event-steam-platform-launch",
    category: "games",
    measure: "history",
    subtype: "event",
    prompt: "In what year did Valve first launch Steam, now the dominant PC gaming storefront?",
    answer: 2003,
    min: 1970,
    max: 2020,
    scale: "linear",
    unit: "year",
    source: {
      title: "Wikipedia — Steam (service)",
      url: "https://en.wikipedia.org/wiki/Steam_(service)",
    },
    explanation: "Steam launched in September 2003 as an automatic patcher for Valve's own games before expanding into a full storefront.",
  },
  {
    id: "games-event-tetris-created",
    category: "games",
    measure: "history",
    subtype: "event",
    prompt: "In what year did Alexey Pajitnov create Tetris?",
    answer: 1984,
    min: 1960,
    max: 2005,
    scale: "linear",
    unit: "year",
    source: {
      title: "Tetris — About Tetris",
      url: "https://tetris.com/about",
    },
    explanation: "Pajitnov built it in 1984 while working at a Soviet computer centre, naming it from the Greek \"tetra\" and his favourite sport, tennis.",
  },
  {
    id: "games-event-uno-invented",
    category: "games",
    measure: "history",
    subtype: "event",
    prompt: "In what year did an Ohio barber invent UNO to settle a family argument over the rules of Crazy Eights?",
    answer: 1971,
    min: 1920,
    max: 2010,
    scale: "linear",
    unit: "year",
    source: {
      title: "The Strong National Museum of Play — America's Favorite Game and Success Story: Uno!",
      url: "https://www.museumofplay.org/blog/americas-favorite-game-and-success-story-uno/",
    },
    explanation: "Merle Robbins invented UNO in 1971 in Reading, Ohio, and sold the first copies out of his own barbershop.",
  },
  {
    id: "games-event-wii-launch",
    category: "games",
    measure: "history",
    subtype: "event",
    prompt: "In what year did the Nintendo Wii launch?",
    answer: 2006,
    min: 1990,
    max: 2020,
    scale: "linear",
    unit: "year",
    source: {
      title: "Nintendo Co., Ltd. — Company History",
      url: "https://www.nintendo.co.jp/corporate/en/history/index.html",
    },
    explanation: "The Wii landed in 2006 and sold on motion control rather than horsepower, pulling in people who had never owned a console.",
  },
  {
    id: "games-event-world-of-warcraft-release",
    category: "games",
    measure: "history",
    subtype: "event",
    prompt: "In what year did World of Warcraft first launch, kicking off two decades of continuous play in Azeroth?",
    answer: 2004,
    min: 1980,
    max: 2020,
    scale: "linear",
    unit: "year",
    source: {
      title: "Wowpedia — World of Warcraft",
      url: "https://wowpedia.fandom.com/wiki/World_of_Warcraft",
    },
    explanation: "World of Warcraft launched in North America on November 23, 2004, on the 10th anniversary of the Warcraft franchise.",
  },
  {
    id: "games-event-xbox-original-launch",
    category: "games",
    measure: "history",
    subtype: "event",
    prompt: "In what year did Microsoft's very first Xbox console launch in North America?",
    answer: 2001,
    min: 1970,
    max: 2020,
    scale: "linear",
    unit: "year",
    source: {
      title: "GameSpot — The Evolution Of Xbox Consoles",
      url: "https://www.gamespot.com/gallery/the-evolution-of-xbox-consoles/2900-1322/",
    },
    explanation: "The original Xbox launched in North America on November 15, 2001, Microsoft's first major foray into game consoles.",
  },
  {
    id: "games-length-fide-king-height",
    category: "games",
    measure: "size",
    subtype: "length",
    prompt: "FIDE's tournament regulations specify a recommended chess king height — how tall, in metres, should it be?",
    answer: 0.095,
    min: 0.02,
    max: 0.3,
    scale: "linear",
    unit: "metre",
    source: {
      title: "Chess.com — Chess Board Dimensions: Basics and Guidelines",
      url: "https://www.chess.com/article/view/chess-board-dimensions",
    },
    explanation: "FIDE recommends a king height of 9.5 centimetres, with every other piece's size scaled proportionally around it.",
  },
  {
    id: "games-length-ps5-height",
    category: "games",
    measure: "size",
    subtype: "length",
    prompt: "Standing upright, how tall in metres is a PlayStation 5 console?",
    answer: 0.39,
    min: 0.1,
    max: 1,
    scale: "linear",
    unit: "metre",
    source: {
      title: "Dimensions.com — PlayStation 5",
      url: "https://www.dimensions.com/element/playstation-5",
    },
    explanation: "The PS5 stands 390 millimetres tall in its upright orientation, making it noticeably taller than earlier PlayStations.",
  },
  {
    id: "games-mass-nintendo-switch-console",
    category: "games",
    measure: "size",
    subtype: "mass",
    prompt: "How much does a Nintendo Switch console weigh without its controllers?",
    answer: 0.3,
    min: 0.05,
    max: 1.5,
    scale: "linear",
    unit: "kilogram",
    source: {
      title: "Nintendo of America — Nintendo Switch technical specs",
      url: "https://www.nintendo.com/us/switch/tech-specs/",
    },
    explanation: "The tablet alone is about 0.66 lbs, roughly 0.3 kilograms, rising to about 0.4 kg once the Joy-Con are clipped on.",
  },
  {
    id: "games-mass-ps5-weight",
    category: "games",
    measure: "size",
    subtype: "mass",
    prompt: "How many kilograms does the original disc-drive PlayStation 5 weigh?",
    answer: 4.5,
    min: 1,
    max: 15,
    scale: "linear",
    unit: "kilogram",
    source: {
      title: "Video Games Chronicle — The rawest PS5 images yet show exactly how big the console is",
      url: "https://www.videogameschronicle.com/news/the-rawest-ps5-images-yet-show-exactly-how-big-the-console-is/",
    },
    explanation: "Sony's official specifications list the original PS5 at 4.5 kilograms, noticeably heavier than its Digital Edition.",
  },
  {
    id: "games-count-backgammon-points",
    category: "games",
    measure: "quantity",
    subtype: "count",
    prompt: "How many narrow triangular points make up a backgammon board?",
    answer: 24,
    min: 4,
    max: 60,
    scale: "linear",
    unit: "count",
    source: {
      title: "Wikipedia — Backgammon",
      url: "https://en.wikipedia.org/wiki/Backgammon",
    },
    explanation: "Each player's 15 checkers move around 24 points, grouped into four quadrants of six triangles each.",
  },
  {
    id: "games-count-catan-hex-tiles",
    category: "games",
    measure: "quantity",
    subtype: "count",
    prompt: "How many hexagonal terrain tiles make up the classic Settlers of Catan board?",
    answer: 19,
    min: 3,
    max: 50,
    scale: "linear",
    unit: "count",
    source: {
      title: "Britannica — Catan",
      url: "https://www.britannica.com/sports/Catan-board-game",
    },
    explanation: "Catan's island is built from 19 hexagonal terrain tiles, each producing a resource except for the single desert tile.",
  },
  {
    id: "games-count-chess-fifty-move-rule",
    category: "games",
    measure: "quantity",
    subtype: "count",
    prompt: "After how many quiet moves each can a chess player claim a draw?",
    answer: 50,
    min: 5,
    max: 200,
    scale: "log",
    unit: "count",
    source: {
      title: "FIDE Handbook — Laws of Chess",
      url: "https://handbook.fide.com/chapter/E012023",
    },
    explanation: "Fifty moves by each player with no capture and no pawn moved lets either side call the game drawn, which is what stops a hopeless endgame running forever.",
  },
  {
    id: "games-count-chessboard-squares",
    category: "games",
    measure: "quantity",
    subtype: "count",
    prompt: "How many squares are on a standard chessboard?",
    answer: 64,
    min: 16,
    max: 144,
    scale: "linear",
    unit: "count",
    source: {
      title: "FIDE Handbook - Laws of Chess",
      url: "https://handbook.fide.com/chapter/e012023",
    },
    explanation: "FIDE defines the chessboard as an 8 by 8 grid, giving 64 alternating light and dark squares.",
  },
  {
    id: "games-count-dnd-5e-core-classes",
    category: "games",
    measure: "quantity",
    subtype: "count",
    prompt: "The current core Dungeons & Dragons rulebook lets you build a character from how many character classes?",
    answer: 12,
    min: 2,
    max: 30,
    scale: "linear",
    unit: "count",
    source: {
      title: "Evanston Games — Dungeons & Dragons 5E Core Rulebooks",
      url: "https://www.evanstongames.com/products/dungeons-dragons-5e-core-rulebooks",
    },
    explanation: "The revised core rulebook offers 12 classes, alongside 48 subclasses and dozens of species and backgrounds.",
  },
  {
    id: "games-count-dnd-standard-dice-set",
    category: "games",
    measure: "quantity",
    subtype: "count",
    prompt: "A standard Dungeons & Dragons dice set, the polyhedral shapes used across most tabletop RPGs, contains how many individual dice?",
    answer: 7,
    min: 1,
    max: 20,
    scale: "linear",
    unit: "count",
    source: {
      title: "GM Dice — Dungeons & Dragons Dice",
      url: "https://www.gmdice.com/pages/dungeons-dragons-dice",
    },
    explanation: "The set has seven dice: a d4, d6, d8, d10, d12, d20, and a percentile d10, and became the standard for RPGs generally.",
  },
  {
    id: "games-count-game-boy-hardware-sales",
    category: "games",
    measure: "quantity",
    subtype: "count",
    prompt: "According to Nintendo's life-to-date figures, how many Game Boy systems were sold worldwide?",
    answer: 118690000,
    min: 10000000,
    max: 500000000,
    scale: "log",
    unit: "count",
    referenceYear: "2026",
    source: {
      title: "Nintendo Investor Relations - Dedicated Video Game Sales Units",
      url: "https://www.nintendo.co.jp/ir/en/finance/hard_soft/index.html",
    },
    explanation: "Nintendo reports 118.69 million worldwide hardware sales for the Game Boy family, including Game Boy Color.",
  },
  {
    id: "games-count-largest-videogame-memorabilia-collection",
    category: "games",
    measure: "quantity",
    subtype: "count",
    prompt: "How many items are in the world's largest videogame memorabilia collection?",
    answer: 17127,
    min: 500,
    max: 100000,
    scale: "log",
    unit: "count",
    referenceYear: "2016",
    source: {
      title: "Guinness World Records — Largest collection of videogame memorabilia",
      url: "https://www.guinnessworldrecords.com/world-records/largest-collection-of-videogame-memorabilia",
    },
    explanation: "Lisa Courtney of the UK was verified with 17,127 pieces of Pokémon memorabilia, a hoard she had been building since childhood.",
  },
  {
    id: "games-count-mario-kart-8-deluxe-sales",
    category: "games",
    measure: "quantity",
    subtype: "count",
    prompt: "How many copies of Mario Kart 8 Deluxe had sold by March 2026?",
    answer: 71080000,
    min: 1000000,
    max: 500000000,
    scale: "log",
    unit: "count",
    referenceYear: "2026",
    source: {
      title: "Nintendo Co., Ltd. — Top Selling Title Sales Units, Nintendo Switch",
      url: "https://www.nintendo.co.jp/ir/en/finance/software/switch.html",
    },
    explanation: "At 71.08 million it is the best-selling Switch game by a wide margin — roughly one copy for every two consoles Nintendo has sold.",
  },
  {
    id: "games-count-minecraft-pc-downloads-at-acquisition",
    category: "games",
    measure: "quantity",
    subtype: "count",
    prompt: "When Microsoft bought Mojang in 2014, how many times had Minecraft been downloaded on PC?",
    answer: 100000000,
    min: 1000000,
    max: 2000000000,
    scale: "log",
    unit: "count",
    referenceYear: "2014",
    source: {
      title: "Microsoft — Minecraft to join Microsoft",
      url: "https://news.microsoft.com/source/2014/09/15/minecraft-to-join-microsoft/",
    },
    explanation: "More than 100 million PC downloads in five years, and nearly 90 percent of paying players had signed in within the past year — which is what Microsoft was really buying.",
  },
  {
    id: "games-count-monopoly-title-deed-cards",
    category: "games",
    measure: "quantity",
    subtype: "count",
    prompt: "How many Title Deed cards come with the classic Monopoly game?",
    answer: 28,
    min: 5,
    max: 80,
    scale: "linear",
    unit: "count",
    source: {
      title: "Hasbro - Monopoly Classic Game instructions",
      url: "https://instructions.hasbro.com/en-nz/instruction/monopoly-classic-game",
    },
    explanation: "Hasbro lists 28 Title Deed cards in the classic set, covering streets, stations and utilities.",
  },
  {
    id: "games-count-national-pokedex-entries",
    category: "games",
    measure: "quantity",
    subtype: "count",
    prompt: "As of 2026, how many Pokémon are listed in the National Pokédex?",
    answer: 1025,
    min: 100,
    max: 3000,
    scale: "log",
    unit: "count",
    referenceYear: "2026",
    source: {
      title: "The Pokémon Company — Pokédex",
      url: "https://www.pokemon.com/us/pokedex",
    },
    explanation: "The official Pokédex now runs from 1 to 1,025, up from the 151 that started it all on the Game Boy.",
  },
  {
    id: "games-count-ps2-lifetime-sales",
    category: "games",
    measure: "quantity",
    subtype: "count",
    prompt: "Sony finally confirmed the figure in 2024 — how many PlayStation 2 consoles were sold across its entire lifetime?",
    answer: 160000000,
    min: 10000000,
    max: 500000000,
    scale: "log",
    unit: "count",
    source: {
      title: "List of best-selling game consoles — Wikipedia",
      url: "https://en.wikipedia.org/wiki/List_of_best-selling_game_consoles",
    },
    explanation: "Sony confirmed in November 2024 that the PS2 sold over 160 million units, making it the best-selling console ever.",
  },
  {
    id: "games-count-risk-territories",
    category: "games",
    measure: "quantity",
    subtype: "count",
    prompt: "How many territories are up for grabs across the six continents of a Risk board?",
    answer: 42,
    min: 10,
    max: 100,
    scale: "linear",
    unit: "count",
    source: {
      title: "US Games — Risk Board Game",
      url: "https://www.usgames.com/p/risk-board-game/",
    },
    explanation: "The classic Risk map is divided into 42 territories grouped into six continents, all up for conquest.",
  },
  {
    id: "games-count-scrabble-tiles",
    category: "games",
    measure: "quantity",
    subtype: "count",
    prompt: "How many letter tiles come in a standard Scrabble set?",
    answer: 100,
    min: 20,
    max: 400,
    scale: "log",
    unit: "count",
    source: {
      title: "Hasbro — Scrabble Board Game official instructions",
      url: "https://instructions.hasbro.com/en-us/instruction/scrabble-board-game",
    },
    explanation: "One hundred wooden tiles, including two blanks, split between players seven at a time.",
  },
  {
    id: "games-count-smash-ultimate-roster",
    category: "games",
    measure: "quantity",
    subtype: "count",
    prompt: "Super Smash Bros. Ultimate boasts the biggest roster in the series — how many playable fighters does it include in total?",
    answer: 89,
    min: 10,
    max: 200,
    scale: "linear",
    unit: "count",
    source: {
      title: "SmashWiki — Super Smash Bros. Ultimate",
      url: "https://www.ssbwiki.com/Super_Smash_Bros._Ultimate",
    },
    explanation: "Ultimate features 89 playable fighters, including every character who had ever appeared in a previous Smash game.",
  },
  {
    id: "games-count-standard-deck-with-jokers",
    category: "games",
    measure: "quantity",
    subtype: "count",
    prompt: "Including the jokers, how many cards come in a standard pack of playing cards sold today?",
    answer: 54,
    min: 10,
    max: 120,
    scale: "linear",
    unit: "count",
    source: {
      title: "Toynk — Xbox Playing Cards",
      url: "https://www.toynk.com/products/xbox-playing-cards-52-card-deck-2-jokers",
    },
    explanation: "A modern pack has 52 playing cards plus 2 jokers, for 54 cards in total, though the jokers sit outside the four suits.",
  },
  {
    id: "games-count-switch-hardware-sales",
    category: "games",
    measure: "quantity",
    subtype: "count",
    prompt: "How many Nintendo Switch consoles had been sold worldwide by March 2026?",
    answer: 155920000,
    min: 5000000,
    max: 1000000000,
    scale: "log",
    unit: "count",
    referenceYear: "2026",
    source: {
      title: "Nintendo Co., Ltd. — Dedicated Video Game Sales Units",
      url: "https://www.nintendo.co.jp/ir/en/finance/hard_soft/index.html",
    },
    explanation: "Nintendo reported 155.92 million Switch consoles sold life-to-date, putting it comfortably past the Wii and closing on the all-time leaders.",
  },
  {
    id: "games-count-tetris-piece-shapes",
    category: "games",
    measure: "quantity",
    subtype: "count",
    prompt: "How many different piece shapes are there in Tetris?",
    answer: 7,
    min: 3,
    max: 20,
    scale: "linear",
    unit: "count",
    source: {
      title: "Tetris — About Tetris",
      url: "https://tetris.com/about",
    },
    explanation: "Seven Tetriminos, each built from four squares — that is every shape four connected squares can make, which is the whole game in one sentence.",
  },
  {
    id: "games-count-trivial-pursuit-categories",
    category: "games",
    measure: "quantity",
    subtype: "count",
    prompt: "How many colour-coded categories does a player need a wedge from to win at Trivial Pursuit?",
    answer: 6,
    min: 2,
    max: 20,
    scale: "linear",
    unit: "count",
    source: {
      title: "Wikipedia — Trivial Pursuit",
      url: "https://en.wikipedia.org/wiki/Trivial_Pursuit",
    },
    explanation: "Players collect one wedge from each of six categories, from Geography to Sports & Leisure, to win the game.",
  },
  {
    id: "games-count-uno-cards",
    category: "games",
    measure: "quantity",
    subtype: "count",
    prompt: "How many cards are in a standard modern UNO deck?",
    answer: 112,
    min: 40,
    max: 200,
    scale: "linear",
    unit: "count",
    source: {
      title: "Mattel - UNO instruction sheet",
      url: "https://service.mattel.com/instruction_sheets/10020-SN70_G1_4XN_IS_Uno.pdf",
    },
    explanation: "Mattel's standard modern UNO instructions list a 112-card deck.",
  },
  {
    id: "games-money-activision-blizzard-acquisition",
    category: "games",
    measure: "quantity",
    subtype: "money",
    prompt: "How much did Microsoft agree to pay for Activision Blizzard in 2022?",
    answer: 68700000000,
    min: 1000000000,
    max: 500000000000,
    scale: "log",
    unit: "usd",
    referenceYear: "2022",
    source: {
      title: "Microsoft — Microsoft to acquire Activision Blizzard",
      url: "https://news.microsoft.com/source/2022/01/18/microsoft-to-acquire-activision-blizzard-to-bring-the-joy-and-community-of-gaming-to-everyone-across-every-device/",
    },
    explanation: "The all-cash deal valued Activision Blizzard at $68.7 billion, or $95 a share — the biggest purchase in gaming history and enough to make Microsoft the third-largest games company by revenue.",
  },
  {
    id: "games-money-black-lotus-auction-record",
    category: "games",
    measure: "quantity",
    subtype: "money",
    prompt: "In 2021, a single signed Magic: The Gathering Black Lotus card sold at public auction for how many US dollars?",
    answer: 511100,
    min: 10000,
    max: 2000000,
    scale: "log",
    unit: "usd",
    referenceYear: "2021",
    source: {
      title: "ComicBook.com — Magic: The Gathering Card Sells for Over Half a Million Dollars",
      url: "https://comicbook.com/gaming/news/magic-the-gathering-mtg-black-lotus-record-auction-sale-half-million/",
    },
    explanation: "The card, signed by illustrator Christopher Rush, sold on eBay for $511,100, tripling the previous public sale record.",
  },
  {
    id: "games-money-dota2-ti2021-prize-pool",
    category: "games",
    measure: "quantity",
    subtype: "money",
    prompt: "In 2021, Dota 2's tournament The International crowd-funded the largest prize pool in esports history — how many US dollars did it reach?",
    answer: 40018400,
    min: 1000000,
    max: 150000000,
    scale: "log",
    unit: "usd",
    referenceYear: "2021",
    source: {
      title: "Esports Earnings — The International: Dota 2 Championships",
      url: "https://www.esportsearnings.com/leagues/524-the-international/largest-tournaments",
    },
    explanation: "The International 2021's prize pool reached just over $40 million, crowd-funded through in-game item sales.",
  },
  {
    id: "games-money-gta-v-budget",
    category: "games",
    measure: "quantity",
    subtype: "money",
    prompt: "Grand Theft Auto V is widely reported as the most expensive video game ever made — what was its combined development and marketing budget, in US dollars?",
    answer: 265000000,
    min: 10000000,
    max: 1000000000,
    scale: "log",
    unit: "usd",
    referenceYear: "2013",
    source: {
      title: "Statista — GTA V is the Most Expensive Video Game Ever Produced",
      url: "https://www.statista.com/chart/amp/1466/most-expensive-video-games-of-all-time",
    },
    explanation: "Rockstar's budget was reported at $265 million, rivalling a big-budget Hollywood blockbuster, though never officially confirmed.",
  },
  {
    id: "games-money-mojang-acquisition",
    category: "games",
    measure: "quantity",
    subtype: "money",
    prompt: "How much did Microsoft pay for Mojang, the maker of Minecraft, in 2014?",
    answer: 2500000000,
    min: 50000000,
    max: 100000000000,
    scale: "log",
    unit: "usd",
    referenceYear: "2014",
    source: {
      title: "Microsoft — Minecraft to join Microsoft",
      url: "https://news.microsoft.com/source/2014/09/15/minecraft-to-join-microsoft/",
    },
    explanation: "Microsoft paid $2.5 billion for a Stockholm studio of a few dozen people whose one big game has since become the best-selling of all time.",
  },
  {
    id: "games-duration-longest-running-videogame-series",
    category: "games",
    measure: "physics",
    subtype: "duration",
    prompt: "How many years has the longest-running videogame series been going?",
    answer: 51,
    min: 10,
    max: 90,
    scale: "linear",
    unit: "duration-year",
    referenceYear: "2023",
    source: {
      title: "Guinness World Records — Longest-running videogame series",
      url: "https://www.guinnessworldrecords.com/world-records/longest-running-videogame-series",
    },
    explanation: "The Oregon Trail was recognised at 51 years and 145 days, running from a 1971 text game written for a classroom to a 2023 mobile release.",
  },
  {
    id: "games-duration-longest-videogame-marathon",
    category: "games",
    measure: "physics",
    subtype: "duration",
    prompt: "How long is the record for the longest videogame marathon?",
    answer: 144,
    min: 12,
    max: 400,
    scale: "log",
    unit: "hour",
    referenceYear: "2024",
    source: {
      title: "Guinness World Records — Longest videogame marathon",
      url: "https://www.guinnessworldrecords.com/world-records/longest-video-games-marathon",
    },
    explanation: "Szabolcs Csépe played Dance Dance Revolution for 144 hours straight — six full days, over 3,000 songs and 22,000 calories burned.",
  },
  {
    id: "games-duration-switch-battery-life",
    category: "games",
    measure: "physics",
    subtype: "duration",
    prompt: "At best, how many hours does a Nintendo Switch battery last?",
    answer: 9,
    min: 2,
    max: 30,
    scale: "linear",
    unit: "hour",
    source: {
      title: "Nintendo of America — Nintendo Switch technical specs",
      url: "https://www.nintendo.com/us/switch/tech-specs/",
    },
    explanation: "Nintendo quotes roughly 4.5 to 9 hours, so the best case is about nine — and a demanding game will halve that.",
  },
];
